import { useState, useEffect, useRef, useCallback } from "react";
import {
  getAllUsers, createUser, updateUser, searchUsers,
  getAllThreads, createThread, updateThread, deleteThread as dbDeleteThread, incrementThreadViews, searchThreads,
  getPostsByThread, createPost, updatePost,
  getProfileComments, addProfileComment,
  trackVisit as dbTrackVisit, getRecentVisitors,
  getBoardMods, addBoardMod, removeBoardMod,
  getBoardStyles, saveBoardStyle as dbSaveBoardStyle,
  uploadMedia, uploadFile, deleteMedia as dbDeleteMedia,
  ensureBoards, getRecentlyReplied,
  getReactions, upsertReaction, removeReaction,
  getUserReactionTotals, getUserReactionTotalsBatch, getThreadLikeTotals,
  getNotifications, createNotification, markNotificationRead, markAllNotificationsRead,
  getFriendships, sendFriendRequest, acceptFriendRequest, declineFriendRequest, removeFriend,
  getProfilePosts, createProfilePost, deleteProfilePost,
  getProfileAlbums, createAlbum, deleteAlbum, addAlbumItem, deleteAlbumItem,
} from './db';

// ─── BOARDS ───────────────────────────────────────────────────────────────────
const BOARDS = [
  { id:"general",       name:"General",        desc:"Talk about anything"               },
  { id:"music",         name:"Music",          desc:"Share what you're into"            },
  { id:"gaming",        name:"Gaming",         desc:"Games and stuff"                   },
  { id:"creative",      name:"Creative",       desc:"Art, writing, whatever"            },
  { id:"cinema",        name:"Cinema & TV",     desc:"Movies, TV, film talk"             },
  { id:"books",         name:"Books & Lit",    desc:"Books, reading, and literature"    },
  { id:"food",          name:"Food",           desc:"Food, recipes, and restaurants"    },
  { id:"currentevents", name:"Current Events", desc:"News and what's going on"          },
  { id:"events",        name:"Events",         desc:"Community events and meetups"      },
  { id:"confessions",   name:"Confessions",    desc:"Post anonymously. No names.", anonOnly:true },
  { id:"offtopic",      name:"Off Topic",      desc:"Random junk"                       },
];

const DEFAULT_BOARD_STYLE = {
  bg:"#ffffff", headerBg:"#336699", headerText:"#ffffff",
  textColor:"#000000", linkColor:"#0000cc", borderColor:"#cccccc",
  tableRowBg:"#f9f9f9", tableRowAlt:"#eef2f7",
  font:"Verdana, Arial, sans-serif", banner:"", rules:"",
};

// ─── SEED DATA ────────────────────────────────────────────────────────────────
const SEED_USERS = [
  { id:1, username:"xX_DarkStar_Xx", password:"1234",
    profileBg:"#000000", profileFont:"'Comic Sans MS', cursive",
    profileTextColor:"#ff00ff", profileLinkColor:"#00ffff",
    profileHeaderBg:"#220022", profileHeaderText:"#ff00ff",
    profileBorderColor:"#9900cc", profileBorderStyle:"dashed", profileBorderWidth:"2px",
    profileTableBg:"rgba(20,0,30,0.8)",
    bio:"just a girl 💜 music saves lives. add me if ur not lame\nim in ur walls rn\n\n[you are visitor #001337]",
    song:"MCR - Welcome to the Black Parade", mood:"headphones in, world out",
    interests:"music, photography, writing, cats", status:"away",
    headline:"music is my boyfriend", aboutTitle:"About Me",
    whoIWantToMeet:"people who get it",
    location:"the void", favoriteMovies:"Donnie Darko, Edward Scissorhands",
    favoriteMusic:"MCR, The Used, Brand New, Dashboard", favoriteTVShow:"Buffy",
    favoriteQuote:"\"we accept the love we think we deserve\"",
    bgMusicUrl:"",
    joinDate:"2024-01-15", posts:147, views:1337,
    blinkies:["~*~emo kid~*~","free spirit","i luv music"],
    topFriends:[2,3], photoKey:null, recentVisitors:[],
    comments:[{id:1,authorName:"glitter_princess",content:"omg ur profile is so cute bestie!! 💜",date:"2024-03-01"}],
  },
  { id:2, username:"sk8rboy_zero", password:"1234",
    profileBg:"#111111", profileFont:"'Courier New', monospace",
    profileTextColor:"#00ff00", profileLinkColor:"#00cc00",
    profileHeaderBg:"#001100", profileHeaderText:"#00ff00",
    profileBorderColor:"#00aa00", profileBorderStyle:"solid", profileBorderWidth:"1px",
    profileTableBg:"rgba(0,20,0,0.9)",
    bio:"sk8r | gamer | vibe checker\nAIM: sk8rzero99 --- add me\n\nlevel 47 rogue",
    song:"Linkin Park - In The End", mood:"just chillin",
    interests:"skating, WoW, metal, energy drinks", status:"online",
    headline:"sk8 or die", aboutTitle:"who is sk8rboy_zero",
    whoIWantToMeet:"anyone who isnt a poser",
    location:"the skatepark", favoriteMovies:"Jackass, Lords of Dogtown",
    favoriteMusic:"LP, Slipknot, System of a Down", favoriteTVShow:"Jackass",
    favoriteQuote:"\"in the end it doesn't even matter\"",
    bgMusicUrl:"",
    joinDate:"2024-02-01", posts:63, views:420,
    blinkies:["sk8r4life","gamer","AIM me"],
    topFriends:[1], photoKey:null, recentVisitors:[], comments:[],
  },
  { id:3, username:"glitter_princess", password:"1234",
    profileBg:"#220033", profileFont:"'Georgia', serif",
    profileTextColor:"#ffaaff", profileLinkColor:"#ff55ff",
    profileHeaderBg:"#440066", profileHeaderText:"#ffffff",
    profileBorderColor:"#ff00cc", profileBorderStyle:"double", profileBorderWidth:"3px",
    profileTableBg:"rgba(40,0,60,0.85)",
    bio:"✨✨✨ SPARKLE QUEEN ✨✨✨\nlife is too short for bad vibes and boring colors\n\n*~*~* glitter makes everything better *~*~*",
    song:"Hilary Duff - Come Clean", mood:"feeling cute might delete later",
    interests:"fashion, makeup, dancing, glitter (obviously)", status:"online",
    headline:"living in a glitter world", aboutTitle:"All About ME!",
    whoIWantToMeet:"fun ppl only no drama",
    location:"the mall", favoriteMovies:"Mean Girls, Legally Blonde, Clueless",
    favoriteMusic:"Hilary Duff, Ashlee Simpson, Kelly Clarkson", favoriteTVShow:"The OC",
    favoriteQuote:"\"whatever! i'm getting cheese fries\"",
    bgMusicUrl:"",
    joinDate:"2024-01-20", posts:312, views:8008,
    blinkies:["*~girly girl~*","sparkle queen","100% princess"],
    topFriends:[1,2], photoKey:null, recentVisitors:[],
    comments:[
      {id:1,authorName:"xX_DarkStar_Xx",content:"bestie!! ur layout is everything 💜",date:"2024-03-02"},
      {id:2,authorName:"sk8rboy_zero",content:"hey",date:"2024-03-03"}
    ],
  },
];

const SEED_THREADS = [
  { id:1, boardId:"general", pinned:true, isLocked:false,
    title:"READ FIRST: Welcome + Rules",
    authorId:1, authorName:"xX_DarkStar_Xx", isAnon:false, media:null,
    content:"welcome to southharbor.net!!\n\nrules:\n1. be nice or gtfo\n2. no drama (save it for ur diary)\n3. pg-13\n4. have fun\n\npost intros below",
    replies:[
      {id:1,authorId:3,authorName:"glitter_princess",isAnon:false,media:null,content:"finally a cool forum!! hi everyone 💕",quotedPost:null,deleted:false,editedAt:null,createdAt:"2024-03-01T10:05:00Z"},
      {id:2,authorId:2,authorName:"sk8rboy_zero",isAnon:false,media:null,content:"sup. mostly here for gaming board",quotedPost:null,deleted:false,editedAt:null,createdAt:"2024-03-01T11:00:00Z"},
    ], createdAt:"2024-03-01T10:00:00Z", views:892 },
  { id:2, boardId:"music", isLocked:false,
    title:"what song is stuck in ur head",
    authorId:3, authorName:"glitter_princess", isAnon:false, media:null,
    content:"Come Clean by Hilary Duff has been in my head for 3 days straight and im going insane lol. what about you guys",
    replies:[
      {id:1,authorId:2,authorName:"sk8rboy_zero",isAnon:false,media:null,content:"In The End - LP. always.",quotedPost:null,deleted:false,editedAt:null,createdAt:"2024-03-02T14:00:00Z"},
      {id:2,authorId:1,authorName:"xX_DarkStar_Xx",isAnon:false,media:null,content:"Helena by MCR for like a week straight. send help",quotedPost:null,deleted:false,editedAt:null,createdAt:"2024-03-02T15:30:00Z"},
    ], createdAt:"2024-03-02T13:00:00Z", views:145 },
  { id:3, boardId:"confessions", isLocked:false,
    title:"i think im falling for my best friends bf",
    authorId:null, authorName:"Anonymous", isAnon:true, media:null,
    content:"this is so messed up and i feel terrible. we've been hanging out more lately bc she's been busy with work and idk it just happened. has anyone been through this",
    replies:[
      {id:1,authorId:null,authorName:"Anonymous",isAnon:true,media:null,content:"same thing happened to me last year. distance urself before it gets worse trust me",quotedPost:null,deleted:false,editedAt:null,createdAt:"2024-03-03T20:00:00Z"},
    ], createdAt:"2024-03-03T19:00:00Z", views:678 },
  { id:4, boardId:"gaming", isLocked:false,
    title:"anyone still on WoW Classic",
    authorId:2, authorName:"sk8rboy_zero", isAnon:false, media:null,
    content:"just rolled undead rogue on Faerlina, classic wow still hits different. anyone want to group up? post ur server",
    replies:[], createdAt:"2024-03-04T16:00:00Z", views:89 },
  { id:5, boardId:"creative", isLocked:false,
    title:"post ur poetry here",
    authorId:1, authorName:"xX_DarkStar_Xx", isAnon:false, media:null,
    content:"ill start. wrote this at 2am:\n\nthe world spins too fast\nand im standing still\nwaiting for someone\nto feel what i feel\n\npost urs",
    replies:[], createdAt:"2024-03-05T02:00:00Z", views:234 },
];

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const fmt = (iso) => new Date(iso).toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"numeric",minute:"2-digit"});
const ago = (iso) => {
  const m=Math.floor((Date.now()-new Date(iso))/60000);
  if(m<1)return"just now";if(m<60)return`${m}m ago`;
  const h=Math.floor(m/60);if(h<24)return`${h}h ago`;
  const d=Math.floor(h/24);if(d<7)return`${d}d ago`;return fmt(iso);
};
const fmtDur=(s)=>`${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;

// ─── HARBOR SCORE ─────────────────────────────────────────────────────────────
// Weighted reputation score: likes received (+3), dislikes (-1),
// threads created (+2), posts/replies (+1), profile views (+0.5).
function calcHarborScore(u, likes, dislikes, threadCount){
  return Math.max(0, Math.round(
    likes * 3 +
    dislikes * -1 +
    threadCount * 2 +
    (u.posts || 0) * 1 +
    Math.floor((u.views || 0) * 0.5)
  ));
}
const HARBOR_RANKS=[
  {min:1000, label:"Legend",      color:"#996600", bg:"#fff8dc", border:"#cc9900"},
  {min:400,  label:"Elder",       color:"#6600bb", bg:"#f3eaff", border:"#9933cc"},
  {min:150,  label:"Veteran",     color:"#005588", bg:"#dff0ff", border:"#3388bb"},
  {min:50,   label:"Contributor", color:"#226622", bg:"#edfaed", border:"#559955"},
  {min:10,   label:"Regular",     color:"#444444", bg:"#f0f0f0", border:"#aaaaaa"},
  {min:0,    label:"Newcomer",    color:"#888888", bg:"#f8f8f8", border:"#cccccc"},
];
const getHarborRank=(score)=>HARBOR_RANKS.find(r=>score>=r.min)||HARBOR_RANKS[HARBOR_RANKS.length-1];

// Parse [quote=name]...[/quote] blocks in post content
function parseQuote(content) {
  const parts=[];let rest=content||"";
  const re=/\[quote=([^\]]*)\]([\s\S]*?)\[\/quote\]/g;
  let last=0,m;
  while((m=re.exec(content))!==null){
    if(m.index>last)parts.push({type:"text",text:content.slice(last,m.index)});
    parts.push({type:"quote",author:m[1],text:m[2]});
    last=m.index+m[0].length;
  }
  if(last<content.length)parts.push({type:"text",text:content.slice(last)});
  return parts.length?parts:[{type:"text",text:content}];
}

// Extract unique user IDs mentioned via @username in content (excluding the author).
function extractMentions(content, users, authorId){
  const matches=content.match(/@(\w[\w\-.]*)/g)||[];
  const ids=new Set();
  for(const m of matches){
    const uname=m.slice(1);
    const u=users.find(x=>x.username.toLowerCase()===uname.toLowerCase());
    if(u&&u.id!==authorId) ids.add(u.id);
  }
  return [...ids];
}

// Split a plain text string into text/url/@mention segments for rendering.
// Pass onMentionClick(username) to make @mentions clickable.
const INLINE_RE=/https?:\/\/[^\s<>"]+|@(\w[\w\-.]*)/g;
function linkify(text,key,onMentionClick){
  const nodes=[];let last=0,m,i=0;
  INLINE_RE.lastIndex=0;
  while((m=INLINE_RE.exec(text))!==null){
    if(m.index>last)nodes.push(text.slice(last,m.index));
    if(m[1]!==undefined){
      // @mention
      const uname=m[1];
      nodes.push(<a key={`${key}-${i++}`} style={{color:"#336699",cursor:"pointer",fontWeight:"bold",textDecoration:"none"}} onClick={()=>onMentionClick&&onMentionClick(uname)}>@{uname}</a>);
    } else {
      nodes.push(<a key={`${key}-${i++}`} href={m[0]} target="_blank" rel="noopener noreferrer" style={{wordBreak:"break-all"}}>{m[0]}</a>);
    }
    last=m.index+m[0].length;
  }
  if(last<text.length)nodes.push(text.slice(last));
  return nodes.length?nodes:text;
}

async function compressImage(file,maxPx=600,quality=0.80){
  return new Promise((res,rej)=>{
    const r=new FileReader();r.onerror=rej;
    r.onload=(e)=>{
      const img=new Image();img.onerror=rej;
      img.onload=()=>{
        let w=img.width,h=img.height;
        if(w>maxPx||h>maxPx){if(w>h){h=Math.round(h*maxPx/w);w=maxPx;}else{w=Math.round(w*maxPx/h);h=maxPx;}}
        const c=document.createElement("canvas");c.width=w;c.height=h;
        c.getContext("2d").drawImage(img,0,0,w,h);res(c.toDataURL("image/jpeg",quality));
      };img.src=e.target.result;
    };r.readAsDataURL(file);
  });
}
async function readAsDataURL(file){
  return new Promise((res,rej)=>{const r=new FileReader();r.onerror=rej;r.onload=e=>res(e.target.result);r.readAsDataURL(file);});
}

// ─── DB ABSTRACTION LAYER ─────────────────────────────────────────────────────
// Now powered by Supabase via ./db.js

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS=`
  @import url('https://fonts.googleapis.com/css2?family=Tahoma&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{background:#c0c0c0;font-family:Verdana,Arial,sans-serif;font-size:12px;color:#000;}
  a{color:#0000cc;text-decoration:underline;cursor:pointer;}a:visited{color:#551a8b;}a:hover{color:#cc0000;}
  input[type=text],input[type=password],textarea,select{font-family:Verdana,Arial,sans-serif;font-size:12px;border:1px inset #999;padding:2px 4px;background:#fff;color:#000;}
  textarea{resize:vertical;}
  input[type=submit],button.btn{font-family:Verdana,Arial,sans-serif;font-size:12px;background:#d4d0c8;border:2px outset #fff;padding:2px 8px;cursor:pointer;color:#000;}
  input[type=submit]:hover,button.btn:hover{background:#bbb;}
  input[type=submit]:active,button.btn:active{border-style:inset;}
  input:disabled,input[type=submit]:disabled,button.btn:disabled{opacity:.5;cursor:not-allowed;}
  .site-wrap{width:780px;margin:0 auto;background:#fff;border:1px solid #666;}
  .site-header{background:#336699;padding:6px 10px;display:flex;align-items:center;justify-content:space-between;}
  .site-title{color:#fff;font-size:18px;font-weight:bold;cursor:pointer;}
  .site-title:hover{color:#ffff99;text-decoration:none;}
  .site-nav{background:#1a4a7a;padding:3px 10px;display:flex;gap:0;align-items:center;flex-wrap:wrap;}
  .site-nav a{color:#fff;font-size:11px;padding:2px 8px;text-decoration:none;border-right:1px solid #4477aa;cursor:pointer;}
  .site-nav a:hover{background:#2255aa;color:#ffff99;}
  .admin-link{color:#ffdd44 !important;font-weight:bold;}
  .admin-link:hover{background:#443300 !important;}
  .breadcrumb{background:#eef2f7;padding:4px 10px;font-size:11px;border-bottom:1px solid #ccc;color:#666;}
  .breadcrumb a{color:#336699;}
  .content{padding:10px;}
  .board-table{width:100%;border-collapse:collapse;margin-bottom:10px;}
  .board-table th{background:#336699;color:#fff;padding:4px 8px;text-align:left;font-size:11px;}
  .board-table td{padding:5px 8px;border-bottom:1px solid #ddd;vertical-align:top;}
  .board-table tr:hover td{background:#f0f5ff;}
  .board-name-link{font-weight:bold;font-size:13px;color:#336699;text-decoration:none;}
  .board-name-link:hover{text-decoration:underline;color:#cc0000;}
  .board-desc{color:#666;font-size:11px;}
  .thread-title-link{color:#000099;text-decoration:none;font-weight:bold;}
  .thread-title-link:hover{text-decoration:underline;color:#cc0000;}
  .pinned-tag{background:#ffcc00;color:#000;font-size:10px;padding:1px 4px;border:1px solid #cc9900;margin-right:3px;}
  .locked-tag{background:#cc3300;color:#fff;font-size:10px;padding:1px 4px;border:1px solid #991100;margin-right:3px;}
  .anon-tag{background:#ccc;color:#333;font-size:10px;padding:1px 4px;border:1px solid #999;margin-right:3px;}
  .media-tag{background:#e8f0e8;color:#336633;font-size:10px;padding:1px 4px;border:1px solid #99aa99;margin-right:3px;}
  .mod-tag{background:#cc3300;color:#fff;font-size:9px;padding:1px 4px;margin-top:2px;display:inline-block;font-weight:bold;}
  .admin-tag{background:#336699;color:#fff;font-size:9px;padding:1px 4px;margin-top:2px;display:inline-block;font-weight:bold;}
  .op-tag{background:#336699;color:#fff;font-size:9px;padding:1px 4px;margin-top:3px;display:inline-block;}
  .post-table{width:100%;border-collapse:collapse;margin-bottom:4px;}
  .post-user-cell{width:130px;background:#eef2f7;border:1px solid #ccc;padding:8px;vertical-align:top;text-align:center;border-right:2px solid #ccc;}
  .post-content-cell{border:1px solid #ccc;padding:8px;vertical-align:top;background:#fff;}
  .post-username{font-weight:bold;font-size:12px;color:#336699;}
  .post-username:hover{text-decoration:underline;color:#cc0000;}
  .post-text{font-size:12px;line-height:1.6;white-space:pre-wrap;word-break:break-word;}
  .post-date{font-size:10px;color:#999;margin-bottom:5px;}
  .post-actions{font-size:10px;color:#999;margin-top:5px;display:flex;gap:8px;}
  .post-actions a{color:#666;font-size:10px;}
  .quote-block{border-left:3px solid #999;background:#f5f5f5;padding:4px 8px;margin-bottom:6px;font-size:11px;color:#555;}
  .quote-block .quote-author{font-weight:bold;color:#336699;margin-bottom:2px;font-size:10px;}
  .quote-block .quote-text{white-space:pre-wrap;}
  .deleted-post{color:#999;font-style:italic;font-size:11px;}
  .edited-note{color:#aaa;font-size:10px;font-style:italic;margin-top:3px;}
  .locked-notice{background:#fff3f0;border:1px solid #cc3300;padding:8px;margin-top:8px;font-size:12px;color:#cc3300;}
  .inline-edit textarea{width:100%;margin-bottom:4px;}
  .reply-box{border:1px solid #ccc;padding:10px;background:#f9f9f9;margin-top:10px;}
  .reply-box h3{font-size:12px;color:#336699;margin-bottom:8px;border-bottom:1px solid #ccc;padding-bottom:4px;}
  .quote-preview{background:#f5f5f5;border:1px solid #ccc;border-left:3px solid #336699;padding:6px 8px;margin-bottom:8px;font-size:11px;}
  .quote-preview .qp-head{font-size:10px;color:#336699;font-weight:bold;margin-bottom:2px;display:flex;justify-content:space-between;}
  .search-bar{display:flex;gap:4px;align-items:center;}
  .search-bar input[type=text]{font-size:11px;padding:2px 5px;width:140px;border:1px inset #999;background:#fff;}
  .search-bar input[type=submit]{font-size:10px;padding:2px 6px;}
  .section-header{background:#336699;color:#fff;padding:4px 8px;font-size:11px;font-weight:bold;}
  .info-box{border:1px solid #ccc;padding:8px;margin-bottom:10px;font-size:12px;line-height:1.7;background:#fffef0;}
  .error-box{border:1px solid #cc0000;padding:6px 10px;background:#fff0f0;color:#cc0000;font-size:12px;margin-bottom:8px;}
  .form-row{margin-bottom:6px;}
  .form-label{display:block;font-size:11px;color:#666;margin-bottom:2px;font-weight:bold;}
  .status-online{color:#009900;font-size:10px;}.status-away{color:#cc6600;font-size:10px;}.status-offline{color:#999;font-size:10px;}
  .blinkie{display:inline-block;border:1px solid #999;background:#ffffcc;padding:1px 5px;font-size:10px;margin:1px;font-family:'Comic Sans MS',cursive;}
  .site-footer{background:#336699;color:#ccddee;font-size:10px;padding:6px 10px;text-align:center;border-top:2px solid #1a4a7a;}
  .logged-in-bar{background:#fffef0;border-bottom:1px solid #cccc99;padding:3px 10px;font-size:11px;color:#666;}
  .avatar-box{border:1px solid #999;overflow:hidden;margin:0 auto 5px;background:#eee;display:flex;align-items:center;justify-content:center;font-size:28px;color:#999;font-family:Verdana;font-weight:bold;}
  .avatar-box img{width:100%;height:100%;object-fit:cover;}
  audio{width:100%;margin-top:4px;}
  .media-drop{border:2px dashed #aaa;padding:10px;text-align:center;cursor:pointer;background:#f9f9f9;font-size:11px;color:#666;}
  .media-drop:hover{border-color:#336699;background:#f0f5ff;}
  .rec-btn{width:28px;height:28px;border-radius:50%;border:2px solid #cc0000;background:#fff;color:#cc0000;font-size:12px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;}
  .rec-btn.on{background:#cc0000;color:#fff;}
  .toast{position:fixed;top:10px;right:10px;background:#fffef0;border:1px solid #cc9900;padding:8px 14px;font-size:12px;color:#663300;z-index:9999;box-shadow:2px 2px 4px rgba(0,0,0,.3);}
  .toast.err{background:#fff0f0;border-color:#cc0000;color:#cc0000;}
  .num{color:#336699;font-weight:bold;}
  hr{border:none;border-top:1px solid #ccc;margin:8px 0;}
  .visitor-dot{display:inline-block;width:6px;height:6px;border-radius:50%;background:#009900;margin-right:3px;vertical-align:middle;}
  @keyframes recblink{0%,49%{opacity:1;}50%,100%{opacity:.3;}}
`;

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function SouthHarborNet() {
  const [view,        setView]        = useState("home");
  const [vp,          setVp]          = useState({});
  const [users,       setUsers]       = useState([]);
  const [threads,     setThreads]     = useState([]);
  const [boardMods,   setBoardMods]   = useState({});
  const [boardStyles, setBoardStyles] = useState({});
  // Restore session immediately from localStorage (before network loads complete)
  const [me,          setMe]          = useState(()=>{
    try{
      const saved=localStorage.getItem('sh_session');
      if(saved){ const u=JSON.parse(saved); if(u&&u.id) return u; }
    }catch(e){}
    return null;
  });
  const [toast,       setToast]       = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [searchQ,     setSearchQ]     = useState("");
  const [friendships, setFriendships] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const isAdmin = me?.id === 1;

  // Keep a ref to the current user so the beforeunload handler can read it
  // without a stale closure.
  const meRef = useRef(null);
  useEffect(()=>{ meRef.current = me; },[me]);

  useEffect(()=>{ loadAll(); },[]);
  useEffect(()=>{
    if(view==="thread"&&vp.threadId){
      loadThreadPosts(vp.threadId);
      incrementThreadViews(vp.threadId).catch(()=>{});
      setThreads(prev=>prev.map(t=>t.id===vp.threadId?{...t,views:(t.views||0)+1}:t));
    }
  },[view,vp.threadId]);

  // Best-effort: mark user offline when the tab is closed/refreshed.
  useEffect(()=>{
    const handleUnload = () => {
      const u = meRef.current;
      if(u) updateUser(u.id, {status:"offline"});
    };
    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  },[]);

  async function loadThreadPosts(threadId){
    try{
      const posts = await getPostsByThread(threadId);
      const mapped = posts.map(p=>({
        ...p,
        authorId: p.author_id,
        authorName: p.author_name,
        isAnon: p.is_anon,
        createdAt: p.created_at,
        editedAt: p.edited_at,
        media: p.media_url?{type:p.media_type,key:p.media_url}:null,
      }));
      setThreads(prev=>prev.map(t=>t.id===threadId?{...t,replies:mapped}:t));
    }catch(e){ console.error("loadThreadPosts error:",e); }
  }

  async function loadAll(){
    try{
      // Ensure all boards are registered in Supabase (fixes FK constraint issues
      // when new boards are added to the BOARDS array but not the DB).
      await ensureBoards(BOARDS);
      const [us, ts, bm, bs] = await Promise.all([
        getAllUsers(),
        getAllThreads(),
        getBoardMods(),
        getBoardStyles(),
      ]);
      if(us) {
        const mappedUsers = us.map(mapUser);
        setUsers(mappedUsers);
        // Restore session from localStorage
        const savedId = localStorage.getItem('sh_user_id');
        if(savedId){
          const savedUser = mappedUsers.find(u=>String(u.id)===savedId);
          if(savedUser){
            const onlineU = {...savedUser, status:"online"};
            updateUser(savedUser.id, {status:"online"});
            try{ localStorage.setItem('sh_session', JSON.stringify(onlineU)); }catch(e){}
            setMe(onlineU);
          }
        }
      }
      if(ts) {
        // Map DB shape to app shape
        const mapped = ts.map(t => ({
          ...t,
          boardId: t.board_id,
          authorId: t.author_id,
          authorName: t.author_name,
          isAnon: t.is_anon,
          isPinned: t.is_pinned,
          isLocked: t.is_locked,
          createdAt: t.created_at,
          media: t.media_url ? { type: t.media_type, key: t.media_url } : null,
          replies: [],
        }));
        setThreads(mapped);
      }
      if(bm) setBoardMods(bm);
      if(bs) setBoardStyles(bs);
    }catch(e){ console.error("loadAll error:", e); }
    setLoading(false);
  }

  // No-op saveCore — Supabase handles persistence per-operation
  const saveCore = useCallback(async()=>{},[]);

  const saveMedia = async(key, data) => uploadMedia(data, key);
  const loadMedia = async(key) => key || null;
  const delMedia  = async(path) => path && dbDeleteMedia(path);

  function msg(text,err=false){ setToast({text,err}); setTimeout(()=>setToast(null),3200); }
  function nav(v,p={}){ setView(v); setVp(p); window.scrollTo(0,0); }

  const getBoardStyle = (bid) => ({...DEFAULT_BOARD_STYLE,...(boardStyles[bid]||{})});
  const isMod = (bid,uid) => !!(boardMods[bid]||[]).includes(uid);
  const getBoardModUsers = (bid) => (boardMods[bid]||[]).map(id=>users.find(u=>u.id===id)).filter(Boolean);

  // ── AUTH ──
  async function register(username, password){
    if(users.find(u=>u.username.toLowerCase()===username.toLowerCase()))return msg("Username already taken.",true);
    try{
      const newUser = await createUser({
        username, password,
        join_date: new Date().toISOString().split('T')[0],
        status: "online",
      });
      const u = mapUser(newUser);
      setUsers(prev=>[...prev, u]);
      localStorage.setItem('sh_user_id', String(u.id));
      try{ localStorage.setItem('sh_session', JSON.stringify(u)); }catch(e){}
      setMe(u);
      msg(`Welcome to SouthHarbor.net, ${username}!`);
      nav("boards");
    }catch(e){ msg("Registration failed: "+e.message, true); }
  }

  async function login(username, password){
    const u = users.find(u2=>u2.username===username && u2.password===password);
    if(!u) return msg("Incorrect username or password.", true);
    const onlineU = {...u, status:"online"};
    updateUser(u.id, {status:"online"});
    setUsers(prev=>prev.map(x=>x.id===u.id ? onlineU : x));
    localStorage.setItem('sh_user_id', String(u.id));
    try{ localStorage.setItem('sh_session', JSON.stringify(onlineU)); }catch(e){}
    setMe(onlineU); msg(`Welcome back, ${u.username}.`); nav("boards");
  }

  function logout(){
    if(me){ updateUser(me.id,{status:"offline"}); setUsers(prev=>prev.map(u=>u.id===me.id?{...u,status:"offline"}:u)); }
    localStorage.removeItem('sh_user_id');
    localStorage.removeItem('sh_session');
    setMe(null); nav("home");
  }

  // Map DB snake_case to app camelCase
  function mapUser(u){
    return {
      ...u,
      aboutTitle:    u.about_title    || u.aboutTitle    || "About Me",
      whoIWantToMeet:u.who_i_want     || u.whoIWantToMeet|| "",
      favoriteMovies:u.fav_movies     || u.favoriteMovies|| "",
      favoriteMusic: u.fav_music      || u.favoriteMusic || "",
      favoriteTVShow:u.fav_tv         || u.favoriteTVShow|| "",
      favoriteQuote: u.fav_quote      || u.favoriteQuote || "",
      bgMusicUrl:    u.bg_music_url   || u.bgMusicUrl    || "",
      joinDate:      u.join_date      || u.joinDate      || "",
      status:        u.status         || "offline",
      profileBg:          u.profile_bg           || u.profileBg           || "#ffffff",
      profileFont:        u.profile_font         || u.profileFont         || "Verdana, Arial, sans-serif",
      profileTextColor:   u.profile_text_color   || u.profileTextColor   || "#000000",
      profileLinkColor:   u.profile_link_color   || u.profileLinkColor   || "#0000cc",
      profileHeaderBg:    u.profile_header_bg    || u.profileHeaderBg    || "#336699",
      profileHeaderText:  u.profile_header_text  || u.profileHeaderText  || "#ffffff",
      profileBorderColor: u.profile_border_color || u.profileBorderColor || "#336699",
      profileBorderStyle: u.profile_border_style || u.profileBorderStyle || "solid",
      profileBorderWidth: u.profile_border_width || u.profileBorderWidth || "1px",
      profileTableBg:     u.profile_table_bg     || u.profileTableBg     || "#f0f5ff",
      profileBgImage:     u.profile_bg_image     || u.profileBgImage     || null,
      profileBannerImage: u.profile_banner_image || u.profileBannerImage || null,
      profileFloats:      Array.isArray(u.profile_floats) ? u.profile_floats : [],
      photoKey:    u.photo_url || u.photoKey || null,
      posts:       u.post_count|| u.posts    || 0,
      blinkies:    Array.isArray(u.blinkies) ? u.blinkies : [],
      topFriends:  Array.isArray(u.top_friends) ? u.top_friends : (u.topFriends||[]),
      recentVisitors: u.recentVisitors || [],
      comments:    u.comments || [],
      audioTracks: Array.isArray(u.audio_tracks) ? u.audio_tracks : [],
    };
  }

  // ── PROFILE ──
  async function updateProfile(updates, newPhotoData){
    let photoUrl = me.photoKey;
    if(newPhotoData){
      if(me.photoKey) await dbDeleteMedia(me.photoKey);
      const path = `photos/${me.id}_${Date.now()}.jpg`;
      photoUrl = await uploadMedia(newPhotoData, path);
    } else if(updates.removePhoto){
      if(me.photoKey) await dbDeleteMedia(me.photoKey);
      photoUrl = null;
    }
    const dbUpdates = {
      bio:updates.bio, mood:updates.mood, song:updates.song,
      interests:updates.interests, status:updates.status,
      headline:updates.headline, about_title:updates.aboutTitle,
      who_i_want:updates.whoIWantToMeet, location:updates.location,
      fav_movies:updates.favoriteMovies, fav_music:updates.favoriteMusic,
      fav_tv:updates.favoriteTVShow, fav_quote:updates.favoriteQuote,
      bg_music_url:updates.bgMusicUrl,
      blinkies:updates.blinkies, top_friends:updates.topFriends, audio_tracks:updates.audioTracks||[],
      profile_bg:updates.profileBg, profile_font:updates.profileFont,
      profile_text_color:updates.profileTextColor, profile_link_color:updates.profileLinkColor,
      profile_header_bg:updates.profileHeaderBg, profile_header_text:updates.profileHeaderText,
      profile_border_color:updates.profileBorderColor, profile_border_style:updates.profileBorderStyle,
      profile_border_width:updates.profileBorderWidth, profile_table_bg:updates.profileTableBg,
      profile_bg_image:updates.profileBgImage!==undefined?updates.profileBgImage:me.profileBgImage,
      profile_banner_image:updates.profileBannerImage!==undefined?updates.profileBannerImage:me.profileBannerImage,
      profile_floats:updates.profileFloats!==undefined?updates.profileFloats:me.profileFloats,
      photo_url:photoUrl,
    };
    // Detect meaningful changes BEFORE saving (compare against current me)
    const changes=[];
    if((updates.bio||'')!==(me.bio||'')) changes.push('bio');
    if(newPhotoData||updates.removePhoto) changes.push('photo');
    if((updates.song||'')!==(me.song||'')||(updates.bgMusicUrl||'')!==(me.bgMusicUrl||'')) changes.push('now playing');
    if(JSON.stringify(updates.audioTracks||[])!==JSON.stringify(me.audioTracks||[])) changes.push('music');
    const themeFields=['profileBg','profileFont','profileTextColor','profileLinkColor','profileHeaderBg','profileHeaderText','profileBorderColor','profileBorderStyle','profileBorderWidth','profileTableBg'];
    if(themeFields.some(f=>(updates[f]||'')!==(me[f]||''))) changes.push('profile look');

    console.log("Saving user id:", me.id, "audio_tracks being saved:", JSON.stringify(dbUpdates.audio_tracks));
    const {error:ue} = await updateUser(me.id, dbUpdates);
    console.log("updateUser result error:", JSON.stringify(ue));
    if(ue){ alert("Save error: " + JSON.stringify(ue)); return; }
    const updated = mapUser({...me, ...dbUpdates, photo_url:photoUrl});
    setMe(updated);
    try{ localStorage.setItem('sh_session', JSON.stringify(updated)); }catch(e){}
    setUsers(prev=>prev.map(u=>u.id===me.id?updated:u));

    // Notify accepted friends about meaningful profile changes (batched into one notification)
    if(changes.length>0){
      const friendIds=friendships
        .filter(f=>f.status==='accepted'&&(f.requester_id===me.id||f.addressee_id===me.id))
        .map(f=>f.requester_id===me.id?f.addressee_id:f.requester_id);
      for(const fid of friendIds) createNotification(fid,'profile_update',me.id,{userId:me.id,changes});
    }

    msg("Profile saved."); nav("profile",{userId:me.id});
  }

  async function addComment(targetId, content){
    if(!me) return;
    await addProfileComment(targetId, me.id, me.username, content);
    const c = {id:Date.now(), authorName:me.username, content, date:new Date().toISOString().split("T")[0]};
    setUsers(prev=>prev.map(u=>u.id===targetId?{...u,comments:[...(u.comments||[]),c]}:u));
    if(me.id===targetId) setMe(prev=>({...prev,comments:[...(prev.comments||[]),c]}));
    msg("Comment posted.");
  }

  async function trackVisit(targetId){
    if(!me || me.id===targetId) return;
    await dbTrackVisit(targetId, me.id, me.username);
    const visitors = await getRecentVisitors(targetId);
    setUsers(prev=>prev.map(u=>u.id===targetId?{...u,views:(u.views||0)+1,recentVisitors:visitors}:u));
  }

  // ── THREADS ──
  async function newThread(boardId,title,content,isAnon,mediaObj){
    let mediaType=null, mediaUrl=null;
    try{
      if(mediaObj){
        const path=`media/${Date.now()}_op.${mediaObj.type==="image"?"jpg":"webm"}`;
        mediaUrl = await uploadMedia(mediaObj.data, path);
        mediaType = mediaObj.type;
      }
      const dbThread = await createThread({
        board_id:boardId, title, content,
        author_id:isAnon?null:me?.id,
        author_name:isAnon?"Anonymous":me?.username,
        is_anon:isAnon, is_locked:false,
        media_type:mediaType, media_url:mediaUrl, views:1,
      });
      const t = {
        ...dbThread,
        boardId, authorId:dbThread.author_id,
        authorName:dbThread.author_name,
        isAnon, isLocked:false,
        media: mediaUrl?{type:mediaType,key:mediaUrl}:null,
        replies:[], createdAt:dbThread.created_at,
      };
      setThreads(prev=>[t,...prev]);
      if(!isAnon&&me){ const np=me.posts+1; setUsers(prev=>prev.map(u=>u.id===me.id?{...u,posts:np}:u)); setMe(prev=>({...prev,posts:np})); updateUser(me.id,{post_count:np}).catch(e=>console.error("post count save failed:",e)); }
      // @mention notifications
      if(!isAnon&&me&&content){ for(const uid of extractMentions(content,users,me.id)) createNotification(uid,'mention',me.id,{threadId:t.id,boardId,snippet:content.substring(0,120)}); }
      msg("Thread posted."); nav("thread",{threadId:t.id});
    }catch(e){ msg("Failed to post thread: "+(e.message||"Unknown error"),true); throw e; }
  }

  async function replyToThread(threadId,content,isAnon,mediaObj,quotedPost=null){
    let mediaType=null, mediaUrl=null;
    try{
      if(mediaObj){
        const path=`media/${Date.now()}_r.${mediaObj.type==="image"?"jpg":"webm"}`;
        mediaUrl = await uploadMedia(mediaObj.data, path);
        mediaType = mediaObj.type;
      }
      const dbPost = await createPost({
        thread_id:threadId, content,
        author_id:isAnon?null:me?.id,
        author_name:isAnon?"Anonymous":me?.username,
        is_anon:isAnon, deleted:false,
        quoted_author:quotedPost?.author||null,
        quoted_content:quotedPost?.content||null,
        media_type:mediaType, media_url:mediaUrl,
      });
      const r = {
        ...dbPost, id:dbPost.id, content, isAnon, deleted:false, editedAt:null,
        authorId:dbPost.author_id, authorName:dbPost.author_name,
        media:mediaUrl?{type:mediaType,key:mediaUrl}:null,
        createdAt:dbPost.created_at,
      };
      setThreads(prev=>prev.map(t=>t.id===threadId?{...t,replies:[...t.replies,r]}:t));
      if(!isAnon&&me){ const np=me.posts+1; setUsers(prev=>prev.map(u=>u.id===me.id?{...u,posts:np}:u)); setMe(prev=>({...prev,posts:np})); updateUser(me.id,{post_count:np}).catch(e=>console.error("post count save failed:",e)); }
      // @mention notifications
      if(!isAnon&&me&&content){ for(const uid of extractMentions(content,users,me.id)) createNotification(uid,'mention',me.id,{threadId,snippet:content.substring(0,120)}); }
      msg("Reply posted.");
    }catch(e){ msg("Failed to post reply: "+(e.message||"Unknown error"),true); throw e; }
  }

  async function editPost(threadId,postId,newContent,isOP){
    if(isOP){
      await updateThread(threadId,{content:newContent,edited_at:new Date().toISOString()});
      setThreads(prev=>prev.map(t=>t.id===threadId?{...t,content:newContent,editedAt:new Date().toISOString()}:t));
    } else {
      await updatePost(postId,{content:newContent,edited_at:new Date().toISOString()});
      setThreads(prev=>prev.map(t=>t.id===threadId?{...t,replies:t.replies.map(r=>r.id===postId?{...r,content:newContent,editedAt:new Date().toISOString()}:r)}:t));
    }
    msg("Post edited.");
  }

  async function deletePost(threadId,postId){
    await updatePost(postId,{deleted:true});
    setThreads(prev=>prev.map(t=>t.id===threadId?{...t,replies:t.replies.map(r=>r.id===postId?{...r,deleted:true}:r)}:t));
    msg("Post deleted.");
  }

  async function handleDeleteThread(threadId,boardId){
    if(!window.confirm("Delete this thread and all its replies? This cannot be undone."))return;
    try{
      await dbDeleteThread(threadId);
      setThreads(prev=>prev.filter(t=>t.id!==threadId));
      msg("Thread deleted.");
      nav("board",{boardId});
    }catch(e){ msg("Failed to delete thread: "+(e.message||"Unknown error"),true); }
  }

  async function toggleLock(threadId){
    const t=threads.find(x=>x.id===threadId);
    const newLocked=!t.isLocked;
    await updateThread(threadId,{is_locked:newLocked});
    setThreads(prev=>prev.map(x=>x.id===threadId?{...x,isLocked:newLocked}:x));
    msg(newLocked?"Thread locked.":"Thread unlocked.");
  }

  // ── BOARD MOD ──
  async function assignMod(boardId,username){
    const u=users.find(x=>x.username===username);
    if(!u) return msg(`User "${username}" not found.`,true);
    const cur=boardMods[boardId]||[];
    if(cur.includes(u.id)) return msg(`${username} is already a mod.`,true);
    try{
      await addBoardMod(boardId,u.id);
    }catch(e){ msg("Failed to assign mod: "+(e.message||"Unknown error"),true); return; }
    const updated={...boardMods,[boardId]:[...cur,u.id]};
    setBoardMods(updated);
    msg(`${username} is now a mod of this board.`);
  }

  async function removeMod(boardId,userId){
    await removeBoardMod(boardId,userId);
    setBoardMods(prev=>({...prev,[boardId]:(prev[boardId]||[]).filter(id=>id!==userId)}));
    msg("Mod removed.");
  }

  async function saveBoardStyle(boardId,style){
    try{
      await dbSaveBoardStyle(boardId,style);
      setBoardStyles(prev=>({...prev,[boardId]:style}));
      msg("Board style saved.");
    }catch(e){ msg("Failed to save board style: "+(e.message||"Unknown error"),true); throw e; }
  }

  // ── SOCIAL: load friendships + notifications when logged in, poll every 30s ──
  useEffect(()=>{
    if(!me?.id){ setFriendships([]); setNotifications([]); setUnreadCount(0); return; }
    const loadSocial=async()=>{
      const [fs,ns]=await Promise.all([getFriendships(me.id),getNotifications(me.id)]);
      setFriendships(fs); setNotifications(ns); setUnreadCount(ns.filter(n=>!n.read).length);
    };
    loadSocial();
    const iv=setInterval(async()=>{
      const ns=await getNotifications(me.id);
      setNotifications(ns); setUnreadCount(ns.filter(n=>!n.read).length);
    },30000);
    return()=>clearInterval(iv);
  },[me?.id]);

  async function handleSendFriendRequest(addresseeId){
    try{
      const f=await sendFriendRequest(me.id,addresseeId);
      setFriendships(prev=>[...prev,f]);
      createNotification(addresseeId,'friend_request',me.id,{});
      msg("Friend request sent!");
    }catch(e){ msg("Failed: "+(e.message||"Unknown error"),true); }
  }

  async function handleAcceptFriend(friendshipId,fromUserId){
    try{
      await acceptFriendRequest(friendshipId);
      setFriendships(prev=>prev.map(f=>f.id===friendshipId?{...f,status:'accepted'}:f));
      createNotification(fromUserId,'friend_accepted',me.id,{});
      // mark the friend_request notif read
      const n=notifications.find(x=>x.type==='friend_request'&&x.from_user_id===fromUserId&&!x.read);
      if(n){ markNotificationRead(n.id); setNotifications(prev=>prev.map(x=>x.id===n.id?{...x,read:true}:x)); setUnreadCount(p=>Math.max(0,p-1)); }
      msg("Friend request accepted!");
    }catch(e){ msg("Failed: "+(e.message||"Unknown error"),true); }
  }

  async function handleDeclineFriend(friendshipId,fromUserId){
    try{
      await declineFriendRequest(friendshipId);
      setFriendships(prev=>prev.map(f=>f.id===friendshipId?{...f,status:'declined'}:f));
      const n=notifications.find(x=>x.type==='friend_request'&&x.from_user_id===fromUserId&&!x.read);
      if(n){ markNotificationRead(n.id); setNotifications(prev=>prev.map(x=>x.id===n.id?{...x,read:true}:x)); setUnreadCount(p=>Math.max(0,p-1)); }
      msg("Request declined.");
    }catch(e){ msg("Failed: "+(e.message||"Unknown error"),true); }
  }

  async function handleRemoveFriend(friendshipId){
    try{
      await removeFriend(friendshipId);
      setFriendships(prev=>prev.filter(f=>f.id!==friendshipId));
      msg("Friend removed.");
    }catch(e){ msg("Failed: "+(e.message||"Unknown error"),true); }
  }

  async function handlePoke(toUserId){
    try{
      await createNotification(toUserId,'poke',me.id,{});
      msg("Poke sent! 👋");
    }catch(e){ msg("Failed to poke.",true); }
  }

  async function handleMarkAllRead(){
    await markAllNotificationsRead(me.id);
    setNotifications(prev=>prev.map(n=>({...n,read:true}))); setUnreadCount(0);
  }

  async function handleMarkRead(notifId){
    await markNotificationRead(notifId);
    setNotifications(prev=>prev.map(n=>n.id===notifId?{...n,read:true}:n));
    setUnreadCount(p=>Math.max(0,p-1));
  }

  if(loading)return<div style={{padding:"20px",fontFamily:"Verdana",fontSize:"12px"}}>Loading...</div>;

  const ctx={nav,boards:BOARDS,threads,users,me,loadMedia,saveMedia,boardMods,boardStyles,
    getBoardStyle,isMod,getBoardModUsers,isAdmin,trackVisit,
    onEditPost:editPost,onDeletePost:deletePost,onDeleteThread:handleDeleteThread,onToggleLock:toggleLock,
    friendships,notifications,unreadCount,
    onSendFriendRequest:handleSendFriendRequest,
    onAcceptFriend:handleAcceptFriend,
    onDeclineFriend:handleDeclineFriend,
    onRemoveFriend:handleRemoveFriend,
    onPoke:handlePoke,
    onMarkAllRead:handleMarkAllRead,
    onMarkRead:handleMarkRead};

  return(
    <div style={{background:"#c0c0c0",minHeight:"100vh",padding:"10px 0"}}>
      <style>{CSS}</style>
      {toast&&<div className={`toast${toast.err?" err":""}`}>{toast.text}</div>}
      <div className="site-wrap">

        {/* Header */}
        <div className="site-header">
          <span className="site-title" onClick={()=>nav("home")}>SouthHarbor Forums</span>
          <div className="search-bar">
            <input type="text" placeholder="search..." value={searchQ} onChange={e=>setSearchQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&searchQ.trim()&&nav("search",{q:searchQ.trim()})}/>
            <input type="submit" value="Go" onClick={()=>searchQ.trim()&&nav("search",{q:searchQ.trim()})}/>
          </div>
        </div>

        {/* Nav */}
        <div className="site-nav">
          <a onClick={()=>nav("home")}>Home</a>
          <a onClick={()=>nav("boards")}>Boards</a>
          <a onClick={()=>nav("rankings")}>Rankings</a>
          {me&&<><a onClick={()=>nav("profile",{userId:me.id})}>My Profile</a><a onClick={()=>nav("edit-profile")}>Edit Profile</a>
            <a onClick={()=>nav("notifications")} style={{position:"relative"}}>
              Notifications{unreadCount>0&&<span style={{marginLeft:"4px",background:"#cc3300",color:"#fff",borderRadius:"10px",padding:"0 5px",fontSize:"9px",fontWeight:"bold",verticalAlign:"middle"}}>{unreadCount}</span>}
            </a>
          </>}
          {!me&&<><a onClick={()=>nav("login")}>Login</a><a onClick={()=>nav("register")}>Register</a></>}
          {isAdmin&&<a className="admin-link" onClick={()=>nav("admin")}>★ Admin</a>}
          {me&&<a onClick={logout} style={{marginLeft:"auto"}}>Logout</a>}
        </div>

        {me&&<div className="logged-in-bar">Logged in as: <strong>{me.username}</strong>{isAdmin&&<span style={{color:"#cc3300",fontWeight:"bold",marginLeft:"8px"}}>[Administrator]</span>} &nbsp;|&nbsp; Posts: <span className="num">{me.posts}</span></div>}

        {view==="home"         &&<HomeView        {...ctx}/>}
        {view==="login"        &&<LoginView        {...ctx} onLogin={login}/>}
        {view==="register"     &&<RegisterView     {...ctx} onRegister={register}/>}
        {view==="boards"       &&<BoardsView       {...ctx}/>}
        {view==="board"        &&<BoardView        {...ctx} boardId={vp.boardId}/>}
        {view==="thread"       &&<ThreadView       {...ctx} threadId={vp.threadId} onReply={replyToThread}/>}
        {view==="new-thread"   &&<NewThreadView    {...ctx} boardId={vp.boardId}   onSubmit={newThread}/>}
        {view==="profile"      &&<ProfileView      {...ctx} userId={vp.userId}     onComment={addComment}/>}
        {view==="edit-profile" &&<EditProfileView  {...ctx} onSave={updateProfile}/>}
        {view==="admin"        &&<AdminView        {...ctx} onAssignMod={assignMod} onRemoveMod={removeMod}/>}
        {view==="mod-panel"    &&<ModPanelView     {...ctx} boardId={vp.boardId}   onSaveStyle={saveBoardStyle}/>}
        {view==="rankings"     &&<RankingsView     {...ctx}/>}
        {view==="notifications"&&<NotificationsView {...ctx}/>}
        {view==="search"       &&<SearchView       {...ctx} query={vp.q}/>}

        <div className="site-footer">SouthHarbor.net &copy; 2004 &nbsp;|&nbsp; <a onClick={()=>nav("boards")} style={{color:"#aaccee"}}>Forums</a></div>
      </div>
    </div>
  );
}

// ─── NOTIFICATIONS VIEW ───────────────────────────────────────────────────────
const NOTIF_ICONS={'friend_request':'🤝','friend_accepted':'✅','poke':'👋','mention':'💬','profile_update':'🖊️','profile_post':'📝','new_album':'🖼️'};
function NotificationsView({nav,me,users,notifications,friendships,onMarkAllRead,onMarkRead,onAcceptFriend,onDeclineFriend}){
  if(!me) return<div className="content"><div style={{padding:"20px",color:"#999",fontSize:"12px"}}>Please <a onClick={()=>nav("login")}>log in</a> to see notifications.</div></div>;
  const unread=notifications.filter(n=>!n.read).length;

  function notifMessage(n){
    const from=users.find(u=>u.id===n.from_user_id);
    const name=from?<a style={{fontWeight:"bold",color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:from.id})}>{from.username}</a>:<strong>Someone</strong>;
    if(n.type==='friend_request') return <>{name} sent you a friend request.</>;
    if(n.type==='friend_accepted') return <>{name} accepted your friend request. You are now friends!</>;
    if(n.type==='poke') return <>{name} poked you! 👋</>;
    if(n.type==='new_album'){
      const d=n.data||{};
      const icon=d.albumType==='audio'?'🎵':'🖼️';
      const kind=d.albumType==='audio'?'audio album':'photo album';
      return <>{icon} <a style={{fontWeight:"bold",color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:n.from_user_id})}>{from?from.username:"Someone"}</a> published a new {kind}{d.albumTitle?<>: <em>&ldquo;{d.albumTitle}&rdquo;</em></>:null}. <a style={{color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:n.from_user_id})}>View profile</a></>;
    }
    if(n.type==='profile_post'){
      const d=n.data||{};
      const snippet=d.snippet?`"${d.snippet.substring(0,80)}${d.snippet.length>80?'...':''}"`:null;
      return <><a style={{fontWeight:"bold",color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:n.from_user_id})}>{from?from.username:"Someone"}</a> posted on their profile{snippet&&<>: <em style={{color:"#555"}}>{snippet}</em></>}. <a style={{color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:n.from_user_id})}>View profile</a></>;
    }
    if(n.type==='profile_update'){
      const d=n.data||{};
      const cs=Array.isArray(d.changes)&&d.changes.length>0
        ? d.changes.join(' and ')
        : 'their profile';
      return <><a style={{fontWeight:"bold",color:"#336699",cursor:"pointer"}} onClick={()=>nav("profile",{userId:n.from_user_id})}>{from?from.username:"Someone"}</a> updated their {cs}.</>;
    }
    if(n.type==='mention'){
      const d=n.data||{};
      return <>{name} mentioned you in a post.{d.threadId&&<> <a style={{color:"#336699",cursor:"pointer"}} onClick={()=>nav("thread",{threadId:d.threadId})}>View thread</a></>}{d.snippet&&<div style={{fontSize:"10px",color:"#888",marginTop:"2px",fontStyle:"italic"}}>"{d.snippet.substring(0,80)}{d.snippet.length>80?"...":""}"</div>}</>;
    }
    return <>{n.type}</>;
  }

  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; Notifications</div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"4px"}}>
        <div className="section-header" style={{margin:0}}>Notifications {unread>0&&<span style={{fontSize:"11px",color:"#cc3300",fontWeight:"normal"}}>({unread} unread)</span>}</div>
        {unread>0&&<a style={{fontSize:"11px",color:"#336699",cursor:"pointer"}} onClick={onMarkAllRead}>Mark all read</a>}
      </div>
      {notifications.length===0&&<div style={{padding:"20px",color:"#999",fontSize:"12px",border:"1px solid #ddd",textAlign:"center"}}>No notifications yet.</div>}
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px",fontFamily:"Verdana,Arial,sans-serif"}}>
        <tbody>
          {notifications.map(n=>{
            const friendship=n.type==='friend_request'
              ? friendships.find(f=>f.requester_id===n.from_user_id&&f.addressee_id===me.id)
              : null;
            const canAct=friendship&&friendship.status==='pending';
            return(
              <tr key={n.id} style={{background:n.read?"#f9f9f9":"#fffbe6",borderBottom:"1px solid #e0e0e0"}}>
                <td style={{padding:"6px 8px",width:"28px",fontSize:"18px",verticalAlign:"top",textAlign:"center"}}>{NOTIF_ICONS[n.type]||'🔔'}</td>
                <td style={{padding:"6px 8px",verticalAlign:"top"}}>
                  <div style={{lineHeight:"1.6"}}>{notifMessage(n)}</div>
                  {canAct&&<div style={{marginTop:"5px",display:"flex",gap:"8px"}}>
                    <button className="btn" style={{fontSize:"10px",padding:"2px 8px",background:"#336699",color:"#fff",border:"none"}} onClick={()=>onAcceptFriend(friendship.id,n.from_user_id)}>Accept</button>
                    <button className="btn" style={{fontSize:"10px",padding:"2px 8px"}} onClick={()=>onDeclineFriend(friendship.id,n.from_user_id)}>Decline</button>
                  </div>}
                </td>
                <td style={{padding:"6px 8px",fontSize:"10px",color:"#999",whiteSpace:"nowrap",verticalAlign:"top",textAlign:"right"}}>
                  {ago(n.created_at)}{!n.read&&<><br/><a style={{color:"#336699",cursor:"pointer"}} onClick={()=>onMarkRead(n.id)}>mark read</a></>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ─── RANKINGS VIEW ────────────────────────────────────────────────────────────
function RankingsView({nav,users,threads}){
  const [rxnMap,setRxnMap]=useState({});
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    const ids=users.filter(u=>u.id).map(u=>u.id);
    getUserReactionTotalsBatch(ids)
      .then(m=>{setRxnMap(m);setLoading(false);})
      .catch(()=>setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  if(loading) return<div className="content"><div style={{padding:"20px",color:"#999",fontSize:"12px"}}>Loading rankings...</div></div>;

  // Build thread counts per user from in-state threads
  const threadsByUser={};
  for(const t of threads){ if(t.authorId&&!t.isAnon) threadsByUser[t.authorId]=(threadsByUser[t.authorId]||0)+1; }

  const ranked=[...users]
    .map(u=>{
      const rxn=rxnMap[u.id]||{likes:0,dislikes:0};
      const tc=threadsByUser[u.id]||0;
      const score=calcHarborScore(u,rxn.likes,rxn.dislikes,tc);
      return{u,score,likes:rxn.likes,dislikes:rxn.dislikes,threads:tc};
    })
    .sort((a,b)=>b.score-a.score);

  const medals=["🥇","🥈","🥉"];
  const podiumBg=["#fffbe6","#f4f4f4","#fff5ec"];
  const podiumBorder=["#e6c200","#aaaaaa","#cc7722"];

  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; Rankings</div>
      <div className="section-header">⭐ Harbor Score Leaderboard</div>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px",fontFamily:"Verdana,Arial,sans-serif"}}>
        <thead>
          <tr style={{background:"#336699",color:"#ffffff"}}>
            <th style={{padding:"5px 8px",textAlign:"center",width:"40px"}}>#</th>
            <th style={{padding:"5px 8px",textAlign:"left"}}>User</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"80px"}}>Rank</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"60px"}}>Score</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"50px"}}>Posts</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"55px"}}>Threads</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"55px"}}>Views</th>
            <th style={{padding:"5px 8px",textAlign:"center",width:"55px"}}>👍</th>
          </tr>
        </thead>
        <tbody>
          {ranked.map(({u,score,likes,threads:tc},i)=>{
            const rank=getHarborRank(score);
            const isPodium=i<3;
            const rowBg=isPodium?podiumBg[i]:(i%2===0?"#f9f9f9":"#eef2f7");
            const rowBorder=isPodium?`2px solid ${podiumBorder[i]}`:"1px solid #dddddd";
            return(
              <tr key={u.id} style={{background:rowBg,borderBottom:rowBorder}}>
                <td style={{textAlign:"center",padding:"6px 8px",fontWeight:"bold",fontSize:isPodium?"16px":"12px",color:isPodium?podiumBorder[i]:"#999"}}>
                  {isPodium?medals[i]:`#${i+1}`}
                </td>
                <td style={{padding:"6px 8px"}}>
                  <a style={{fontWeight:"bold",color:"#336699",cursor:"pointer",fontSize:"12px"}} onClick={()=>nav("profile",{userId:u.id})}>{u.username}</a>
                  {u.bio&&<div style={{fontSize:"10px",color:"#888",marginTop:"1px",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",maxWidth:"220px"}}>{u.bio.split("\n")[0].substring(0,60)}</div>}
                </td>
                <td style={{textAlign:"center",padding:"6px 8px"}}>
                  <span style={{display:"inline-block",background:rank.color,color:"#fff",fontSize:"9px",padding:"2px 7px",borderRadius:"2px",fontWeight:"bold",letterSpacing:"0.5px"}}>{rank.label.toUpperCase()}</span>
                </td>
                <td style={{textAlign:"center",padding:"6px 8px",fontWeight:"bold",color:rank.color,fontSize:"13px"}}>{score}</td>
                <td style={{textAlign:"center",padding:"6px 8px",color:"#555"}}>{u.posts||0}</td>
                <td style={{textAlign:"center",padding:"6px 8px",color:"#555"}}>{tc}</td>
                <td style={{textAlign:"center",padding:"6px 8px",color:"#555"}}>{u.views||0}</td>
                <td style={{textAlign:"center",padding:"6px 8px",color:"#336699",fontWeight:likes>0?"bold":"normal"}}>{likes}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ─── SEARCH VIEW ──────────────────────────────────────────────────────────────
function SearchView({nav,threads,users,boards,query}){
  const q=(query||"").toLowerCase().trim();
  const matchThreads=threads.filter(t=>!t.isAnon&&(t.title.toLowerCase().includes(q)||t.content.toLowerCase().includes(q)));
  const matchUsers=users.filter(u=>u.username.toLowerCase().includes(q)||u.bio?.toLowerCase().includes(q));
  const matchReplies=threads.filter(t=>!matchThreads.includes(t)&&t.replies.some(r=>!r.isAnon&&r.content.toLowerCase().includes(q)));

  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; Search results for: <strong>"{query}"</strong></div><br/>
      <div className="section-header">Members ({matchUsers.length})</div>
      {matchUsers.length===0&&<div style={{padding:"8px",color:"#999",fontSize:"12px",borderBottom:"1px solid #eee"}}>No members found.</div>}
      {matchUsers.length>0&&<table className="board-table"><tbody>
        {matchUsers.map(u=>(
          <tr key={u.id}><td style={{width:"60px"}}><AvatarBox user={u} name={u.username} loadMedia={async(k)=>k||null} size={44} clickable onClick={()=>nav("profile",{userId:u.id})}/></td>
          <td><a className="board-name-link" onClick={()=>nav("profile",{userId:u.id})}>{u.username}</a><br/><span className="board-desc">{u.bio?.substring(0,80)}{u.bio?.length>80?"...":""}</span></td>
          <td style={{fontSize:"11px",color:"#999",whiteSpace:"nowrap"}}>{u.posts} posts</td></tr>
        ))}
      </tbody></table>}

      <br/>
      <div className="section-header">Threads ({matchThreads.length+matchReplies.length})</div>
      {matchThreads.length===0&&matchReplies.length===0&&<div style={{padding:"8px",color:"#999",fontSize:"12px"}}>No threads found.</div>}
      {[...matchThreads,...matchReplies].map(t=>(
        <div key={t.id} style={{padding:"6px 8px",borderBottom:"1px solid #eee"}}>
          <a className="thread-title-link" onClick={()=>nav("thread",{threadId:t.id})}>{t.title}</a>
          <span style={{fontSize:"10px",color:"#999",marginLeft:"8px"}}>in {boards.find(b=>b.id===t.boardId)?.name} — {ago(t.createdAt)}</span><br/>
          <span style={{fontSize:"11px",color:"#666"}}>{t.content.substring(0,100)}{t.content.length>100?"...":""}</span>
        </div>
      ))}
    </div>
  );
}

// ─── HOME ─────────────────────────────────────────────────────────────────────
function HomeView({nav,boards,threads,users,me}){
  const recent=[...threads].sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt)).slice(0,12);
  const [recentlyReplied,setRecentlyReplied]=useState([]);
  const [repliedLoading,setRepliedLoading]=useState(true);
  useEffect(()=>{
    getRecentlyReplied(15).then(data=>{setRecentlyReplied(data);setRepliedLoading(false);}).catch(()=>setRepliedLoading(false));
  },[]);
  return(
    <div className="content">
      <div className="section-header">Welcome to SouthHarbor.net</div>
      <div className="info-box" style={{marginBottom:"10px"}}>
        <strong>SouthHarbor.net</strong> is a free community forum and personal homepage network.<br/>
        {!me&&<><a onClick={()=>nav("register")}>Register for free</a> or <a onClick={()=>nav("login")}>login</a> to get started.<br/></>}
        {me&&<>Welcome back, <strong>{me.username}</strong>! <a onClick={()=>nav("profile",{userId:me.id})}>View your profile</a> | <a onClick={()=>nav("boards")}>Go to boards</a><br/></>}
        <span style={{fontSize:"11px",color:"#666"}}>Members: {users.length} &nbsp;|&nbsp; Threads: {threads.length} &nbsp;|&nbsp; Posts: {threads.reduce((a,t)=>a+t.replies.length+1,0)}</span>
      </div>
      <table style={{width:"100%",borderCollapse:"collapse",marginBottom:"10px"}}><tbody><tr valign="top">
        <td style={{width:"55%",paddingRight:"10px"}}>
          <div className="section-header">Recent Posts</div>
          <table className="board-table" style={{marginBottom:0}}><tbody>
            {recent.map(t=><tr key={t.id}><td>
              <a className="thread-title-link" onClick={()=>nav("thread",{threadId:t.id})}>{t.title}</a><br/>
              <span style={{fontSize:"10px",color:"#999"}}>by {t.authorName} in {boards.find(b=>b.id===t.boardId)?.name} — {ago(t.createdAt)}</span>
            </td></tr>)}
          </tbody></table>
        </td>
        <td style={{width:"45%"}}>
          <div className="section-header">Boards</div>
          <table className="board-table" style={{marginBottom:0}}><tbody>
            {boards.map(b=>{const c=threads.filter(t=>t.boardId===b.id).length;return(
              <tr key={b.id}><td><a className="board-name-link" onClick={()=>nav("board",{boardId:b.id})}>{b.name}</a>{b.anonOnly&&<span className="anon-tag" style={{marginLeft:"4px"}}>anon</span>}<br/><span className="board-desc">{b.desc}</span></td><td style={{textAlign:"right",color:"#999",fontSize:"11px",whiteSpace:"nowrap"}}>{c}</td></tr>
            );})}
          </tbody></table>
        </td>
      </tr></tbody></table>
      <div className="section-header" style={{marginBottom:"1px"}}>Recently Replied</div>
      <table className="board-table" style={{marginBottom:"10px"}}>
        <thead><tr><th>Thread</th><th style={{width:"90px"}}>Board</th><th style={{width:"80px"}}>Last Reply</th></tr></thead>
        <tbody>
          {repliedLoading&&<tr><td colSpan={3} style={{color:"#999",fontSize:"11px",padding:"8px"}}>Loading...</td></tr>}
          {!repliedLoading&&recentlyReplied.length===0&&<tr><td colSpan={3} style={{color:"#999",fontSize:"11px",padding:"8px"}}>No replies yet.</td></tr>}
          {recentlyReplied.map(r=>{
            const boardName=boards.find(b=>b.id===r.boardId)?.name||r.boardId;
            return(<tr key={r.threadId}>
              <td><a className="thread-title-link" onClick={()=>nav("thread",{threadId:r.threadId})}>{r.threadTitle}</a></td>
              <td style={{fontSize:"11px",color:"#666"}}><a onClick={()=>nav("board",{boardId:r.boardId})} style={{color:"#336699"}}>{boardName}</a></td>
              <td style={{fontSize:"11px",color:"#999",whiteSpace:"nowrap"}}>{ago(r.lastReplyAt)}<br/><span style={{fontSize:"10px"}}>by {r.lastReplyBy}</span></td>
            </tr>);
          })}
        </tbody>
      </table>
      <div className="section-header">Members Online</div>
      <div style={{padding:"6px",border:"1px solid #ccc",fontSize:"11px",lineHeight:2}}>
        {users.filter(u=>u.status==="online"||u.status==="away").map(u=><span key={u.id}><a onClick={()=>nav("profile",{userId:u.id})}>{u.username}</a><span className={`status-${u.status}`}> ●</span>{" "}</span>)}
        {users.filter(u=>u.status==="online"||u.status==="away").length===0&&<span style={{color:"#999"}}>No members currently online.</span>}
      </div>
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginView({nav,onLogin}){
  const [u,setU]=useState("");const [p,setP]=useState("");const [err,setErr]=useState("");const [hint,setHint]=useState(false);
  const go=()=>{if(!u||!p)return setErr("Please fill in all fields.");onLogin(u,p);};
  return(
    <div className="content" style={{maxWidth:"360px"}}>
      <div className="section-header">Login</div>
      <div style={{border:"1px solid #ccc",padding:"12px",background:"#fafafa"}}>
        {err&&<div className="error-box">{err}</div>}
        <div className="form-row"><label className="form-label">Username:</label><input type="text" value={u} onChange={e=>setU(e.target.value)} style={{width:"100%"}} onKeyDown={e=>e.key==="Enter"&&go()}/></div>
        <div className="form-row"><label className="form-label">Password:</label><input type="password" value={p} onChange={e=>setP(e.target.value)} style={{width:"100%"}} onKeyDown={e=>e.key==="Enter"&&go()}/></div>
        <input type="submit" value="Login" onClick={go}/>&nbsp;&nbsp;<a onClick={()=>nav("register")}>Register for free</a>
        <br/><br/><a style={{fontSize:"10px",color:"#999"}} onClick={()=>setHint(!hint)}>[show demo accounts]</a>
        {hint&&<div style={{fontSize:"11px",color:"#666",marginTop:"6px",lineHeight:"1.8"}}>username: <strong>xX_DarkStar_Xx</strong> / password: <strong>1234</strong><br/>username: <strong>sk8rboy_zero</strong> / password: <strong>1234</strong><br/>username: <strong>glitter_princess</strong> / password: <strong>1234</strong></div>}
      </div>
    </div>
  );
}

// ─── REGISTER ─────────────────────────────────────────────────────────────────
function RegisterView({nav,onRegister}){
  const [u,setU]=useState("");const [p,setP]=useState("");const [c,setC]=useState("");const [err,setErr]=useState("");
  const go=()=>{
    if(!u.trim()||u.length<3)return setErr("Username must be at least 3 characters.");
    if(!/^[\w\-.]+$/.test(u))return setErr("Username: letters, numbers, _ - . only.");
    if(p.length<4)return setErr("Password must be at least 4 characters.");
    if(p!==c)return setErr("Passwords do not match.");
    onRegister(u,p);
  };
  return(
    <div className="content" style={{maxWidth:"380px"}}>
      <div className="section-header">Create Your Account</div>
      <div style={{border:"1px solid #ccc",padding:"12px",background:"#fafafa"}}>
        <p style={{fontSize:"11px",color:"#666",marginBottom:"10px"}}>Registration is free. Customize your profile and post on the boards.</p>
        {err&&<div className="error-box">{err}</div>}
        <div className="form-row"><label className="form-label">Username:</label><input type="text" value={u} onChange={e=>setU(e.target.value)} style={{width:"100%"}}/></div>
        <div className="form-row"><label className="form-label">Password:</label><input type="password" value={p} onChange={e=>setP(e.target.value)} style={{width:"100%"}}/></div>
        <div className="form-row"><label className="form-label">Confirm password:</label><input type="password" value={c} onChange={e=>setC(e.target.value)} style={{width:"100%"}} onKeyDown={e=>e.key==="Enter"&&go()}/></div>
        <input type="submit" value="Create Account" onClick={go}/>&nbsp;&nbsp;<a onClick={()=>nav("login")}>Already have an account?</a>
      </div>
    </div>
  );
}

// ─── BOARDS LIST ──────────────────────────────────────────────────────────────
function BoardsView({nav,boards,threads,getBoardModUsers}){
  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; Boards</div><br/>
      <table className="board-table">
        <thead><tr><th>Board</th><th style={{width:"70px",textAlign:"center"}}>Threads</th><th style={{width:"60px",textAlign:"center"}}>Posts</th><th>Last Post</th><th style={{width:"90px"}}>Moderators</th></tr></thead>
        <tbody>{boards.map(b=>{
          const bt=threads.filter(t=>t.boardId===b.id);
          const posts=bt.reduce((a,t)=>a+t.replies.length+1,0);
          const last=[...bt].sort((a,c)=>new Date(c.createdAt)-new Date(a.createdAt))[0];
          const mods=getBoardModUsers(b.id);
          return(<tr key={b.id}>
            <td><a className="board-name-link" onClick={()=>nav("board",{boardId:b.id})}>{b.name}</a>{b.anonOnly&&<span className="anon-tag" style={{marginLeft:"5px"}}>anon only</span>}<br/><span className="board-desc">{b.desc}</span></td>
            <td style={{textAlign:"center"}}>{bt.length}</td>
            <td style={{textAlign:"center"}}>{posts}</td>
            <td style={{fontSize:"11px",color:"#666"}}>{last?<><a className="thread-title-link" style={{fontWeight:"normal"}} onClick={()=>nav("thread",{threadId:last.id})}>{last.title.substring(0,28)}{last.title.length>28?"...":""}</a><br/><span style={{fontSize:"10px",color:"#999"}}>{ago(last.createdAt)}</span></>:"—"}</td>
            <td style={{fontSize:"11px",color:"#666"}}>{mods.length>0?mods.map(m=><div key={m.id}><a onClick={()=>nav("profile",{userId:m.id})}>{m.username}</a></div>):<span style={{color:"#bbb"}}>none</span>}</td>
          </tr>);
        })}</tbody>
      </table>
    </div>
  );
}

// ─── BOARD VIEW ───────────────────────────────────────────────────────────────
function BoardView({nav,boards,threads,boardId,me,getBoardStyle,getBoardModUsers,isMod,isAdmin}){
  const b=boards.find(x=>x.id===boardId);
  if(!b)return<div className="content">Board not found.</div>;
  const style=getBoardStyle(boardId);
  const mods=getBoardModUsers(boardId);
  const canMod=me&&(isMod(boardId,me.id)||isAdmin);
  const bt=[...threads.filter(t=>t.boardId===boardId)].sort((a,c)=>{
    if(a.pinned&&!c.pinned)return -1;if(!a.pinned&&c.pinned)return 1;return new Date(c.createdAt)-new Date(a.createdAt);
  });
  const [threadLikes,setThreadLikes]=useState({});
  useEffect(()=>{
    if(bt.length) getThreadLikeTotals(bt).then(setThreadLikes).catch(()=>{});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[boardId]);
  return(
    <div>
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; <a onClick={()=>nav("boards")}>Boards</a> &raquo; {b.name}</div>
      <div style={{background:style.headerBg,color:style.headerText,padding:"6px 10px",fontFamily:style.font,fontSize:"13px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <span>{b.name}</span>
        <span style={{display:"flex",gap:"6px",alignItems:"center"}}>
          {mods.length>0&&<span style={{fontSize:"10px",opacity:.8}}>mod: {mods.map(m=>m.username).join(", ")}</span>}
          {canMod&&<button className="btn" style={{fontSize:"10px",padding:"1px 6px"}} onClick={()=>nav("mod-panel",{boardId})}>Mod Panel</button>}
          {me&&<button className="btn" style={{fontSize:"10px",padding:"1px 6px"}} onClick={()=>nav("new-thread",{boardId})}>+ New Thread</button>}
        </span>
      </div>
      {style.banner&&<div style={{padding:"6px 10px",fontSize:"12px",background:style.headerBg,color:style.headerText,borderBottom:`2px solid ${style.borderColor}`,fontFamily:style.font}}>{style.banner}</div>}
      <div style={{background:style.bg,fontFamily:style.font,color:style.textColor,padding:"8px"}}>
        {style.rules&&<div style={{border:`1px solid ${style.borderColor}`,background:style.tableRowBg,padding:"6px 8px",marginBottom:"8px",fontSize:"11px",whiteSpace:"pre-wrap"}}><strong>Rules:</strong><br/>{style.rules}</div>}
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr style={{background:style.headerBg,color:style.headerText}}>
            <th style={{padding:"4px 8px",textAlign:"left",fontSize:"11px",fontFamily:style.font}}>Thread</th>
            <th style={{padding:"4px 8px",width:"60px",textAlign:"center",fontSize:"11px"}}>Replies</th>
            <th style={{padding:"4px 8px",width:"50px",textAlign:"center",fontSize:"11px"}}>Views</th>
            <th style={{padding:"4px 8px",width:"50px",textAlign:"center",fontSize:"11px"}}>👍</th>
            <th style={{padding:"4px 8px",width:"90px",fontSize:"11px"}}>Last Post</th>
          </tr></thead>
          <tbody>
            {bt.length===0&&<tr><td colSpan={5} style={{padding:"20px",textAlign:"center",color:style.textColor,opacity:.6,fontSize:"12px"}}>No threads yet. {me&&<a style={{color:style.linkColor}} onClick={()=>nav("new-thread",{boardId})}>Post the first one.</a>}</td></tr>}
            {bt.map((t,i)=>(
              <tr key={t.id} style={{background:i%2===0?style.tableRowBg:style.tableRowAlt}}
                onMouseEnter={e=>e.currentTarget.style.opacity=".8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                <td style={{padding:"5px 8px",borderBottom:`1px solid ${style.borderColor}`,verticalAlign:"top"}}>
                  {t.pinned&&<span className="pinned-tag">PINNED</span>}
                  {t.isLocked&&<span className="locked-tag">LOCKED</span>}
                  {t.isAnon&&<span className="anon-tag">ANON</span>}
                  {t.media&&<span className="media-tag">{t.media.type==="image"?"[img]":t.media.type==="voice"?"[voice]":"[audio]"}</span>}
                  <a style={{color:style.linkColor,fontWeight:"bold",fontFamily:style.font,cursor:"pointer",textDecoration:"none"}} onClick={()=>nav("thread",{threadId:t.id})}>{t.title}</a><br/>
                  <span style={{fontSize:"10px",color:style.textColor,opacity:.6,fontFamily:style.font}}>by {t.authorName} — {ago(t.createdAt)}</span>
                </td>
                <td style={{textAlign:"center",padding:"5px",borderBottom:`1px solid ${style.borderColor}`,color:style.textColor,fontFamily:style.font,fontSize:"12px"}}>{t.replies.length}</td>
                <td style={{textAlign:"center",padding:"5px",borderBottom:`1px solid ${style.borderColor}`,color:style.textColor,fontFamily:style.font,fontSize:"12px"}}>{t.views}</td>
                <td style={{textAlign:"center",padding:"5px",borderBottom:`1px solid ${style.borderColor}`,color:threadLikes[t.id]>0?"#336699":style.textColor,fontFamily:style.font,fontSize:"12px",fontWeight:threadLikes[t.id]>0?"bold":"normal"}}>{threadLikes[t.id]||0}</td>
                <td style={{padding:"5px 8px",borderBottom:`1px solid ${style.borderColor}`,fontSize:"10px",color:style.textColor,opacity:.7}}>{t.replies.length>0?ago(t.replies[t.replies.length-1].createdAt):ago(t.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!me&&<div style={{fontSize:"11px",color:style.textColor,opacity:.7,marginTop:"6px"}}><a style={{color:style.linkColor}} onClick={()=>nav("login")}>Login</a> or <a style={{color:style.linkColor}} onClick={()=>nav("register")}>register</a> to post.</div>}
      </div>
    </div>
  );
}

// ─── POST CONTENT (renders quote blocks + clickable URLs + @mentions) ───────
function PostContent({content,font,color,users,nav}){
  const parts=parseQuote(content||"");
  const onMention=users&&nav?(uname)=>{
    const u=users.find(x=>x.username.toLowerCase()===uname.toLowerCase());
    if(u) nav("profile",{userId:u.id});
  }:null;
  return(
    <div className="post-text" style={{fontFamily:font,color:color}}>
      {parts.map((p,i)=>
        p.type==="quote"
          ?<div key={i} className="quote-block"><div className="quote-author">{p.author} wrote:</div><div className="quote-text">{linkify(p.text,`q${i}`,onMention)}</div></div>
          :<span key={i}>{linkify(p.text,`t${i}`,onMention)}</span>
      )}
    </div>
  );
}

// ─── THREAD VIEW ──────────────────────────────────────────────────────────────
function ThreadView({nav,threads,threadId,me,boards,users,onReply,loadMedia,getBoardStyle,isMod,boardMods,isAdmin,onEditPost,onDeletePost,onDeleteThread,onToggleLock}){
  const t=threads.find(x=>x.id===threadId);
  const [txt,setTxt]=useState("");const [anon,setAnon]=useState(false);
  const [mediaObj,setMediaObj]=useState(null);const [busy,setBusy]=useState(false);
  const [quotedPost,setQuotedPost]=useState(null);
  const replyRef=useRef();

  // ── REACTIONS ──
  // Post reactions keyed by post ID; thread reaction is separate (different ID space).
  const [reactions,setReactions]=useState({});
  const [threadReaction,setThreadReaction]=useState({likes:0,dislikes:0,myReaction:null});
  // Author reputation totals fetched from DB (same source as profile page)
  const [authorRxnTotals,setAuthorRxnTotals]=useState({});
  const replyIds=(t?.replies||[]).map(r=>r.id).filter(Boolean);
  const replyCount=replyIds.length;

  const buildEntry=(rows,idCol)=>{
    const entry={likes:0,dislikes:0,myReaction:null};
    for(const r of rows){
      if(r.type==='like') entry.likes++;
      else entry.dislikes++;
      if(me&&r.user_id===me.id) entry.myReaction=r.type;
    }
    return entry;
  };
  const buildMap=(rows)=>{
    const map={};
    for(const r of rows){
      const id=r.post_id;
      if(!map[id]) map[id]={likes:0,dislikes:0,myReaction:null};
      if(r.type==='like') map[id].likes++;
      else map[id].dislikes++;
      if(me&&r.user_id===me.id) map[id].myReaction=r.type;
    }
    return map;
  };

  useEffect(()=>{
    // Thread (OP) reaction
    if(t?.id) getReactions([t.id],'thread').then(rows=>setThreadReaction(buildEntry(rows)));
    // Reply (post) reactions
    if(replyCount) getReactions(replyIds,'post').then(rows=>setReactions(buildMap(rows)));
    else setReactions({});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[threadId, replyCount]);

  useEffect(()=>{
    if(!t) return;
    // Collect unique non-anon author IDs across OP + all replies
    const ids=new Set();
    if(t.authorId&&!t.isAnon) ids.add(t.authorId);
    for(const r of t.replies||[]){ if(r.authorId&&!r.isAnon) ids.add(r.authorId); }
    if(ids.size) getUserReactionTotalsBatch([...ids]).then(setAuthorRxnTotals).catch(()=>{});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[threadId]);

  // targetType: 'post' | 'thread'
  const handleReact=async(targetId,type,targetType='post')=>{
    if(!me) return;
    const isThread=targetType==='thread';
    const cur=isThread?threadReaction:(reactions[targetId]||{likes:0,dislikes:0,myReaction:null});
    const removing=cur.myReaction===type;

    // Optimistic update
    const next=(()=>{
      let{likes,dislikes}=cur;
      if(cur.myReaction==='like') likes=Math.max(0,likes-1);
      if(cur.myReaction==='dislike') dislikes=Math.max(0,dislikes-1);
      if(!removing){if(type==='like') likes++; else dislikes++;}
      return{likes,dislikes,myReaction:removing?null:type};
    })();
    if(isThread) setThreadReaction(next);
    else setReactions(prev=>({...prev,[targetId]:next}));

    try{
      if(removing) await removeReaction(targetId,me.id,targetType);
      else await upsertReaction(targetId,me.id,type,targetType);
    }catch(e){
      console.error('reaction error:',e);
      // Revert to pre-click state
      if(isThread) setThreadReaction(cur);
      else setReactions(prev=>({...prev,[targetId]:cur}));
    }
  };

  if(!t)return<div className="content">Thread not found.</div>;
  const b=boards.find(x=>x.id===t.boardId);
  const style=getBoardStyle(t.boardId);
  const boardModIds=boardMods[t.boardId]||[];
  const canMod=me&&(isMod(t.boardId,me.id)||isAdmin);

  const quotePost=(post)=>{
    const author=post.isAnon?"Anonymous":post.authorName;
    const snippet=(post.content||"").substring(0,200);
    setQuotedPost({author,content:snippet});
    setTxt(`[quote=${author}]${snippet}[/quote]\n`);
    replyRef.current?.scrollIntoView({behavior:"smooth"});
  };

  const submit=async()=>{
    if(!txt.trim()&&!mediaObj)return;
    setBusy(true);
    try{
      await onReply(t.id,txt.trim(),anon,mediaObj,quotedPost);
      setTxt("");setMediaObj(null);setQuotedPost(null);
    }catch(e){ /* error already shown via msg() in replyToThread */ }
    finally{ setBusy(false); }
  };

  const allPosts=[{...t,isOP:true},...t.replies.map(r=>({...r,isOP:false}))];

  return(
    <div>
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; <a onClick={()=>nav("boards")}>Boards</a> &raquo; <a onClick={()=>nav("board",{boardId:t.boardId})}>{b?.name}</a> &raquo; {t.title.substring(0,40)}{t.title.length>40?"...":""}</div>
      <div style={{background:style.headerBg,color:style.headerText,padding:"6px 10px",fontFamily:style.font,fontSize:"12px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <strong>{t.title}</strong>
        <span style={{display:"flex",gap:"6px",alignItems:"center",fontSize:"11px"}}>
          {t.isLocked&&<span className="locked-tag">LOCKED</span>}
          <span style={{opacity:.8}}>{t.views} views · {t.replies.length+1} posts</span>
          {canMod&&<button className="btn" style={{fontSize:"9px",padding:"1px 5px"}} onClick={()=>onToggleLock(t.id)}>{t.isLocked?"Unlock":"Lock"} Thread</button>}
          {(me&&me.id===t.authorId)&&<button className="btn" style={{fontSize:"9px",padding:"1px 5px",color:"#ffaaaa",background:"#660000",border:"1px solid #aa3333"}} onClick={()=>onDeleteThread&&onDeleteThread(t.id,t.boardId)}>Delete Thread</button>}
        </span>
      </div>
      <div style={{background:style.bg,padding:"6px"}}>
        {allPosts.map((post,i)=>{
          const pu=!post.isAnon&&post.authorId?users.find(u=>u.id===post.authorId):null;
          const pIsMod=pu&&boardModIds.includes(pu.id);
          const pIsAdmin=pu?.id===1;
          const isOwn=me&&!post.isAnon&&post.authorId===me.id;
          const rxn=post.isOP ? threadReaction : (reactions[post.id]||{likes:0,dislikes:0,myReaction:null});
          const onRxn=post.isOP ? (id,type)=>handleReact(id,type,'thread') : (id,type)=>handleReact(id,type,'post');
          return <PostRow key={post.id||i} post={post} pu={pu} isOP={post.isOP} pIsMod={pIsMod} pIsAdmin={pIsAdmin} isOwn={isOwn} style={style} nav={nav} loadMedia={loadMedia} threadId={t.id} onEdit={onEditPost} onDelete={onDeletePost} onQuote={quotePost} me={me} canMod={canMod} reaction={rxn} onReact={onRxn} authorRxnTotals={authorRxnTotals} users={users}/>;
        })}
      </div>

      {t.isLocked&&<div className="locked-notice">This thread is locked. No new replies can be posted.</div>}

      {!t.isLocked&&me&&(
        <div className="reply-box" style={{background:style.tableRowBg,border:`1px solid ${style.borderColor}`}} ref={replyRef}>
          <h3 style={{color:style.headerBg,fontFamily:style.font,borderColor:style.borderColor}}>Post a Reply</h3>
          {quotedPost&&(
            <div className="quote-preview">
              <div className="qp-head"><span>Quoting {quotedPost.author}</span><a onClick={()=>{setQuotedPost(null);setTxt("");}}>✕ remove</a></div>
              <div style={{fontSize:"11px",color:"#555"}}>{quotedPost.content.substring(0,100)}{quotedPost.content.length>100?"...":""}</div>
            </div>
          )}
          <div className="form-row"><textarea value={txt} onChange={e=>setTxt(e.target.value)} rows={5} style={{width:"100%",fontFamily:style.font}} placeholder="Type your reply..."/></div>
          <div style={{marginBottom:"8px"}}><MediaComposer onMedia={setMediaObj}/></div>
          <div style={{display:"flex",alignItems:"center",gap:"12px",flexWrap:"wrap"}}>
            <label style={{fontSize:"11px",display:"flex",alignItems:"center",gap:"4px",cursor:"pointer",fontFamily:style.font}}>
              <input type="checkbox" checked={anon} onChange={e=>setAnon(e.target.checked)}/> Post anonymously
            </label>
            <input type="submit" value={busy?"Posting...":"Post Reply"} disabled={(!txt.trim()&&!mediaObj)||busy} onClick={submit}/>
          </div>
        </div>
      )}
      {!t.isLocked&&!me&&<div style={{fontSize:"11px",color:"#666",padding:"8px"}}><a onClick={()=>nav("login")}>Login</a> or <a onClick={()=>nav("register")}>register</a> to reply.</div>}
    </div>
  );
}

// ─── POST ROW ─────────────────────────────────────────────────────────────────
function PostRow({post,pu,isOP,pIsMod,pIsAdmin,isOwn,style,nav,loadMedia,threadId,onEdit,onDelete,onQuote,me,canMod,reaction,onReact,authorRxnTotals,users}){
  const [editing,setEditing]=useState(false);
  const [editTxt,setEditTxt]=useState(post.content||"");

  if(post.deleted&&!isOP){
    return(
      <table className="post-table" style={{marginBottom:"4px"}}>
        <tbody><tr>
          <td style={{width:"130px",background:style.tableRowBg,border:`1px solid ${style.borderColor}`,padding:"8px",verticalAlign:"top",textAlign:"center",borderRight:`2px solid ${style.borderColor}`}}><span style={{color:style.textColor,opacity:.5,fontSize:"12px"}}>—</span></td>
          <td style={{border:`1px solid ${style.borderColor}`,padding:"8px",background:style.tableRowBg}}>
            <div className="post-date" style={{fontFamily:style.font,color:style.textColor,opacity:.5}}>{ago(post.createdAt||"")}</div>
            <div className="deleted-post">[this post has been deleted]</div>
          </td>
        </tr></tbody>
      </table>
    );
  }

  return(
    <table className="post-table" style={{marginBottom:"4px"}}>
      <tbody><tr>
        <td style={{width:"130px",background:style.tableRowBg,border:`1px solid ${style.borderColor}`,padding:"8px",verticalAlign:"top",textAlign:"center",borderRight:`2px solid ${style.borderColor}`}}>
          {post.isAnon
            ?<><div style={{fontSize:"28px",marginBottom:"4px"}}>?</div><div style={{color:style.textColor,opacity:.6,fontSize:"12px",fontFamily:style.font}}>Anonymous</div></>
            :<>
              <AvatarBox user={pu} name={post.authorName} loadMedia={loadMedia} size={60} clickable={!!pu} onClick={()=>pu&&nav("profile",{userId:pu.id})}/>
              <div className="post-username" style={{cursor:pu?"pointer":"default",color:style.linkColor,fontFamily:style.font}} onClick={()=>pu&&nav("profile",{userId:pu.id})}>{post.authorName}</div>
              {pu&&<div className={`status-${pu.status||"offline"}`}>{pu.status||"offline"}</div>}
              {pu&&<div className="post-count" style={{fontFamily:style.font}}>{pu.posts} posts</div>}
              {pu&&(()=>{const pur=authorRxnTotals?.[pu.id]||{likes:0,dislikes:0,threadCount:0};const s=calcHarborScore(pu,pur.likes,pur.dislikes,pur.threadCount);const r=getHarborRank(s);return<div style={{marginTop:"3px"}}><div style={{fontSize:"13px",fontWeight:"bold",color:r.color,fontFamily:"Verdana,sans-serif",lineHeight:1,marginBottom:"2px"}}>{s}</div><span style={{display:"inline-block",background:r.color,color:"#fff",fontSize:"9px",padding:"1px 5px",borderRadius:"2px",fontFamily:"Verdana,sans-serif",fontWeight:"bold",letterSpacing:"0.5px"}}>{r.label.toUpperCase()}</span></div>;})()}
              {pIsAdmin&&<div><span className="admin-tag">ADMIN</span></div>}
              {pIsMod&&!pIsAdmin&&<div><span className="mod-tag">MOD</span></div>}
            </>
          }
          {isOP&&<div><span className="op-tag">OP</span></div>}
        </td>
        <td style={{border:`1px solid ${style.borderColor}`,padding:"8px",verticalAlign:"top",background:isOP?style.tableRowAlt:style.tableRowBg}}>
          <div className="post-date" style={{fontFamily:style.font,color:style.textColor,opacity:.6}}>
            {ago(post.createdAt||"")}
            {post.editedAt&&<span className="edited-note"> (edited {ago(post.editedAt)})</span>}
            {post.isAnon&&" — Anonymous"}
          </div>

          {editing?(
            <div className="inline-edit">
              <textarea value={editTxt} onChange={e=>setEditTxt(e.target.value)} rows={4} style={{width:"100%",fontFamily:style.font,marginBottom:"4px"}}/>
              <input type="submit" value="Save" onClick={()=>{onEdit(threadId,post.id,editTxt,isOP);setEditing(false);}}/>&nbsp;
              <input type="submit" value="Cancel" onClick={()=>{setEditing(false);setEditTxt(post.content||"");}}/>
            </div>
          ):(
            <PostContent content={post.content} font={style.font} color={style.textColor} users={users} nav={nav}/>
          )}

          {post.media&&<MediaDisplay media={post.media} loadMedia={loadMedia}/>}

          {!editing&&(
            <div className="post-actions">
              <a onClick={()=>onQuote(post)}>Quote</a>
              {isOwn&&!isOP&&<><a onClick={()=>setEditing(true)}>Edit</a><a onClick={()=>onDelete(threadId,post.id)} style={{color:"#cc0000"}}>Delete</a></>}
              {isOwn&&isOP&&<a onClick={()=>setEditing(true)}>Edit OP</a>}
              {canMod&&!isOwn&&!isOP&&<a onClick={()=>onDelete(threadId,post.id)} style={{color:"#cc0000"}}>Mod Delete</a>}
              {reaction&&(
                <span style={{marginLeft:"auto",display:"flex",gap:"10px",alignItems:"center"}}>
                  <a title={me?undefined:"Login to react"} onClick={()=>onReact&&me&&onReact(post.id,"like")}
                    style={{cursor:me?"pointer":"default",fontSize:"11px",userSelect:"none",color:reaction.myReaction==="like"?"#336699":"#888",fontWeight:reaction.myReaction==="like"?"bold":"normal"}}>
                    👍{reaction.likes>0&&<span style={{marginLeft:"3px"}}>{reaction.likes}</span>}
                  </a>
                  <a title={me?undefined:"Login to react"} onClick={()=>onReact&&me&&onReact(post.id,"dislike")}
                    style={{cursor:me?"pointer":"default",fontSize:"11px",userSelect:"none",color:reaction.myReaction==="dislike"?"#aa0000":"#888",fontWeight:reaction.myReaction==="dislike"?"bold":"normal"}}>
                    👎{reaction.dislikes>0&&<span style={{marginLeft:"3px"}}>{reaction.dislikes}</span>}
                  </a>
                </span>
              )}
            </div>
          )}
        </td>
      </tr></tbody>
    </table>
  );
}

// ─── NEW THREAD ───────────────────────────────────────────────────────────────
function NewThreadView({nav,boardId,me,boards,onSubmit,getBoardStyle}){
  const [title,setTitle]=useState("");const [body,setBody]=useState("");
  const [anon,setAnon]=useState(false);const [mediaObj,setMediaObj]=useState(null);const [busy,setBusy]=useState(false);
  const b=boards.find(x=>x.id===boardId);const style=getBoardStyle(boardId);
  if(!me)return<div className="content"><a onClick={()=>nav("login")}>Login</a> to post.</div>;
  const submit=async()=>{
    if(!title.trim()||(!body.trim()&&!mediaObj))return;
    setBusy(true);
    try{ await onSubmit(boardId,title.trim(),body.trim(),anon||!!b?.anonOnly,mediaObj); }
    catch(e){ /* error already shown via msg() in newThread */ }
    finally{ setBusy(false); }
  };
  return(
    <div>
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; <a onClick={()=>nav("boards")}>Boards</a> &raquo; <a onClick={()=>nav("board",{boardId})}>{b?.name}</a> &raquo; New Thread</div>
      <div style={{background:style.headerBg,color:style.headerText,padding:"6px 10px",fontFamily:style.font,fontSize:"12px",fontWeight:"bold"}}>Post New Thread — {b?.name}</div>
      <div style={{border:`1px solid ${style.borderColor}`,padding:"12px",background:style.bg,fontFamily:style.font}}>
        <div className="form-row"><label className="form-label" style={{color:style.textColor}}>Title:</label><input type="text" value={title} onChange={e=>setTitle(e.target.value)} style={{width:"100%",fontFamily:style.font}} maxLength={100}/></div>
        <div className="form-row"><label className="form-label" style={{color:style.textColor}}>Post:</label><textarea value={body} onChange={e=>setBody(e.target.value)} rows={8} style={{width:"100%",fontFamily:style.font}} placeholder="Write your post..."/></div>
        <div className="form-row"><div style={{fontSize:"11px",color:style.textColor,fontWeight:"bold",marginBottom:"4px"}}>Attach media (optional):</div><MediaComposer onMedia={setMediaObj}/></div>
        <div style={{display:"flex",alignItems:"center",gap:"12px",flexWrap:"wrap",marginTop:"8px"}}>
          {b?.anonOnly?<span style={{fontSize:"11px",color:style.textColor}}>* This board is anonymous.</span>
          :<label style={{fontSize:"11px",display:"flex",alignItems:"center",gap:"4px",cursor:"pointer",fontFamily:style.font,color:style.textColor}}><input type="checkbox" checked={anon} onChange={e=>setAnon(e.target.checked)}/> Post anonymously</label>}
          <input type="submit" value={busy?"Posting...":"Post Thread"} disabled={!title.trim()||(!body.trim()&&!mediaObj)||busy} onClick={submit}/>
        </div>
      </div>
    </div>
  );
}

// ─── PROFILE LAYOUT SYSTEM ────────────────────────────────────────────────────
const LAYOUT_DEFS=[
  {id:"avatar",       label:"👤 Avatar"},
  {id:"stats",        label:"📊 Stats"},
  {id:"bg-music",     label:"🎵 Background Music"},
  {id:"blinkies",     label:"✨ Blinkies"},
  {id:"top-friends",  label:"👥 Top Friends"},
  {id:"visitors",     label:"👁 Recent Visitors"},
  {id:"mods-of",      label:"🛡 Moderator Of"},
  {id:"posts",        label:"📝 Posts"},
  {id:"photo-albums", label:"📷 Photo Albums"},
  {id:"audio-albums", label:"🎵 Music"},
  {id:"about",        label:"ℹ About Me"},
  {id:"more-about",   label:"📋 More About"},
  {id:"threads",      label:"💬 Recent Threads"},
  {id:"comments",     label:"🗨 Comments"},
];
// Default canvas positions (x, y, width, height in px)
const DEFAULT_POS={
  "avatar":       {x:0,   y:0,   width:215,height:160},
  "stats":        {x:0,   y:168, width:215,height:135},
  "bg-music":     {x:0,   y:311, width:215,height:80},
  "blinkies":     {x:0,   y:399, width:215,height:80},
  "top-friends":  {x:0,   y:487, width:215,height:200},
  "visitors":     {x:0,   y:695, width:215,height:155},
  "mods-of":      {x:0,   y:858, width:215,height:80},
  "posts":        {x:223, y:0,   width:395,height:285},
  "photo-albums": {x:223, y:293, width:395,height:235},
  "audio-albums": {x:223, y:536, width:395,height:210},
  "about":        {x:223, y:754, width:395,height:160},
  "more-about":   {x:626, y:0,   width:215,height:200},
  "threads":      {x:626, y:208, width:215,height:185},
  "comments":     {x:626, y:401, width:215,height:260},
};
function defaultLayout(){return LAYOUT_DEFS.map(s=>({...s,type:"builtin",visible:true,...DEFAULT_POS[s.id]}));}
function mergeLayout(saved){
  if(!saved||!Array.isArray(saved))return defaultLayout();
  const builtinIds=LAYOUT_DEFS.map(s=>s.id);
  const valid=saved.filter(s=>s.type==="custom"||builtinIds.includes(s.id));
  // Fill in default positions for items missing x/y
  const withPos=valid.map(s=>{
    const dp=DEFAULT_POS[s.id]||{x:10,y:10,width:280,height:200};
    return{x:dp.x,y:dp.y,width:dp.width,height:dp.height,...s};
  });
  const existingIds=withPos.map(s=>s.id);
  const missing=defaultLayout().filter(s=>!existingIds.includes(s.id));
  return[...withPos,...missing];
}
function getEmbedUrl(rawUrl){
  if(!rawUrl)return null;
  const u=rawUrl.trim();
  // YouTube
  const ytMatch=u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);
  if(ytMatch)return`https://www.youtube.com/embed/${ytMatch[1]}?autoplay=0`;
  // Spotify
  if(u.includes("open.spotify.com")){
    const sp=u.replace("open.spotify.com/","open.spotify.com/embed/").replace("/track/","/track/").replace("?si=","?utm_source=");
    return sp.includes("/embed/")?sp:u.replace("open.spotify.com/","open.spotify.com/embed/");
  }
  // SoundCloud — use their oembed iframe pattern
  if(u.includes("soundcloud.com"))return`https://w.soundcloud.com/player/?url=${encodeURIComponent(u)}&color=%236688ee&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`;
  return null;
}

// ─── PROFILE VIEW ─────────────────────────────────────────────────────────────
function ProfileView({nav,userId,users,me,threads,onComment,loadMedia,boardMods,boards,trackVisit,friendships,onSendFriendRequest,onAcceptFriend,onDeclineFriend,onRemoveFriend,onPoke}){
  const u=users.find(x=>x.id===userId);
  const [ctxt,setCtxt]=useState("");
  const [rxnTotals,setRxnTotals]=useState({likes:0,dislikes:0});
  const [profilePosts,setProfilePosts]=useState([]);
  const [newPostTxt,setNewPostTxt]=useState("");
  const [newPostImg,setNewPostImg]=useState(null); // {file, previewUrl}
  const [postingPost,setPostingPost]=useState(false);
  const [albums,setAlbums]=useState([]);
  const [lightbox,setLightbox]=useState(null); // {albumId,itemIndex}
  const [newAlbumTitle,setNewAlbumTitle]=useState("");
  const [creatingAlbum,setCreatingAlbum]=useState(false);
  const [uploadingTo,setUploadingTo]=useState(null); // albumId
  const [photoCaption,setPhotoCaption]=useState("");
  const photoFileRef=useRef();
  const postImgRef=useRef();
  // ── Layout customization ──
  const [layout,setLayout]=useState(()=>mergeLayout(null));
  const [editLayout,setEditLayout]=useState(false);
  const [dragSrc,setDragSrc]=useState(null);
  const [dragDst,setDragDst]=useState(null);
  const [savingLayout,setSavingLayout]=useState(false);
  const [addBlockOpen,setAddBlockOpen]=useState(false);
  const [editingBlock,setEditingBlock]=useState(null);
  const touchSrcRef=useRef(null);const touchDstRef=useRef(null);
  const [blockStyleModal,setBlockStyleModal]=useState(null);
  const layoutSetBlockStyle=(si,styles)=>setLayout(prev=>prev.map((s,i)=>i===si?{...s,blockStyle:{...(s.blockStyle||{}),...styles}}:s));

  // ── Block drag / resize ──
  const blockMouseRef=useRef({si:null,type:null,ox:0,oy:0,ow:0,oh:0,sx:0,sy:0});
  const blockTouchRef=useRef({si:null,type:null,ox:0,oy:0,ow:0,oh:0,sx:0,sy:0});
  const autoSaveLayout=async(next)=>{try{await updateUser(userId,{profile_layout:next||layout});}catch(e){console.error("auto-save",e);}};

  const onBlockDragStart=(e,si)=>{
    e.preventDefault();
    const s=layout[si];
    blockMouseRef.current={si,type:'move',ox:s.x??0,oy:s.y??0,sx:e.clientX,sy:e.clientY};
    const move=(ev)=>{const{si,ox,oy,sx,sy}=blockMouseRef.current;if(si===null)return;setLayout(prev=>{const n=prev.map((s,i)=>i===si?{...s,x:Math.max(0,ox+(ev.clientX-sx)),y:Math.max(0,oy+(ev.clientY-sy))}:s);return n;});};
    const up=()=>{window.removeEventListener("mousemove",move);window.removeEventListener("mouseup",up);setLayout(prev=>{autoSaveLayout(prev);return prev;});blockMouseRef.current={si:null};};
    window.addEventListener("mousemove",move);window.addEventListener("mouseup",up);
  };
  const onResizeStart=(e,si)=>{
    e.preventDefault();e.stopPropagation();
    const s=layout[si];
    blockMouseRef.current={si,type:'resize',ow:s.width??280,oh:s.height??200,sx:e.clientX,sy:e.clientY};
    const move=(ev)=>{const{si,ow,oh,sx,sy}=blockMouseRef.current;if(si===null)return;setLayout(prev=>prev.map((s,i)=>i===si?{...s,width:Math.max(140,ow+(ev.clientX-sx)),height:Math.max(60,oh+(ev.clientY-sy))}:s));};
    const up=()=>{window.removeEventListener("mousemove",move);window.removeEventListener("mouseup",up);setLayout(prev=>{autoSaveLayout(prev);return prev;});blockMouseRef.current={si:null};};
    window.addEventListener("mousemove",move);window.addEventListener("mouseup",up);
  };
  const onBlockTouchStart=(e,si)=>{e.stopPropagation();const t=e.touches[0];const s=layout[si];blockTouchRef.current={si,type:'move',ox:s.x??0,oy:s.y??0,sx:t.clientX,sy:t.clientY};};
  const onResizeTouchStart=(e,si)=>{e.stopPropagation();e.preventDefault();const t=e.touches[0];const s=layout[si];blockTouchRef.current={si,type:'resize',ow:s.width??280,oh:s.height??200,sx:t.clientX,sy:t.clientY};};
  const onProfileTouchMove=(e)=>{
    const{si,type,ox,oy,ow,oh,sx,sy}=blockTouchRef.current;
    if(si!==null){
      e.preventDefault();const t=e.touches[0];
      if(type==='move')setLayout(prev=>prev.map((s,i)=>i===si?{...s,x:Math.max(0,ox+(t.clientX-sx)),y:Math.max(0,oy+(t.clientY-sy))}:s));
      else setLayout(prev=>prev.map((s,i)=>i===si?{...s,width:Math.max(140,ow+(t.clientX-sx)),height:Math.max(60,oh+(t.clientY-sy))}:s));
      return;
    }
    onFloatTouchMove(e);
  };
  const onProfileTouchEnd=()=>{
    if(blockTouchRef.current.si!==null){setLayout(prev=>{autoSaveLayout(prev);return prev;});blockTouchRef.current={si:null};return;}
    onFloatTouchEnd();
  };
  const [floats,setFloats]=useState(()=>u?.profileFloats||[]);
  const floatsRef=useRef(floats);
  useEffect(()=>{floatsRef.current=floats;},[floats]);
  const [addFloatOpen,setAddFloatOpen]=useState(false);
  const [editingFloat,setEditingFloat]=useState(null);
  const floatDragRef=useRef({id:null,ox:0,oy:0,sx:0,sy:0});
  const profileContainerRef=useRef();
  const canvasRef=useRef();
  // Declared before assignment below — must come first
  const onProfileTouchMoveRef=useRef(null);
  const onProfileTouchEndRef=useRef(null);
  // Keep refs current every render so non-passive listeners always call latest versions
  onProfileTouchMoveRef.current=onProfileTouchMove;
  onProfileTouchEndRef.current=onProfileTouchEnd;
  // Non-passive touch listeners on the canvas so preventDefault() actually stops page scroll
  useEffect(()=>{
    const el=canvasRef.current;if(!el)return;
    const move=(e)=>onProfileTouchMoveRef.current&&onProfileTouchMoveRef.current(e);
    const end=()=>onProfileTouchEndRef.current&&onProfileTouchEndRef.current();
    el.addEventListener("touchmove",move,{passive:false});
    el.addEventListener("touchend",end,{passive:false});
    return()=>{el.removeEventListener("touchmove",move);el.removeEventListener("touchend",end);};
  },[]);
  // Sync layout and floats from user's saved data whenever the viewed user changes
  useEffect(()=>{
    const uu=users.find(x=>x.id===userId);
    setLayout(mergeLayout(uu?.profile_layout));
    setFloats(Array.isArray(uu?.profileFloats)?uu.profileFloats:[]);
  },[userId]);

  const [localComments,setLocalComments]=useState([]);
  useEffect(()=>{
    getProfileComments(userId).then(rows=>{
      setLocalComments(rows.map(c=>({id:c.id,authorName:c.author_name,content:c.content,date:(c.created_at||"").split("T")[0]})));
    }).catch(()=>{});
  },[userId]);

  const [localVisitors,setLocalVisitors]=useState([]);
  useEffect(()=>{
    getRecentVisitors(userId).then(rows=>{
      setLocalVisitors(rows.map(v=>({id:v.visitor_id,username:v.visitor_name,date:v.visited_at})));
    }).catch(()=>{});
  },[userId]);

  useEffect(()=>{
    getProfilePosts(userId).then(setProfilePosts).catch(()=>{});
    getProfileAlbums(userId).then(setAlbums).catch(()=>{});
  },[userId]);

  useEffect(()=>{ if(u&&me&&me.id!==u.id) trackVisit(userId); },[userId]);
  useEffect(()=>{
    if(!userId) return;
    getUserReactionTotals(userId).then(setRxnTotals).catch(()=>{});
  },[userId]);

  if(!u)return<div className="content">User not found.</div>;
  const uts=threads.filter(t=>!t.isAnon&&t.authorId===userId).slice(0,6);
  const friends=(u.topFriends||[]).map(id=>users.find(x=>x.id===id)).filter(Boolean);
  const moddedBoards=boards.filter(b=>(boardMods[b.id]||[]).includes(u.id));
  const visitors=localVisitors.slice(0,10);

  const threadCount=threads.filter(t=>!t.isAnon&&t.authorId===userId).length;
  const harborScore=calcHarborScore(u,rxnTotals.likes,rxnTotals.dislikes,threadCount);
  const rank=getHarborRank(harborScore);

  const submitComment=()=>{
    if(!ctxt.trim()||!me)return;
    const c={id:Date.now(),authorName:me.username,content:ctxt.trim(),date:new Date().toISOString().split("T")[0]};
    setLocalComments(prev=>[...prev,c]);
    onComment(userId,ctxt.trim());
    setCtxt("");
  };

  const submitProfilePost=async()=>{
    if((!newPostTxt.trim()&&!newPostImg)||!me||me.id!==userId)return;
    setPostingPost(true);
    try{
      let imageUrl=null;
      if(newPostImg?.file){
        const path=`profile-posts/${userId}/${Date.now()}_${newPostImg.file.name.replace(/[^a-z0-9.]/gi,'_')}`;
        imageUrl=await uploadFile(newPostImg.file,path);
      }
      const p=await createProfilePost(userId,newPostTxt.trim(),imageUrl);
      setProfilePosts(prev=>[p,...prev]);
      setNewPostTxt("");
      setNewPostImg(null);
      if(postImgRef.current)postImgRef.current.value="";
      const snippet=newPostTxt.trim().substring(0,120);
      const friendIds=(friendships||[])
        .filter(f=>f.status==='accepted'&&(f.requester_id===me.id||f.addressee_id===me.id))
        .map(f=>f.requester_id===me.id?f.addressee_id:f.requester_id);
      for(const fid of friendIds) createNotification(fid,'profile_post',me.id,{userId:me.id,snippet});
    }catch(e){ console.error('profile post error:',e); }
    setPostingPost(false);
  };

  const handleDeleteProfilePost=async(postId)=>{
    try{ await deleteProfilePost(postId); setProfilePosts(prev=>prev.filter(p=>p.id!==postId)); }
    catch(e){ console.error('delete profile post error:',e); }
  };

  const handleCreateAlbum=async(albumType)=>{
    if(!newAlbumTitle.trim()||!me||me.id!==userId)return;
    setCreatingAlbum(true);
    try{
      const a=await createAlbum(userId,newAlbumTitle.trim(),albumType);
      setAlbums(prev=>[a,...prev]);
      setNewAlbumTitle("");
      const friendIds=(friendships||[]).filter(f=>f.status==='accepted'&&(f.requester_id===me.id||f.addressee_id===me.id)).map(f=>f.requester_id===me.id?f.addressee_id:f.requester_id);
      for(const fid of friendIds) createNotification(fid,'new_album',me.id,{userId:me.id,albumTitle:a.title,albumType:a.type});
    }catch(e){console.error('createAlbum error:',e);}
    setCreatingAlbum(false);
  };

  const handleDeleteAlbum=async(albumId)=>{
    if(!window.confirm("Delete this album and all its contents?"))return;
    try{ await deleteAlbum(albumId); setAlbums(prev=>prev.filter(a=>a.id!==albumId)); }
    catch(e){console.error('deleteAlbum error:',e);}
  };

  const handlePhotoUpload=async(e,albumId)=>{
    const files=[...e.target.files]; if(!files.length)return;
    setUploadingTo(albumId);
    for(const file of files){
      if(file.size>15*1024*1024){alert(`${file.name} exceeds 15MB`);continue;}
      try{
        const ext=file.name.split('.').pop().toLowerCase();
        const path=`albums/${albumId}/${Date.now()}.${ext}`;
        const url=await uploadFile(file,path);
        const caption=photoCaption.trim()||null;
        const item=await addAlbumItem(albumId,url,caption,albums.find(a=>a.id===albumId)?.album_items?.length||0);
        setAlbums(prev=>prev.map(a=>a.id===albumId?{...a,album_items:[...(a.album_items||[]),item]}:a));
      }catch(err){
        console.error('photo upload error:',err);
        alert('Photo upload failed: '+(err.message||JSON.stringify(err)));
      }
    }
    setPhotoCaption("");
    if(photoFileRef.current)photoFileRef.current.value="";
    setUploadingTo(null);
  };

  const handleDeletePhoto=async(itemId,albumId)=>{
    try{ await deleteAlbumItem(itemId); setAlbums(prev=>prev.map(a=>a.id===albumId?{...a,album_items:(a.album_items||[]).filter(it=>it.id!==itemId)}:a)); }
    catch(e){console.error('deleteAlbumItem error:',e);}
  };

  const handleAddAudioTrack=async(albumId,url,title,sortOrder)=>{
    const item=await addAlbumItem(albumId,url,title,sortOrder);
    setAlbums(prev=>prev.map(a=>a.id===albumId?{...a,album_items:[...(a.album_items||[]),item]}:a));
  };

  const handleDeleteAudioTrack=async(itemId,albumId,itemIdx,curIdx,setCurIdx)=>{
    try{
      await deleteAlbumItem(itemId);
      setAlbums(prev=>prev.map(a=>a.id===albumId?{...a,album_items:(a.album_items||[]).filter(it=>it.id!==itemId)}:a));
      if(itemIdx<=curIdx) setCurIdx(i=>Math.max(0,i-1));
    }catch(e){console.error('deleteAudioTrack error:',e);}
  };

  // ── Layout handlers ──
  const layoutDragStart=(i)=>setDragSrc(i);
  const layoutDragOver=(e,i)=>{e.preventDefault();setDragDst(i);};
  const layoutDrop=(i)=>{
    if(dragSrc===null||dragSrc===i){setDragSrc(null);setDragDst(null);return;}
    setLayout(prev=>{const n=[...prev];const[r]=n.splice(dragSrc,1);n.splice(i,0,r);return n;});
    setDragSrc(null);setDragDst(null);
  };
  const layoutToggleVisible=(i)=>setLayout(prev=>prev.map((s,si)=>si===i?{...s,visible:!s.visible}:s));
  const layoutMoveUp=(i)=>{if(i===0)return;setLayout(prev=>{const n=[...prev];[n[i-1],n[i]]=[n[i],n[i-1]];return n;});};
  const layoutMoveDown=(i)=>{setLayout(prev=>{if(i>=prev.length-1)return prev;const n=[...prev];[n[i],n[i+1]]=[n[i+1],n[i]];return n;});};
  const layoutDeleteBlock=(i)=>setLayout(prev=>prev.filter((_,si)=>si!==i));
  const layoutAddBlock=(block)=>setLayout(prev=>[...prev,{...block,id:"c-"+Date.now(),type:"custom",visible:true}]);
  const layoutUpdateBlock=(id,updates)=>setLayout(prev=>prev.map(s=>s.id===id?{...s,...updates}:s));
  const saveLayout=async()=>{
    setSavingLayout(true);
    try{await updateUser(userId,{profile_layout:layout});}
    catch(e){alert("Save failed: "+e.message);}
    setSavingLayout(false);setEditLayout(false);
  };
  const cancelLayout=()=>{setLayout(mergeLayout(users.find(x=>x.id===userId)?.profile_layout));setEditLayout(false);setDragSrc(null);setDragDst(null);};

  // ── Float handlers ──
  const saveFloats=async(nextFloats)=>{
    const payload=nextFloats||floatsRef.current;
    try{ await updateUser(userId,{profile_floats:payload}); }catch(e){console.error("float save failed",e);}
  };
  const addFloat=(f)=>{const nf=[...floatsRef.current,{...f,id:"fl-"+Date.now(),x:120,y:120}];setFloats(nf);saveFloats(nf);};
  const updateFloat=(id,updates)=>{const nf=floatsRef.current.map(f=>f.id===id?{...f,...updates}:f);setFloats(nf);saveFloats(nf);};
  const deleteFloat=(id)=>{const nf=floatsRef.current.filter(f=>f.id!==id);setFloats(nf);saveFloats(nf);};

  // Mouse drag/resize for floats
  const onFloatMouseDown=(e,floatId,type='move')=>{
    if(me?.id!==userId)return;
    e.preventDefault();e.stopPropagation();
    const fl=floatsRef.current.find(f=>f.id===floatId);if(!fl)return;
    floatDragRef.current=type==='move'
      ?{id:floatId,type:'move',ox:fl.x,oy:fl.y,sx:e.clientX,sy:e.clientY}
      :{id:floatId,type:'resize',ow:fl.width||150,oh:fl.height||150,sx:e.clientX,sy:e.clientY};
    const move=(ev)=>{
      const{id,type:t,ox,oy,sx,sy,ow,oh}=floatDragRef.current;if(!id)return;
      if(t==='move')setFloats(prev=>prev.map(f=>f.id===id?{...f,x:ox+(ev.clientX-sx),y:oy+(ev.clientY-sy)}:f));
      else setFloats(prev=>prev.map(f=>f.id===id?{...f,width:Math.max(40,ow+(ev.clientX-sx)),height:Math.max(30,oh+(ev.clientY-sy))}:f));
    };
    const up=()=>{window.removeEventListener("mousemove",move);window.removeEventListener("mouseup",up);saveFloats();floatDragRef.current={id:null};};
    window.addEventListener("mousemove",move);window.addEventListener("mouseup",up);
  };
  // Touch drag/resize for floats
  const onFloatTouchStart=(e,floatId,type='move')=>{
    if(me?.id!==userId)return;
    e.stopPropagation();
    const fl=floatsRef.current.find(f=>f.id===floatId);if(!fl)return;
    const t=e.touches[0];
    floatDragRef.current=type==='move'
      ?{id:floatId,type:'move',ox:fl.x,oy:fl.y,sx:t.clientX,sy:t.clientY}
      :{id:floatId,type:'resize',ow:fl.width||150,oh:fl.height||150,sx:t.clientX,sy:t.clientY};
  };
  const onFloatTouchMove=(e)=>{
    const{id,type:t,ox,oy,sx,sy,ow,oh}=floatDragRef.current;if(!id)return;
    e.preventDefault();
    const tc=e.touches[0];
    if(t==='move')setFloats(prev=>prev.map(f=>f.id===id?{...f,x:ox+(tc.clientX-sx),y:oy+(tc.clientY-sy)}:f));
    else setFloats(prev=>prev.map(f=>f.id===id?{...f,width:Math.max(40,ow+(tc.clientX-sx)),height:Math.max(30,oh+(tc.clientY-sy))}:f));
  };
  const onFloatTouchEnd=()=>{
    if(!floatDragRef.current.id)return;
    saveFloats();floatDragRef.current={id:null};
  };

  const ps={
    position:"relative",
    background:u.profileBg,
    ...(u.profileBgImage?{backgroundImage:`url(${u.profileBgImage})`,backgroundSize:"cover",backgroundAttachment:"fixed",backgroundPosition:"center"}:{}),
    fontFamily:u.profileFont,color:u.profileTextColor,minHeight:"400px",padding:"10px"
  };
  const hS=u.profileBannerImage?{
    position:"relative",backgroundImage:`url(${u.profileBannerImage})`,backgroundSize:"cover",backgroundPosition:"center top",
    minHeight:"110px",marginBottom:"8px",border:`${u.profileBorderWidth} ${u.profileBorderStyle} ${u.profileBorderColor}`,
    display:"flex",alignItems:"flex-end",overflow:"hidden"
  }:{background:u.profileHeaderBg,color:u.profileHeaderText,padding:"8px 12px",marginBottom:"8px",border:`${u.profileBorderWidth} ${u.profileBorderStyle} ${u.profileBorderColor}`};
  const tS={border:`${u.profileBorderWidth} ${u.profileBorderStyle} ${u.profileBorderColor}`,borderCollapse:"collapse",width:"100%",background:u.profileTableBg};
  const tdS={border:`1px solid ${u.profileBorderColor}`,padding:"6px 8px",verticalAlign:"top"};
  const lS={color:u.profileLinkColor,textDecoration:"underline",cursor:"pointer",fontFamily:u.profileFont};

  // Determine if bg music is YouTube or audio
  const bgMusic=u.bgMusicUrl||"";
  const isYT=bgMusic.includes("youtube.com")||bgMusic.includes("youtu.be");
  const isAudio=/\.(mp3|ogg|wav|flac|m4a)(\?.*)?$/i.test(bgMusic);

  // Canvas height = tallest block bottom edge + padding
  const canvasHeight=layout.reduce((max,s)=>{
    if(s.visible===false)return max;
    const dp=DEFAULT_POS[s.id]||{y:0,height:200};
    const bottom=(s.y??dp.y)+(s.height??dp.height)+40;
    return bottom>max?bottom:max;
  },500);

  return(
    <div>
      <div className="breadcrumb" style={{fontFamily:"Verdana",fontSize:"11px",background:"#eef2f7",padding:"4px 10px",borderBottom:"1px solid #ccc",color:"#666"}}>
        <a onClick={()=>nav("home")} style={{color:"#336699"}}>Home</a> &raquo; {u.username}'s Profile
        {me&&me.id===userId&&<> | <a onClick={()=>nav("edit-profile")} style={{color:"#336699"}}>Edit your profile</a></>}
      </div>

      <div ref={profileContainerRef} style={ps}>

        {/* ── Floating text boxes ── */}
        {floats.map(f=>{
          const isOwner=me?.id===userId;
          const isImg=f.floatType==="image";
          const fW=f.width||(isImg?200:undefined);
          const fH=f.height||(isImg?150:undefined);
          const animKey=`fl${f.id.replace(/-/g,"")}`;
          let animCss="";
          if(!isImg){
            if(f.rainbow)animCss=`@keyframes ${animKey}{0%{color:#f00;}14%{color:#f80;}28%{color:#ff0;}42%{color:#0f0;}57%{color:#08f;}71%{color:#80f;}85%{color:#f0f;}100%{color:#f00;}}`;
            else if(f.color2&&f.flashSpeed>0)animCss=`@keyframes ${animKey}{0%,100%{color:${f.color1||"#fff"};opacity:1;}50%{color:${f.color2};opacity:${f.flashOpacity!==undefined?f.flashOpacity:1};}}`;
          }
          return(
          <div key={f.id}
            style={{position:"absolute",left:f.x,top:f.y,zIndex:20,userSelect:"none",
              transform:`rotate(${f.rotation||0}deg)`,
              width:fW?fW+"px":undefined,height:(isImg&&fH)?fH+"px":undefined,
              touchAction:isOwner?"none":"auto",
            }}
            onMouseDown={isOwner?e=>onFloatMouseDown(e,f.id,'move'):undefined}
            onTouchStart={isOwner?e=>onFloatTouchStart(e,f.id,'move'):undefined}>
            {animCss&&<style>{animCss}</style>}
            {isImg?(
              <img src={f.src} alt={f.caption||""} draggable={false}
                style={{width:"100%",height:fH?"100%":undefined,objectFit:f.fit||"cover",
                  display:"block",borderRadius:f.borderRadius||0,
                  border:f.border||"none",cursor:isOwner?"move":"default"}}/>
            ):(
              <span style={{
                display:"block",fontSize:f.fontSize||22,fontFamily:f.fontFamily||"Impact, Arial Black, sans-serif",
                fontWeight:f.bold?"bold":"normal",fontStyle:f.italic?"italic":"normal",
                color:f.color1||"#ff00ff",whiteSpace:"pre-wrap",wordBreak:"break-word",
                width:fW?fW+"px":undefined,maxWidth:fW?undefined:"400px",
                background:f.bg||"transparent",padding:f.bg?"3px 8px":"0",borderRadius:f.bg?"3px":"0",
                cursor:isOwner?"move":"default",
                textShadow:f.glow&&!animCss?`0 0 10px ${f.color1},0 0 22px ${f.color1}`:f.shadow?"1px 1px 3px rgba(0,0,0,.6)":"none",
                animation:animCss?`${animKey} ${f.rainbow?f.flashSpeed*5:f.flashSpeed}ms ${f.rainbow?"linear":""}infinite`:"none",
              }}>{f.text}</span>
            )}
            {isOwner&&<>
              <div style={{position:"absolute",top:"-20px",right:0,display:"flex",gap:"2px",opacity:.9}}>
                <button onMouseDown={e=>e.stopPropagation()} onClick={()=>setEditingFloat(f)} style={{background:"#334",border:"1px solid #66f",color:"#aaf",fontSize:"9px",padding:"1px 4px",cursor:"pointer",borderRadius:"2px",lineHeight:1}}>✎</button>
                <button onMouseDown={e=>e.stopPropagation()} onClick={()=>deleteFloat(f.id)} style={{background:"#400",border:"1px solid #f66",color:"#faa",fontSize:"9px",padding:"1px 4px",cursor:"pointer",borderRadius:"2px",lineHeight:1}}>✕</button>
              </div>
              <div
                style={{position:"absolute",bottom:0,right:0,width:22,height:22,cursor:"se-resize",background:"linear-gradient(135deg,transparent 40%,rgba(180,180,255,.6) 40%)",zIndex:2,touchAction:"none"}}
                onMouseDown={e=>onFloatMouseDown(e,f.id,'resize')}
                onTouchStart={e=>onFloatTouchStart(e,f.id,'resize')}
              />
            </>}
          </div>
          );
        })}

        {/* Banner */}
        <div style={hS}>
          {u.profileBannerImage?(
            <>
              <div style={{position:"absolute",inset:0,background:"linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)"}}/>
              <div style={{position:"relative",padding:"8px 12px",color:"#fff",width:"100%"}}>
                <span style={{fontSize:"18px",fontWeight:"bold",textShadow:"0 1px 3px rgba(0,0,0,.8)"}}>{u.username}</span>
                {u.headline&&<span style={{fontSize:"12px",marginLeft:"12px",opacity:.9,textShadow:"0 1px 2px rgba(0,0,0,.8)"}}>"{u.headline}"</span>}
                {u.id===1&&<span style={{marginLeft:"10px",background:"#336699",color:"#fff",fontSize:"9px",padding:"1px 5px",fontFamily:"Verdana"}}>ADMIN</span>}
                {moddedBoards.length>0&&<span style={{marginLeft:"8px",background:"#cc3300",color:"#fff",fontSize:"9px",padding:"1px 5px",fontFamily:"Verdana"}}>MOD: {moddedBoards.map(b=>b.name).join(", ")}</span>}
              </div>
            </>
          ):(
            <>
              <span style={{fontSize:"18px",fontWeight:"bold"}}>{u.username}</span>
              {u.headline&&<span style={{fontSize:"12px",marginLeft:"12px",opacity:.85}}>"{u.headline}"</span>}
              {u.id===1&&<span style={{marginLeft:"10px",background:"#336699",color:"#fff",fontSize:"9px",padding:"1px 5px",fontFamily:"Verdana"}}>ADMIN</span>}
              {moddedBoards.length>0&&<span style={{marginLeft:"8px",background:"#cc3300",color:"#fff",fontSize:"9px",padding:"1px 5px",fontFamily:"Verdana"}}>MOD: {moddedBoards.map(b=>b.name).join(", ")}</span>}
            </>
          )}
        </div>

        {/* Profile meta bar */}
        <div style={{fontSize:"11px",marginBottom:"6px",color:u.profileTextColor,opacity:.7,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:"4px",position:"relative",zIndex:10}}>
          <span>Profile views: <strong style={{color:u.profileLinkColor}}>{u.views}</strong></span>
        </div>

        {/* Customize toolbar */}
        {me?.id===userId&&(editLayout?(
          <div style={{background:"linear-gradient(90deg,#1e2040,#2a2a50)",border:"1px solid #4455aa",borderRadius:"3px",padding:"6px 10px",marginBottom:"8px",display:"flex",flexWrap:"wrap",gap:"6px",alignItems:"center",fontFamily:"Verdana",fontSize:"11px",color:"#aaccff",position:"relative",zIndex:50}}>
            <span style={{fontWeight:"bold",flex:1}}>✏️ Customize Layout</span>
            <button onClick={()=>setAddBlockOpen(true)} style={{background:"#334488",border:"1px solid #6677cc",color:"#fff",fontSize:"10px",padding:"3px 8px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>+ Add Block</button>
            <button onClick={()=>setAddFloatOpen(true)} style={{background:"#443388",border:"1px solid #8866cc",color:"#fff",fontSize:"10px",padding:"3px 8px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>✦ Add Overlay</button>
            <button onClick={saveLayout} style={{background:"#225522",border:"1px solid #44aa44",color:"#aaffaa",fontSize:"10px",padding:"3px 8px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>{savingLayout?"Saving…":"💾 Save"}</button>
            <button onClick={cancelLayout} style={{background:"#333",border:"1px solid #666",color:"#ccc",fontSize:"10px",padding:"3px 8px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>Cancel</button>
            <div style={{width:"100%",fontSize:"9px",color:"#778",marginTop:"2px"}}>Drag any block header to move · drag ↘ corner to resize · 🎨 to style · 👁 to hide</div>
          </div>
        ):(
          <div style={{textAlign:"right",marginBottom:"4px",display:"flex",gap:"10px",justifyContent:"flex-end",position:"relative",zIndex:10}}>
            <a onClick={()=>setAddFloatOpen(true)} style={{fontSize:"10px",cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline"}}>✦ Add Overlay</a>
            <a onClick={()=>setEditLayout(true)} style={{fontSize:"10px",cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline"}}>✏ Customize Layout</a>
          </div>
        ))}

        {/* Free-form canvas — all blocks live here */}
        <div ref={canvasRef} style={{position:"relative",minHeight:canvasHeight+"px"}}>
        {layout.map((section,si)=>{
          const isVisible=section.visible!==false;
          const isOwner=me?.id===userId;
          const defPos=DEFAULT_POS[section.id]||{x:10,y:10,width:280,height:200};
          const x=section.x??defPos.x;
          const y=section.y??defPos.y;
          const w=section.width??defPos.width;
          const h=section.height??defPos.height;
          const HBAR=28;
          const bs=section.blockStyle||{};
          const sHdrBg=bs.headerBg||u.profileHeaderBg;
          const sHdrTx=bs.headerText||u.profileHeaderText;
          const sBodyBg=bs.bodyBg||u.profileTableBg;
          const sBrdClr=bs.borderColor||u.profileBorderColor;
          const sBrdSty=bs.borderStyle||u.profileBorderStyle;
          const sBrdWid=bs.borderWidth||u.profileBorderWidth;
          const sBgImg=bs.bgImage||null;
          const stS={border:`${sBrdWid} ${sBrdSty} ${sBrdClr}`,borderCollapse:"collapse",width:"100%",background:sBodyBg};
          const stdS={border:`1px solid ${sBrdClr}`,padding:"6px 8px",verticalAlign:"top"};
          const sHdrTd={...stdS,background:sHdrBg,color:sHdrTx,fontSize:"12px",fontWeight:"bold"};

          let content=null;
          if(section.type==="custom"){
            content=<CustomBlock block={section} u={u} tS={stS} tdS={stdS} sHdrBg={sHdrBg} sHdrTx={sHdrTx}/>;
          } else switch(section.id){
            case"avatar":
              content=(
                <div style={{padding:"8px",textAlign:"center"}}>
                  <AvatarBox user={u} name={u.username} loadMedia={loadMedia} size={Math.min(120,w-30)}/>
                  <div style={{marginTop:"4px",fontSize:"11px"}}>
                    <span style={{color:u.status==="online"?"#009900":u.status==="away"?"#cc6600":"#999"}}>● {u.status||"offline"}</span>
                  </div>
                  {u.mood&&<div style={{fontSize:"11px",marginTop:"4px",fontStyle:"italic",opacity:.8}}>Mood: {u.mood}</div>}
                  {me&&me.id!==userId&&(()=>{
                    const fs=friendships&&friendships.find(f=>(f.requester_id===me.id&&f.addressee_id===userId)||(f.requester_id===userId&&f.addressee_id===me.id));
                    const bS2={fontSize:"10px",padding:"2px 8px",cursor:"pointer",fontFamily:"Verdana,sans-serif"};
                    return<div style={{marginTop:"8px",display:"flex",flexDirection:"column",alignItems:"center",gap:"3px"}}>
                      {!fs&&<button className="btn" style={bS2} onClick={()=>onSendFriendRequest&&onSendFriendRequest(userId)}>+ Add Friend</button>}
                      {fs&&fs.status==='pending'&&fs.requester_id===me.id&&<button className="btn" style={{...bS2,color:"#888"}} disabled>Request Sent</button>}
                      {fs&&fs.status==='pending'&&fs.addressee_id===me.id&&<><button className="btn" style={{...bS2,background:"#336699",color:"#fff"}} onClick={()=>onAcceptFriend&&onAcceptFriend(fs.id,userId)}>Accept</button><button className="btn" style={bS2} onClick={()=>onDeclineFriend&&onDeclineFriend(fs.id,userId)}>Decline</button></>}
                      {fs&&fs.status==='accepted'&&<><button className="btn" style={{...bS2,color:"#226622"}} disabled>Friends ✓</button><button className="btn" style={{...bS2,color:"#cc0000"}} onClick={()=>onRemoveFriend&&onRemoveFriend(fs.id)}>Remove</button></>}
                      <button className="btn" style={bS2} onClick={()=>onPoke&&onPoke(userId)}>👋 Poke</button>
                    </div>;
                  })()}
                  <div style={{marginTop:"6px",fontSize:"10px",color:u.profileTextColor,opacity:.55}}>Views: <strong style={{color:u.profileLinkColor}}>{u.views}</strong></div>
                </div>
              );break;
            case"stats":
              content=(
                <table style={stS}><tbody><tr><td style={stdS}>
                  <div style={{marginBottom:"7px",paddingBottom:"7px",borderBottom:`1px solid ${sBrdClr}`}}>
                    <div style={{fontSize:"28px",fontWeight:"bold",color:rank.color,fontFamily:"Verdana",lineHeight:1}}>{harborScore}</div>
                    <div style={{marginTop:"5px"}}><span style={{display:"inline-block",background:rank.color,color:"#fff",border:`2px solid ${rank.border}`,fontSize:"10px",padding:"2px 8px",fontFamily:"Verdana",fontWeight:"bold",letterSpacing:"1px",borderRadius:"3px"}}>{rank.label.toUpperCase()}</span></div>
                    <div style={{fontSize:"10px",color:"#555",marginTop:"4px",fontFamily:"Verdana",fontWeight:"bold"}}>Harbor Score</div>
                  </div>
                  <span style={{fontSize:"11px"}}>Member since: {fmt(u.joinDate)}<br/>Threads: <strong>{threadCount}</strong>&nbsp;Posts: <strong>{u.posts}</strong><br/>Views: <strong>{u.views||0}</strong></span>
                </td></tr></tbody></table>
              );break;
            case"bg-music":
              if(!bgMusic&&!(u.audioTracks||[]).length)break;
              content=(
                <div style={{padding:"6px"}}>
                  {bgMusic&&isYT&&(()=>{
                    let src=bgMusic.replace("watch?v=","embed/").replace("youtu.be/","youtube.com/embed/");
                    src+=(src.includes("?")?"&":"?")+"autoplay=1";
                    return<iframe src={src} width="100%" height="80" frameBorder="0" allow="autoplay" style={{border:`1px solid ${sBrdClr}`,display:"block"}} title="bg music"/>;
                  })()}
                  {bgMusic&&isAudio&&<div style={{border:`1px solid ${sBrdClr}`,padding:"4px"}}><div style={{fontSize:"10px",color:u.profileTextColor,marginBottom:"2px"}}>🎵 {u.song||"now playing"}</div><audio controls autoPlay src={bgMusic} style={{width:"100%"}}/></div>}
                  {bgMusic&&!isYT&&!isAudio&&bgMusic.includes("soundcloud.com")&&(()=>{
                    const sc=bgMusic.includes("&auto_play")?bgMusic:bgMusic+(bgMusic.includes("?")?"&":"?")+"auto_play=true";
                    return<iframe width="100%" height="80" scrolling="no" frameBorder="no" allow="autoplay" src={sc} style={{border:`1px solid ${sBrdClr}`,display:"block"}} title="bg music"/>;
                  })()}
                  {bgMusic&&!isYT&&!isAudio&&!bgMusic.includes("soundcloud.com")&&<div style={{fontSize:"11px"}}><a href={bgMusic} target="_blank" rel="noreferrer" style={lS}>🎵 {u.song||bgMusic}</a></div>}
                  {(u.audioTracks||[]).length>0&&<AudioAlbumPlayer tracks={u.audioTracks} u={{...u,profileHeaderBg:sHdrBg,profileHeaderText:sHdrTx,profileTableBg:sBodyBg,profileBorderColor:sBrdClr}} tS={stS} tdS={stdS}/>}
                </div>
              );break;
            case"blinkies":
              if(!(u.blinkies||[]).length)break;
              content=(
                <div style={{padding:"6px",display:"flex",flexWrap:"wrap",gap:"2px"}}>
                  {u.blinkies.map((b,i)=><span key={i} style={{border:`1px solid ${sBrdClr}`,background:sHdrBg,color:sHdrTx,padding:"1px 6px",fontSize:"11px",fontFamily:"'Comic Sans MS', cursive"}}>{b}</span>)}
                </div>
              );break;
            case"top-friends":
              content=(
                <div style={{padding:"6px"}}>
                  {friends.length===0
                    ?<span style={{fontSize:"11px",opacity:.7}}>No friends added yet.</span>
                    :<div style={{display:"flex",flexWrap:"wrap",gap:"6px"}}>
                      {friends.map(f=><div key={f.id} style={{textAlign:"center",cursor:"pointer"}} onClick={()=>nav("profile",{userId:f.id})}>
                        <AvatarBox user={f} name={f.username} loadMedia={loadMedia} size={44} clickable/>
                        <div style={{fontSize:"9px",maxWidth:"44px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",...lS}}>{f.username}</div>
                      </div>)}
                    </div>
                  }
                </div>
              );break;
            case"visitors":
              if(!visitors.length)break;
              content=(
                <div style={{padding:"6px"}}>
                  {visitors.map((v,i)=>{
                    const vu=users.find(x=>x.id===v.id);
                    return<div key={i} style={{fontSize:"11px",marginBottom:"2px"}}>
                      <span className="visitor-dot"/>
                      {vu?<a style={lS} onClick={()=>nav("profile",{userId:v.id})}>{v.username}</a>:<span style={{color:u.profileTextColor}}>{v.username}</span>}
                      <span style={{fontSize:"10px",opacity:.6,marginLeft:"4px"}}>{ago(v.date)}</span>
                    </div>;
                  })}
                </div>
              );break;
            case"mods-of":
              if(!moddedBoards.length)break;
              content=(
                <div style={{padding:"6px"}}>
                  {moddedBoards.map(b=><div key={b.id}><a style={lS} onClick={()=>nav("board",{boardId:b.id})}>{b.name}</a></div>)}
                </div>
              );break;
            case"posts":
              content=(
                <table style={stS}><tbody>
                  <tr><td style={sHdrTd}>📝 Posts</td></tr>
                  {me&&me.id===userId&&<tr><td style={stdS}>
                    <textarea value={newPostTxt} onChange={e=>setNewPostTxt(e.target.value)} rows={3} style={{width:"100%",marginBottom:"4px",fontFamily:u.profileFont,boxSizing:"border-box"}} placeholder="What's on your mind?"/>
                    {newPostImg&&<div style={{marginBottom:"4px",position:"relative",display:"inline-block"}}>
                      <img src={newPostImg.previewUrl} alt="" style={{maxWidth:"100%",maxHeight:"120px",border:`1px solid ${sBrdClr}`,borderRadius:"2px"}}/>
                      <a onClick={()=>{setNewPostImg(null);if(postImgRef.current)postImgRef.current.value="";}} style={{position:"absolute",top:"2px",right:"2px",background:"rgba(0,0,0,0.6)",color:"#fff",fontSize:"10px",padding:"1px 5px",cursor:"pointer",borderRadius:"2px"}}>✕</a>
                    </div>}
                    <div style={{display:"flex",gap:"6px",alignItems:"center",flexWrap:"wrap"}}>
                      <input type="submit" value={postingPost?"Posting...":"Post"} disabled={(!newPostTxt.trim()&&!newPostImg)||postingPost} onClick={submitProfilePost}/>
                      <label style={{fontSize:"10px",cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline"}}>📷 Add photo<input ref={postImgRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{const f=e.target.files?.[0];if(f)setNewPostImg({file:f,previewUrl:URL.createObjectURL(f)});}}/></label>
                    </div>
                  </td></tr>}
                  {profilePosts.length===0&&<tr><td style={stdS}><span style={{fontSize:"11px",opacity:.7}}>No posts yet.</span></td></tr>}
                  {profilePosts.map(p=><tr key={p.id}><td style={stdS}>
                    {p.image_url&&<div style={{marginBottom:"6px"}}><img src={p.image_url} alt="" style={{maxWidth:"120px",maxHeight:"90px",objectFit:"cover",borderRadius:"2px",border:`1px solid ${sBrdClr}`,cursor:"pointer",display:"block"}} onClick={()=>window.open(p.image_url,"_blank")}/></div>}
                    {p.content&&<div style={{fontSize:"12px",lineHeight:"1.6",whiteSpace:"pre-wrap",wordBreak:"break-word"}}>{p.content}</div>}
                    <div style={{fontSize:"10px",color:u.profileTextColor,opacity:.6,marginTop:"4px",display:"flex",justifyContent:"space-between"}}>
                      <span>{ago(p.created_at)}</span>
                      {me&&me.id===userId&&<a style={{color:"#cc0000",cursor:"pointer"}} onClick={()=>handleDeleteProfilePost(p.id)}>delete</a>}
                    </div>
                  </td></tr>)}
                </tbody></table>
              );break;
            case"photo-albums":
              if(albums.filter(a=>a.type==="photo").length===0&&me?.id!==userId)break;
              content=(<>
                {me?.id===userId&&<div style={{padding:"4px 6px",display:"flex",gap:"4px",alignItems:"center",borderBottom:`1px solid ${sBrdClr}`}}>
                  <input type="text" value={newAlbumTitle} onChange={e=>setNewAlbumTitle(e.target.value)} placeholder="Album name..." style={{fontSize:"10px",fontFamily:u.profileFont,padding:"1px 4px",width:"90px"}} onKeyDown={e=>{if(e.key==="Enter")handleCreateAlbum("photo");}}/>
                  <input type="submit" value={creatingAlbum?"...":"+ Album"} onClick={()=>handleCreateAlbum("photo")} disabled={!newAlbumTitle.trim()||creatingAlbum} style={{fontSize:"10px",padding:"1px 6px"}}/>
                </div>}
                {albums.filter(a=>a.type==="photo").map(album=>(
                  <PhotoAlbumViewer key={album.id} album={album} isOwn={me?.id===userId} onDeleteAlbum={handleDeleteAlbum} onDeletePhoto={handleDeletePhoto} onUpload={handlePhotoUpload} uploadingTo={uploadingTo} u={{...u,profileHeaderBg:sHdrBg,profileHeaderText:sHdrTx,profileTableBg:sBodyBg,profileBorderColor:sBrdClr,profileBorderStyle:sBrdSty,profileBorderWidth:sBrdWid}} onOpenLightbox={(aId,i)=>setLightbox({albumId:aId,itemIndex:i})}/>
                ))}
                {lightbox&&albums.find(a=>a.id===lightbox.albumId)&&<Lightbox items={albums.find(a=>a.id===lightbox.albumId).album_items||[]} startIdx={lightbox.itemIndex} onClose={()=>setLightbox(null)}/>}
              </>);break;
            case"audio-albums":
              if(albums.filter(a=>a.type==="audio").length===0&&me?.id!==userId)break;
              content=(<>
                {me?.id===userId&&<div style={{padding:"4px 6px",display:"flex",gap:"4px",alignItems:"center",borderBottom:`1px solid ${sBrdClr}`}}>
                  <input type="text" value={newAlbumTitle} onChange={e=>setNewAlbumTitle(e.target.value)} placeholder="Playlist name..." style={{fontSize:"10px",fontFamily:u.profileFont,padding:"1px 4px",width:"90px"}} onKeyDown={e=>{if(e.key==="Enter")handleCreateAlbum("audio");}}/>
                  <input type="submit" value={creatingAlbum?"...":"+ Playlist"} onClick={()=>handleCreateAlbum("audio")} disabled={!newAlbumTitle.trim()||creatingAlbum} style={{fontSize:"10px",padding:"1px 6px"}}/>
                </div>}
                {albums.filter(a=>a.type==="audio").map(album=>(
                  <AudioAlbumMiniPlayer key={album.id} album={album} isOwn={me?.id===userId} onDeleteItem={handleDeleteAudioTrack} onDeleteAlbum={handleDeleteAlbum} onAddTrack={handleAddAudioTrack} u={{...u,profileHeaderBg:sHdrBg,profileHeaderText:sHdrTx,profileTableBg:sBodyBg,profileBorderColor:sBrdClr,profileBorderStyle:sBrdSty,profileBorderWidth:sBrdWid}}/>
                ))}
              </>);break;
            case"about":
              content=(
                <table style={stS}><tbody>
                  <tr><td style={sHdrTd}>{u.aboutTitle||"About Me"}</td></tr>
                  <tr><td style={stdS}>
                    <div style={{fontSize:"12px",lineHeight:"1.8",whiteSpace:"pre-wrap"}}>{u.bio||"Nothing here yet."}</div>
                    {u.mood&&<div style={{fontSize:"11px",marginTop:"6px",opacity:.8}}>Mood: <em>{u.mood}</em></div>}
                    {u.interests&&<div style={{fontSize:"11px",marginTop:"4px",opacity:.8}}>Interests: {u.interests}</div>}
                    {u.whoIWantToMeet&&<div style={{fontSize:"11px",marginTop:"4px",opacity:.8}}>Who I want to meet: {u.whoIWantToMeet}</div>}
                  </td></tr>
                </tbody></table>
              );break;
            case"more-about":
              if(!u.location&&!u.favoriteMovies&&!u.favoriteMusic&&!u.favoriteTVShow&&!u.favoriteQuote)break;
              content=(
                <table style={stS}><tbody>
                  <tr><td style={sHdrTd}>More About Me</td></tr>
                  {u.location&&<tr><td style={stdS}><span style={{fontSize:"10px",opacity:.7}}>Location:</span><br/><span style={{fontSize:"12px"}}>{u.location}</span></td></tr>}
                  {u.favoriteMovies&&<tr><td style={stdS}><span style={{fontSize:"10px",opacity:.7}}>Favorite Movies:</span><br/><span style={{fontSize:"12px"}}>{u.favoriteMovies}</span></td></tr>}
                  {u.favoriteMusic&&<tr><td style={stdS}><span style={{fontSize:"10px",opacity:.7}}>Favorite Music:</span><br/><span style={{fontSize:"12px"}}>{u.favoriteMusic}</span></td></tr>}
                  {u.favoriteTVShow&&<tr><td style={stdS}><span style={{fontSize:"10px",opacity:.7}}>Favorite TV Show:</span><br/><span style={{fontSize:"12px"}}>{u.favoriteTVShow}</span></td></tr>}
                  {u.favoriteQuote&&<tr><td style={stdS}><span style={{fontSize:"10px",opacity:.7}}>Favorite Quote:</span><br/><span style={{fontSize:"12px",fontStyle:"italic"}}>{u.favoriteQuote}</span></td></tr>}
                </tbody></table>
              );break;
            case"threads":
              if(uts.length===0)break;
              content=(
                <table style={stS}><tbody>
                  <tr><td style={sHdrTd}>Recent Threads</td></tr>
                  {uts.map(t=><tr key={t.id}><td style={stdS}><a style={lS} onClick={()=>nav("thread",{threadId:t.id})}>{t.title}</a><span style={{fontSize:"10px",opacity:.7,marginLeft:"6px"}}>{ago(t.createdAt)}</span></td></tr>)}
                </tbody></table>
              );break;
            case"comments":
              content=(
                <table style={stS}><tbody>
                  <tr><td style={sHdrTd}>Comments</td></tr>
                  {localComments.length===0&&<tr><td style={stdS}><span style={{fontSize:"11px",opacity:.7}}>No comments yet.</span></td></tr>}
                  {localComments.map(c=><tr key={c.id}><td style={stdS}>
                    <div style={{fontSize:"11px"}}><a style={lS} onClick={()=>{const cu=users.find(x=>x.username===c.authorName);if(cu)nav("profile",{userId:cu.id});}}>{c.authorName}</a><span style={{opacity:.6,marginLeft:"6px"}}>{c.date}</span></div>
                    <div style={{fontSize:"12px",marginTop:"3px"}}>{c.content}</div>
                  </td></tr>)}
                  {me&&me.id!==userId&&<tr><td style={stdS}>
                    <textarea value={ctxt} onChange={e=>setCtxt(e.target.value)} rows={3} style={{width:"100%",marginBottom:"4px",fontFamily:u.profileFont}} placeholder="Leave a comment..."/>
                    <input type="submit" value="Post Comment" onClick={submitComment}/>
                  </td></tr>}
                  {!me&&<tr><td style={stdS}><span style={{fontSize:"11px"}}><a style={lS} onClick={()=>nav("login")}>Login</a> to comment.</span></td></tr>}
                </tbody></table>
              );break;
            default:break;
          }

          if(!content&&!isOwner)return null;
          if(!content&&!editLayout)return null;

          return(
            <div key={section.id} style={{
              position:"absolute",left:x,top:y,width:w,
              opacity:!isVisible?0.35:1,boxSizing:"border-box",
              pointerEvents:!isVisible&&!editLayout?"none":"auto",
            }}>
              {/* Drag handle header */}
              <div
                style={{
                  background:sHdrBg,color:sHdrTx,
                  padding:"3px 6px",fontSize:"11px",fontWeight:"bold",
                  cursor:isOwner&&editLayout?"move":"default",userSelect:"none",
                  display:"flex",alignItems:"center",gap:"3px",
                  height:HBAR+"px",boxSizing:"border-box",borderRadius:"2px 2px 0 0",
                  touchAction:isOwner&&editLayout?"none":"auto",
                }}
                onMouseDown={isOwner&&editLayout?e=>onBlockDragStart(e,si):undefined}
                onTouchStart={isOwner&&editLayout?e=>onBlockTouchStart(e,si):undefined}
              >
                {isOwner&&editLayout&&<span style={{opacity:.4,fontSize:"13px",lineHeight:1}}>⠿</span>}
                <span style={{flex:1,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{section.label||section.id}</span>
                {editLayout&&<>
                  <button onMouseDown={e=>e.stopPropagation()} onClick={()=>layoutToggleVisible(si)} style={{background:"none",border:"none",color:sHdrTx,cursor:"pointer",fontSize:"12px",padding:"0 2px",opacity:.8,minWidth:"22px",minHeight:"22px"}}>{isVisible?"👁":"🚫"}</button>
                  <button onMouseDown={e=>e.stopPropagation()} onClick={()=>setBlockStyleModal({si,section})} style={{background:"none",border:"none",color:sHdrTx,cursor:"pointer",fontSize:"11px",padding:"0 2px",opacity:.8,minWidth:"22px",minHeight:"22px"}}>🎨</button>
                  {section.type==="custom"&&<>
                    <button onMouseDown={e=>e.stopPropagation()} onClick={()=>setEditingBlock({...section,_si:si})} style={{background:"none",border:"none",color:sHdrTx,cursor:"pointer",fontSize:"11px",padding:"0 2px",opacity:.8,minWidth:"22px",minHeight:"22px"}}>✎</button>
                    <button onMouseDown={e=>e.stopPropagation()} onClick={()=>layoutDeleteBlock(si)} style={{background:"none",border:"none",color:"#ff8888",cursor:"pointer",fontSize:"11px",padding:"0 2px",minWidth:"22px",minHeight:"22px"}}>✕</button>
                  </>}
                </>}
              </div>
              {/* Scrollable content area */}
              <div style={{
                height:(h-HBAR)+"px",overflowY:"auto",overflowX:"hidden",
                border:`${sBrdWid} ${sBrdSty} ${sBrdClr}`,borderTop:"none",
                background:sBodyBg,
                ...(sBgImg?{backgroundImage:`url(${sBgImg})`,backgroundSize:"cover",backgroundPosition:"center"}:{}),
                boxSizing:"border-box",
              }}>
                {content||(editLayout&&isOwner&&<div style={{padding:"12px",fontSize:"10px",color:"#999",textAlign:"center"}}>(hidden)</div>)}
              </div>
              {/* Resize corner — only visible/active in customize mode */}
              {isOwner&&editLayout&&<div
                style={{position:"absolute",bottom:0,right:0,width:22,height:22,cursor:"se-resize",background:"linear-gradient(135deg,transparent 40%,rgba(160,160,255,.55) 40%)",zIndex:2,touchAction:"none"}}
                onMouseDown={e=>onResizeStart(e,si)}
                onTouchStart={e=>onResizeTouchStart(e,si)}
              />}
            </div>
          );
        })}
        </div>

        {/* Modals */}
        {addBlockOpen&&<AddBlockModal onAdd={b=>{layoutAddBlock(b);setAddBlockOpen(false);}} onClose={()=>setAddBlockOpen(false)} u={u}/>}
        {editingBlock&&<AddBlockModal existing={editingBlock} onAdd={b=>{layoutUpdateBlock(editingBlock.id,b);setEditingBlock(null);}} onClose={()=>setEditingBlock(null)} u={u}/>}
        {addFloatOpen&&<AddFloatModal onAdd={f=>{addFloat(f);setAddFloatOpen(false);}} onClose={()=>setAddFloatOpen(false)}/>}
        {editingFloat&&<AddFloatModal existing={editingFloat} onAdd={f=>{updateFloat(editingFloat.id,f);setEditingFloat(null);}} onClose={()=>setEditingFloat(null)}/>}
        {blockStyleModal&&<BlockStyleModal section={blockStyleModal.section} si={blockStyleModal.si} u={u} onSave={(si,styles)=>{layoutSetBlockStyle(si,styles);setBlockStyleModal(null);}} onClose={()=>setBlockStyleModal(null)}/>}

      </div>
    </div>
  );
}

// ─── CUSTOM BLOCK ─────────────────────────────────────────────────────────────
function CustomBlock({block,u,tS,tdS,sHdrBg,sHdrTx}){
  const h=block.height||200;
  const embedUrl=block.embedType!=="html"?getEmbedUrl(block.content):null;
  const hdrBg=sHdrBg||u.profileHeaderBg;const hdrTx=sHdrTx||u.profileHeaderText;
  return(
    <div style={{border:`${u.profileBorderWidth} ${u.profileBorderStyle} ${u.profileBorderColor}`,overflow:"hidden",marginBottom:"2px"}}>
      {block.label&&<div style={{background:hdrBg,color:hdrTx,padding:"4px 8px",fontSize:"12px",fontWeight:"bold"}}>{block.label}</div>}
      <div style={{background:u.profileTableBg}}>
        {block.embedType==="image"&&<img src={block.content} alt={block.label||""} style={{width:"100%",maxHeight:h+"px",objectFit:"contain",display:"block"}}/>}
        {block.embedType==="html"&&<div style={{padding:"8px",fontSize:"12px",lineHeight:"1.6",color:u.profileTextColor}} dangerouslySetInnerHTML={{__html:block.content}}/>}
        {embedUrl&&<iframe src={embedUrl} width="100%" height={h} frameBorder="0" allowFullScreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" style={{display:"block"}}/>}
      </div>
    </div>
  );
}

// ─── ADD BLOCK MODAL ──────────────────────────────────────────────────────────
function AddBlockModal({onAdd,onClose,u,existing}){
  const [label,setLabel]=useState(existing?.label||"");
  const [embedType,setEmbedType]=useState(existing?.embedType||"youtube");
  const [content,setContent]=useState(existing?.content||"");
  const [height,setHeight]=useState(existing?.height||220);

  const TYPES=[
    {id:"youtube",  name:"YouTube"},
    {id:"spotify",  name:"Spotify"},
    {id:"soundcloud",name:"SoundCloud"},
    {id:"image",    name:"Image URL"},
    {id:"html",     name:"Custom HTML"},
  ];
  const placeholder={youtube:"https://youtu.be/...",spotify:"https://open.spotify.com/track/...",soundcloud:"https://soundcloud.com/...",image:"https://example.com/image.jpg",html:"<p>Your HTML here</p>"}[embedType]||"";
  const previewUrl=embedType!=="html"&&embedType!=="image"?getEmbedUrl(content):null;

  const submit=()=>{
    if(!content.trim())return;
    onAdd({label:label.trim()||TYPES.find(t=>t.id===embedType)?.name,embedType,content:content.trim(),height});
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:"#1a1a2e",border:"1px solid #4455aa",borderRadius:"4px",padding:"18px",maxWidth:"460px",width:"100%",fontFamily:"Verdana,sans-serif",color:"#ccd",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{fontSize:"13px",fontWeight:"bold",marginBottom:"14px",color:"#aaccff"}}>
          {existing?"✎ Edit Block":"＋ Add Custom Block"}
          <button onClick={onClose} style={{float:"right",background:"none",border:"none",color:"#aaa",fontSize:"16px",cursor:"pointer",padding:0}}>✕</button>
        </div>

        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"10px",color:"#889",marginBottom:"3px",textTransform:"uppercase",letterSpacing:"1px"}}>Block Title (optional)</div>
          <input type="text" value={label} onChange={e=>setLabel(e.target.value)} placeholder="e.g. My Favorite Song" style={{width:"100%",boxSizing:"border-box",fontSize:"12px",padding:"4px 6px",background:"#111",border:"1px solid #445",color:"#dde",borderRadius:"2px"}}/>
        </div>

        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"10px",color:"#889",marginBottom:"5px",textTransform:"uppercase",letterSpacing:"1px"}}>Type</div>
          <div style={{display:"flex",gap:"5px",flexWrap:"wrap"}}>
            {TYPES.map(t=>(
              <button key={t.id} onClick={()=>setEmbedType(t.id)} style={{background:embedType===t.id?"#334488":"#222",border:`1px solid ${embedType===t.id?"#6677cc":"#444"}`,color:embedType===t.id?"#fff":"#aaa",fontSize:"10px",padding:"3px 10px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>{t.name}</button>
            ))}
          </div>
        </div>

        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"10px",color:"#889",marginBottom:"3px",textTransform:"uppercase",letterSpacing:"1px"}}>{embedType==="html"?"HTML Content":"URL"}</div>
          {embedType==="html"?(
            <textarea value={content} onChange={e=>setContent(e.target.value)} rows={5} placeholder={placeholder} style={{width:"100%",boxSizing:"border-box",fontSize:"11px",padding:"4px 6px",background:"#111",border:"1px solid #445",color:"#dde",borderRadius:"2px",fontFamily:"monospace"}}/>
          ):(
            <input type="text" value={content} onChange={e=>setContent(e.target.value)} placeholder={placeholder} style={{width:"100%",boxSizing:"border-box",fontSize:"12px",padding:"4px 6px",background:"#111",border:"1px solid #445",color:"#dde",borderRadius:"2px"}}/>
          )}
        </div>

        {embedType!=="html"&&(
          <div style={{marginBottom:"12px"}}>
            <div style={{fontSize:"10px",color:"#889",marginBottom:"4px",textTransform:"uppercase",letterSpacing:"1px"}}>Height: {height}px</div>
            <input type="range" min={100} max={500} value={height} onChange={e=>setHeight(Number(e.target.value))} style={{width:"100%"}}/>
          </div>
        )}

        {/* Preview */}
        {content.trim()&&(embedType==="image"||previewUrl||embedType==="html")&&(
          <div style={{marginBottom:"12px",border:"1px solid #334",borderRadius:"2px",overflow:"hidden"}}>
            <div style={{fontSize:"9px",color:"#778",padding:"3px 6px",background:"#111",textTransform:"uppercase",letterSpacing:"1px"}}>Preview</div>
            {embedType==="image"&&<img src={content} alt="" style={{width:"100%",maxHeight:"160px",objectFit:"contain",display:"block",background:"#000"}}/>}
            {embedType==="html"&&<div style={{padding:"8px",fontSize:"12px",color:"#ccc",maxHeight:"120px",overflow:"auto"}} dangerouslySetInnerHTML={{__html:content}}/>}
            {previewUrl&&<iframe src={previewUrl} width="100%" height={Math.min(height,200)} frameBorder="0" allowFullScreen allow="autoplay" style={{display:"block"}}/>}
          </div>
        )}

        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{background:"#333",border:"1px solid #666",color:"#ccc",fontSize:"11px",padding:"5px 14px",cursor:"pointer",borderRadius:"2px",fontFamily:"Verdana"}}>Cancel</button>
          <button onClick={submit} disabled={!content.trim()} style={{background:content.trim()?"#334488":"#222",border:`1px solid ${content.trim()?"#6677cc":"#444"}`,color:content.trim()?"#fff":"#666",fontSize:"11px",padding:"5px 14px",cursor:content.trim()?"pointer":"default",borderRadius:"2px",fontFamily:"Verdana"}}>
            {existing?"Save Changes":"Add Block"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── LIGHTBOX ─────────────────────────────────────────────────────────────────
function Lightbox({items,startIdx,onClose}){
  const [idx,setIdx]=useState(startIdx);
  const item=items[idx]||items[0];
  useEffect(()=>{
    const h=e=>{if(e.key==="Escape")onClose();if(e.key==="ArrowLeft")setIdx(i=>Math.max(0,i-1));if(e.key==="ArrowRight")setIdx(i=>Math.min(items.length-1,i+1));};
    window.addEventListener("keydown",h);return()=>window.removeEventListener("keydown",h);
  },[]);
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={onClose}>
      <div style={{position:"relative",maxWidth:"92vw",maxHeight:"92vh",textAlign:"center"}} onClick={e=>e.stopPropagation()}>
        <button onClick={onClose} style={{position:"absolute",top:"-30px",right:0,background:"none",border:"none",color:"#fff",fontSize:"14px",cursor:"pointer",fontFamily:"Verdana"}}>✕ close</button>
        <img src={item.url} alt={item.title||""} style={{maxWidth:"88vw",maxHeight:"80vh",objectFit:"contain",display:"block",margin:"0 auto",border:"2px solid #555"}}/>
        {item.title&&<div style={{color:"#ddd",fontSize:"12px",marginTop:"6px",fontFamily:"Verdana"}}>{item.title}</div>}
        <div style={{color:"#888",fontSize:"11px",marginTop:"4px",fontFamily:"Verdana"}}>{idx+1} / {items.length}</div>
        {idx>0&&<button onClick={()=>setIdx(i=>i-1)} style={{position:"absolute",left:"-44px",top:"40%",background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:"26px",cursor:"pointer",padding:"6px 10px",borderRadius:"3px"}}>‹</button>}
        {idx<items.length-1&&<button onClick={()=>setIdx(i=>i+1)} style={{position:"absolute",right:"-44px",top:"40%",background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:"26px",cursor:"pointer",padding:"6px 10px",borderRadius:"3px"}}>›</button>}
      </div>
    </div>
  );
}

// ─── PHOTO ALBUM VIEWER ───────────────────────────────────────────────────────
function PhotoAlbumViewer({album,isOwn,onDeleteAlbum,onDeletePhoto,onUpload,uploadingTo,u,onOpenLightbox}){
  const [selIdx,setSelIdx]=useState(0);
  const fileRef=useRef();
  const photos=album.album_items||[];
  const sel=photos[Math.min(selIdx,photos.length-1)];
  useEffect(()=>{if(selIdx>=photos.length&&photos.length>0)setSelIdx(photos.length-1);},[photos.length]);

  return(
    <div style={{border:`${u.profileBorderWidth} ${u.profileBorderStyle} ${u.profileBorderColor}`,marginBottom:"8px",overflow:"hidden"}}>
      {/* Album title bar */}
      <div style={{background:u.profileHeaderBg,color:u.profileHeaderText,padding:"4px 8px",fontSize:"11px",fontWeight:"bold",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span>📷 {album.title}</span>
        <div style={{display:"flex",gap:"10px",alignItems:"center",fontSize:"10px"}}>
          {photos.length>0&&<span style={{opacity:.75}}>{photos.length} photo{photos.length!==1?"s":""}</span>}
          {isOwn&&<a style={{color:u.profileHeaderText,cursor:"pointer",textDecoration:"underline",opacity:.8}} onClick={()=>onDeleteAlbum(album.id)}>delete</a>}
        </div>
      </div>

      {photos.length===0?(
        <div style={{padding:"18px 8px",textAlign:"center",fontSize:"11px",color:u.profileTextColor,opacity:.6,background:u.profileTableBg}}>
          No photos yet.
          {isOwn&&<div style={{marginTop:"8px"}}>
            <label style={{cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline",fontSize:"11px"}}>
              + Upload Photos
              <input ref={fileRef} type="file" multiple accept="image/*" style={{display:"none"}} onChange={e=>onUpload(e,album.id)} disabled={uploadingTo===album.id}/>
            </label>
            {uploadingTo===album.id&&<span style={{marginLeft:"8px",fontSize:"10px",opacity:.7}}>Uploading...</span>}
          </div>}
        </div>
      ):(
        <>
          {/* Main image */}
          <div style={{position:"relative",background:"#111",textAlign:"center",lineHeight:0}}>
            <img src={sel.url} alt={sel.title||""} style={{maxWidth:"100%",maxHeight:"300px",objectFit:"contain",cursor:"pointer",display:"inline-block"}} onClick={()=>onOpenLightbox(album.id,selIdx)}/>
            {photos.length>1&&<>
              <button onClick={()=>setSelIdx(i=>(i-1+photos.length)%photos.length)} style={{position:"absolute",left:"6px",top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,0.55)",border:"none",color:"#fff",fontSize:"22px",cursor:"pointer",padding:"4px 10px",lineHeight:1,borderRadius:"2px"}}>‹</button>
              <button onClick={()=>setSelIdx(i=>(i+1)%photos.length)} style={{position:"absolute",right:"6px",top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,0.55)",border:"none",color:"#fff",fontSize:"22px",cursor:"pointer",padding:"4px 10px",lineHeight:1,borderRadius:"2px"}}>›</button>
            </>}
            {isOwn&&<button onClick={()=>onDeletePhoto(sel.id,album.id)} style={{position:"absolute",top:"4px",right:"4px",background:"rgba(0,0,0,0.6)",border:"none",color:"#fff",fontSize:"10px",cursor:"pointer",padding:"2px 6px",borderRadius:"2px"}}>✕ remove</button>}
          </div>

          {/* Caption + count */}
          <div style={{padding:"4px 8px",background:u.profileTableBg,fontSize:"10px",color:u.profileTextColor,display:"flex",justifyContent:"space-between",borderBottom:`1px solid ${u.profileBorderColor}`}}>
            <span style={{fontStyle:"italic",opacity:.8}}>{sel.title||""}</span>
            <span style={{opacity:.6}}>{selIdx+1} / {photos.length}</span>
          </div>

          {/* Thumbnail strip */}
          {photos.length>1&&(
            <div style={{display:"flex",gap:"3px",padding:"6px",background:u.profileTableBg,flexWrap:"wrap"}}>
              {photos.map((ph,pi)=>(
                <div key={ph.id} onClick={()=>setSelIdx(pi)} style={{width:"52px",height:"52px",flexShrink:0,cursor:"pointer",overflow:"hidden",border:pi===selIdx?`2px solid ${u.profileLinkColor}`:`1px solid ${u.profileBorderColor}`,opacity:pi===selIdx?1:.75,transition:"opacity .15s"}}>
                  <img src={ph.url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                </div>
              ))}
            </div>
          )}

          {/* Upload row */}
          {isOwn&&(
            <div style={{padding:"5px 8px",background:u.profileTableBg,borderTop:`1px solid ${u.profileBorderColor}`}}>
              <label style={{cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline",fontSize:"10px"}}>
                {uploadingTo===album.id?"Uploading...":"+ Add Photos"}
                <input ref={fileRef} type="file" multiple accept="image/*" style={{display:"none"}} onChange={e=>onUpload(e,album.id)} disabled={uploadingTo===album.id}/>
              </label>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// ─── AUDIO ALBUM PLAYER (MySpace-style) ───────────────────────────────────────
function AudioAlbumMiniPlayer({album,isOwn,onDeleteItem,onDeleteAlbum,onAddTrack,u}){
  const [idx,setIdx]=useState(0);
  const [playing,setPlaying]=useState(false);
  const [progress,setProgress]=useState(0);
  const [currTime,setCurrTime]=useState(0);
  const [dur,setDur]=useState(0);
  const [newTitle,setNewTitle]=useState("");
  const [newUrl,setNewUrl]=useState("");
  const [uploading,setUploading]=useState(false);
  const audioRef=useRef();
  const fileRef=useRef();
  const items=album.album_items||[];
  const cur=items[idx];

  useEffect(()=>{
    if(!audioRef.current)return;
    audioRef.current.pause();audioRef.current.load();
    setProgress(0);setCurrTime(0);setDur(0);
    if(playing)audioRef.current.play().catch(()=>{});
  },[idx]);

  const fmt=s=>{if(!s||isNaN(s))return"0:00";return`${Math.floor(s/60)}:${String(Math.floor(s%60)).padStart(2,"0")}`;};
  const toggle=()=>{if(!audioRef.current)return;playing?(audioRef.current.pause(),setPlaying(false)):(audioRef.current.play().catch(()=>{}),setPlaying(true));};
  const prev=()=>{setIdx(i=>(i-1+items.length)%items.length);setPlaying(false);};
  const next=()=>{setIdx(i=>(i+1)%items.length);setPlaying(false);};
  const onEnded=()=>{if(items.length>1){const n=(idx+1)%items.length;setIdx(n);setTimeout(()=>audioRef.current?.play().catch(()=>{}),100);}else setPlaying(false);};
  const onTimeUpdate=()=>{if(!audioRef.current)return;const t=audioRef.current.currentTime,d=audioRef.current.duration;setCurrTime(t);setProgress(d?t/d:0);};
  const onMeta=()=>{if(audioRef.current)setDur(audioRef.current.duration);};
  const seek=e=>{if(!audioRef.current||!audioRef.current.duration)return;const r=e.currentTarget.getBoundingClientRect();audioRef.current.currentTime=(e.clientX-r.left)/r.width*audioRef.current.duration;};

  const handleFileUpload=async(e)=>{
    const file=e.target.files?.[0]; if(!file)return;
    const ext=file.name.split('.').pop().toLowerCase();
    if(!["mp3","ogg","wav","flac","m4a","aac","webm"].includes(ext)){alert("Supported: mp3, ogg, wav, flac, m4a, aac");return;}
    if(file.size>20*1024*1024){alert("Max 20MB");return;}
    setUploading(true);
    try{
      const path=`albums/${album.id}/${Date.now()}.${ext}`;
      const url=await uploadFile(file,path);
      const title=newTitle.trim()||file.name.replace(/\.[^.]+$/,"");
      await onAddTrack(album.id,url,title,items.length);
      setNewTitle("");setNewUrl("");
    }catch(err){alert("Upload failed: "+err.message);}
    setUploading(false);if(fileRef.current)fileRef.current.value="";
  };
  const handleUrlAdd=async()=>{
    if(!newUrl.trim())return;
    try{await onAddTrack(album.id,newUrl.trim(),newTitle.trim()||newUrl.trim(),items.length);setNewTitle("");setNewUrl("");}
    catch(err){alert("Failed: "+err.message);}
  };

  // Classic MySpace-style player palette
  const P={
    outerBg:"linear-gradient(180deg,#4a4a4a 0%,#2c2c2c 40%,#1a1a1a 100%)",
    innerBg:"linear-gradient(180deg,#1c1c1c 0%,#111 100%)",
    border:"#555",
    headerBg:"linear-gradient(180deg,#3a3a3a,#222)",
    accent:"#c9e84b",
    accentDim:"#8aaa22",
    trackActive:"rgba(180,220,60,0.12)",
    text:"#ddd",
    subtext:"#888",
    btnBg:"linear-gradient(180deg,#555 0%,#333 100%)",
    btnBorder:"#666",
    playBtnBg:"linear-gradient(180deg,#4a5a10 0%,#2a3408 100%)",
    playBtnBorder:"#7a9a20",
  };

  return(
    <div style={{border:"2px solid #555",borderRadius:"4px",marginBottom:"8px",overflow:"hidden",background:P.outerBg,boxShadow:"0 2px 6px rgba(0,0,0,0.7)",fontFamily:"Verdana,Arial,sans-serif"}}>
      {/* MySpace-style header bar */}
      <div style={{background:P.headerBg,borderBottom:"1px solid #555",padding:"4px 8px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{color:"#c9e84b",fontSize:"10px",fontWeight:"bold",letterSpacing:"1px",textTransform:"uppercase"}}>▶ {album.title}</span>
        {isOwn&&<a style={{color:"#aaa",fontSize:"9px",cursor:"pointer",textDecoration:"underline"}} onClick={()=>onDeleteAlbum(album.id)}>delete</a>}
      </div>

      {/* Player body */}
      <div style={{padding:"10px 10px 8px",background:P.innerBg}}>
        <audio ref={audioRef} src={cur?.url} onEnded={onEnded} onTimeUpdate={onTimeUpdate} onLoadedMetadata={onMeta} style={{display:"none"}}/>

        {items.length===0?(
          <div style={{color:P.subtext,fontSize:"11px",textAlign:"center",padding:"8px 0"}}>No tracks yet.</div>
        ):<>
          {/* Now playing strip */}
          <div style={{background:"linear-gradient(90deg,#2a2a2a,#1a1a1a)",border:"1px solid #444",borderRadius:"2px",padding:"5px 8px",marginBottom:"8px"}}>
            <div style={{color:P.accentDim,fontSize:"9px",textTransform:"uppercase",letterSpacing:"1px",marginBottom:"2px"}}>Now Playing</div>
            <div style={{color:"#fff",fontSize:"12px",fontWeight:"bold",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{cur?.title||`Track ${idx+1}`}</div>
            <div style={{color:P.subtext,fontSize:"9px",marginTop:"1px"}}>{idx+1} of {items.length}</div>
          </div>

          {/* Progress bar */}
          <div onClick={seek} style={{background:"#222",border:"1px solid #444",height:"6px",borderRadius:"1px",cursor:"pointer",marginBottom:"3px",position:"relative"}}>
            <div style={{background:`linear-gradient(90deg,${P.accentDim},${P.accent})`,height:"100%",borderRadius:"1px",width:`${progress*100}%`,transition:"width 0.15s linear",pointerEvents:"none"}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",color:P.subtext,fontSize:"9px",marginBottom:"9px"}}>
            <span>{fmt(currTime)}</span><span>{fmt(dur)}</span>
          </div>

          {/* Controls — classic MySpace layout */}
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"4px",marginBottom:"9px"}}>
            <button onClick={prev} disabled={items.length<2} title="Previous"
              style={{background:P.btnBg,border:`1px solid ${P.btnBorder}`,color:items.length<2?"#555":"#ccc",fontSize:"11px",cursor:items.length<2?"default":"pointer",padding:"4px 10px",borderRadius:"2px",fontFamily:"Verdana",boxShadow:"inset 0 1px 0 rgba(255,255,255,0.08)"}}>
              ◄◄
            </button>
            <button onClick={toggle} title={playing?"Pause":"Play"}
              style={{background:P.playBtnBg,border:`1px solid ${P.playBtnBorder}`,color:P.accent,fontSize:"14px",cursor:"pointer",padding:"5px 16px",borderRadius:"2px",fontFamily:"Verdana",minWidth:"54px",fontWeight:"bold",boxShadow:"inset 0 1px 0 rgba(255,255,255,0.1),0 1px 3px rgba(0,0,0,0.5)"}}>
              {playing?"■ STOP":"► PLAY"}
            </button>
            <button onClick={next} disabled={items.length<2} title="Next"
              style={{background:P.btnBg,border:`1px solid ${P.btnBorder}`,color:items.length<2?"#555":"#ccc",fontSize:"11px",cursor:items.length<2?"default":"pointer",padding:"4px 10px",borderRadius:"2px",fontFamily:"Verdana",boxShadow:"inset 0 1px 0 rgba(255,255,255,0.08)"}}>
              ►►
            </button>
          </div>

          {/* Track list */}
          <div style={{borderTop:"1px solid #333",paddingTop:"6px"}}>
            {items.map((t,i)=>(
              <div key={t.id} onClick={()=>{setIdx(i);setPlaying(false);}} style={{display:"flex",alignItems:"center",gap:"6px",padding:"3px 5px",cursor:"pointer",background:i===idx?P.trackActive:"transparent",borderBottom:"1px solid #222"}}>
                <span style={{color:i===idx?P.accent:"#555",fontSize:"9px",width:"16px",flexShrink:0,textAlign:"right",fontWeight:"bold"}}>{i===idx?"▶":i+1}</span>
                <span style={{flex:1,color:i===idx?"#fff":P.text,fontSize:"11px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.title||`Track ${i+1}`}</span>
                {isOwn&&<a style={{color:"#cc4444",fontSize:"9px",cursor:"pointer",flexShrink:0,opacity:.8}} onClick={e=>{e.stopPropagation();onDeleteItem(t.id,album.id,i,idx,setIdx);}}>✕</a>}
              </div>
            ))}
          </div>
        </>}
      </div>

      {/* Add track */}
      {isOwn&&<div style={{padding:"7px 8px",background:u.profileTableBg,borderTop:`1px solid ${u.profileBorderColor}`}}>
        <div style={{fontSize:"10px",color:u.profileTextColor,fontWeight:"bold",marginBottom:"4px"}}>Add Track:</div>
        <input type="text" value={newTitle} onChange={e=>setNewTitle(e.target.value)} placeholder="Title (optional)" style={{width:"100%",marginBottom:"4px",fontSize:"11px",fontFamily:u.profileFont,boxSizing:"border-box"}}/>
        <div style={{display:"flex",gap:"4px",alignItems:"center",marginBottom:"5px"}}>
          <input type="text" value={newUrl} onChange={e=>setNewUrl(e.target.value)} placeholder="Paste audio URL..." style={{flex:1,fontSize:"11px",fontFamily:u.profileFont}}/>
          <input type="submit" value="Add URL" onClick={handleUrlAdd} style={{fontSize:"10px",padding:"2px 6px",whiteSpace:"nowrap"}}/>
        </div>
        <label style={{cursor:"pointer",color:u.profileLinkColor,textDecoration:"underline",fontSize:"10px"}}>
          {uploading?"Uploading...":"📁 Upload from device"}
          <input ref={fileRef} type="file" style={{display:"none"}} onChange={handleFileUpload} disabled={uploading}/>
        </label>
      </div>}
    </div>
  );
}

// ─── AUDIO ALBUM PLAYER ───────────────────────────────────────────────────────
function AudioAlbumPlayer({tracks,u,tS,tdS}){
  const [currentIdx,setCurrentIdx]=useState(0);
  const [isPlaying,setIsPlaying]=useState(false);
  const audioRef=useRef(null);

  useEffect(()=>{
    if(!audioRef.current)return;
    audioRef.current.pause();
    audioRef.current.load();
    if(isPlaying)audioRef.current.play().catch(()=>{});
  },[currentIdx]);

  const togglePlay=()=>{
    if(!audioRef.current)return;
    if(isPlaying){audioRef.current.pause();setIsPlaying(false);}
    else{audioRef.current.play().catch(()=>{});setIsPlaying(true);}
  };
  const goPrev=()=>setCurrentIdx(i=>(i-1+tracks.length)%tracks.length);
  const goNext=()=>setCurrentIdx(i=>(i+1)%tracks.length);
  const onEnded=()=>{ const n=(currentIdx+1)%tracks.length; setCurrentIdx(n); setTimeout(()=>audioRef.current?.play().catch(()=>{}),50); };
  const track=tracks[currentIdx];

  const btnS={background:"none",border:`1px solid ${u.profileBorderColor}`,color:u.profileTextColor,cursor:"pointer",padding:"2px 8px",fontFamily:u.profileFont,fontSize:"12px"};

  return(
    <><table style={tS}><tbody>
      <tr><td style={{...tdS,background:u.profileHeaderBg,color:u.profileHeaderText,fontSize:"12px",fontWeight:"bold"}}>🎵 My Music</td></tr>
      <tr><td style={tdS}>
        <audio ref={audioRef} src={track?.url} onEnded={onEnded}/>
        <div style={{marginBottom:"6px"}}>
          {tracks.map((t,i)=>(
            <div key={t.id} onClick={()=>{ if(i===currentIdx){togglePlay();}else{setCurrentIdx(i);setIsPlaying(true);setTimeout(()=>audioRef.current?.play().catch(()=>{}),50);} }}
              style={{fontSize:"11px",padding:"3px 5px",cursor:"pointer",borderRadius:"2px",marginBottom:"1px",
                background:i===currentIdx?u.profileHeaderBg:"transparent",
                color:i===currentIdx?u.profileHeaderText:u.profileTextColor}}>
              <span style={{marginRight:"5px",fontSize:"10px"}}>{i===currentIdx?(isPlaying?"▶":"▐▐"):"♪"}</span>{t.title}
            </div>
          ))}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:"4px"}}>
          <button style={btnS} onClick={goPrev}>⏮</button>
          <button style={btnS} onClick={togglePlay}>{isPlaying?"⏸":"▶"}</button>
          <button style={btnS} onClick={goNext}>⏭</button>
          <span style={{fontSize:"10px",color:u.profileTextColor,opacity:.7,marginLeft:"4px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:"120px"}}>{track?.title}</span>
        </div>
      </td></tr>
    </tbody></table><br/></>
  );
}

// ─── BLOCK STYLE MODAL ───────────────────────────────────────────────────────
function BlockStyleModal({section,si,u,onSave,onClose}){
  const bs=section.blockStyle||{};
  const [headerBg,setHeaderBg]=useState(bs.headerBg||u.profileHeaderBg);
  const [headerText,setHeaderText]=useState(bs.headerText||u.profileHeaderText);
  const [bodyBg,setBodyBg]=useState(bs.bodyBg||u.profileTableBg);
  const [borderColor,setBorderColor]=useState(bs.borderColor||u.profileBorderColor);
  const [borderStyle,setBorderStyle]=useState(bs.borderStyle||u.profileBorderStyle||"solid");
  const [borderWidth,setBorderWidth]=useState(bs.borderWidth||u.profileBorderWidth||"1px");
  const [bgImage,setBgImage]=useState(bs.bgImage||"");
  const [bgImgUploading,setBgImgUploading]=useState(false);
  const bgImgRef=useRef();
  const handleBgImageUpload=async(e)=>{
    const file=e.target.files?.[0];if(!file)return;
    setBgImgUploading(true);
    try{
      const path=`block-bg/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g,"_")}`;
      const url=await uploadMedia(await new Promise((res,rej)=>{const r=new FileReader();r.onload=ev=>res(ev.target.result);r.onerror=rej;r.readAsDataURL(file);}),path);
      if(url)setBgImage(url);
    }catch(err){alert("Upload failed: "+err.message);}
    setBgImgUploading(false);
    if(bgImgRef.current)bgImgRef.current.value="";
  };

  const modalStyle={position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"};
  const boxStyle={background:"#111122",border:"2px solid #5544aa",borderRadius:"6px",padding:"16px",width:"min(420px,96vw)",fontFamily:"Verdana,sans-serif",color:"#ccbbff"};
  const rowS={marginBottom:"10px"};const lblS={fontSize:"10px",color:"#aaa",marginBottom:"3px",display:"block"};
  const inpS={background:"#1a1a2e",border:"1px solid #554488",color:"#ddd",padding:"4px 6px",fontSize:"11px",borderRadius:"2px"};
  const clrRow=(label,val,set)=>(
    <div style={rowS}><label style={lblS}>{label}</label>
      <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
        <input type="color" value={val} onChange={e=>set(e.target.value)} style={{width:"32px",height:"26px",border:"1px solid #554",padding:0,cursor:"pointer"}}/>
        <input type="text" value={val} onChange={e=>set(e.target.value)} style={{...inpS,width:"80px"}}/>
      </div>
    </div>
  );

  return(
    <div style={modalStyle} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={boxStyle}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"12px"}}>
          <span style={{fontWeight:"bold",fontSize:"13px"}}>🎨 Style: {section.label||section.id}</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#aaa",cursor:"pointer",fontSize:"16px"}}>✕</button>
        </div>

        {/* Preview */}
        <div style={{marginBottom:"12px",border:`${borderWidth} ${borderStyle} ${borderColor}`,borderRadius:"2px",overflow:"hidden"}}>
          <div style={{background:headerBg,color:headerText,padding:"5px 8px",fontSize:"12px",fontWeight:"bold"}}>{section.label||section.id}</div>
          <div style={{background:bodyBg,padding:"8px",fontSize:"11px",color:u.profileTextColor}}>Sample block content</div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
          {clrRow("Header background",headerBg,setHeaderBg)}
          {clrRow("Header text",headerText,setHeaderText)}
          {clrRow("Body background",bodyBg,setBodyBg)}
          {clrRow("Border color",borderColor,setBorderColor)}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"12px"}}>
          <div><label style={lblS}>Border style</label>
            <select value={borderStyle} onChange={e=>setBorderStyle(e.target.value)} style={{...inpS,width:"100%"}}>
              {["solid","dashed","dotted","double","groove","ridge","inset","outset"].map(s=><option key={s}>{s}</option>)}
            </select></div>
          <div><label style={lblS}>Border width</label>
            <select value={borderWidth} onChange={e=>setBorderWidth(e.target.value)} style={{...inpS,width:"100%"}}>
              {["0px","1px","2px","3px","4px","5px"].map(s=><option key={s}>{s}</option>)}
            </select></div>
        </div>

        {/* Background image */}
        <div style={{marginBottom:"12px"}}>
          <label style={lblS}>Block background image (optional)</label>
          {bgImage&&<div style={{marginBottom:"6px",border:"1px solid #443366",borderRadius:"3px",overflow:"hidden",maxHeight:"70px"}}>
            <img src={bgImage} alt="bg preview" style={{width:"100%",maxHeight:"70px",objectFit:"cover",display:"block"}}/>
          </div>}
          <input type="text" value={bgImage} onChange={e=>setBgImage(e.target.value)} style={{...inpS,width:"100%",marginBottom:"4px"}} placeholder="Image URL…"/>
          <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
            <input ref={bgImgRef} type="file" accept="image/*" onChange={handleBgImageUpload} style={{fontSize:"10px",color:"#ccc",flex:1}}/>
            {bgImgUploading&&<span style={{fontSize:"10px",color:"#88aaff"}}>Uploading…</span>}
            {bgImage&&<button onClick={()=>setBgImage("")} style={{background:"#400",border:"1px solid #f44",color:"#faa",fontSize:"10px",padding:"2px 6px",cursor:"pointer",borderRadius:"2px"}}>✕ Remove</button>}
          </div>
        </div>

        <div style={{display:"flex",gap:"8px",justifyContent:"space-between"}}>
          <button onClick={()=>onSave(si,{headerBg:u.profileHeaderBg,headerText:u.profileHeaderText,bodyBg:u.profileTableBg,borderColor:u.profileBorderColor,borderStyle:u.profileBorderStyle,borderWidth:u.profileBorderWidth,bgImage:""})} style={{background:"#222",border:"1px solid #555",color:"#aaa",fontSize:"10px",padding:"4px 10px",cursor:"pointer",borderRadius:"3px"}}>Reset to defaults</button>
          <div style={{display:"flex",gap:"8px"}}>
            <button onClick={onClose} style={{background:"#333",border:"1px solid #555",color:"#ccc",fontSize:"11px",padding:"4px 12px",cursor:"pointer",borderRadius:"3px"}}>Cancel</button>
            <button onClick={()=>onSave(si,{headerBg,headerText,bodyBg,borderColor,borderStyle,borderWidth,bgImage:bgImage||""})} style={{background:"#5533cc",border:"1px solid #8866ff",color:"#fff",fontSize:"11px",padding:"4px 12px",cursor:"pointer",borderRadius:"3px"}}>Apply</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── ADD FLOAT MODAL ─────────────────────────────────────────────────────────
const FLOAT_FONTS=["Impact, Arial Black, sans-serif","'Comic Sans MS', cursive","'Courier New', monospace","'Georgia', serif","Verdana, sans-serif","Arial, sans-serif","'Times New Roman', serif","Tahoma, sans-serif"];
const FLOAT_EFFECTS=[
  {id:"none",    label:"None (solid)"},
  {id:"flash",   label:"Flash / Strobe"},
  {id:"fade",    label:"Fade in/out"},
  {id:"rainbow", label:"Rainbow cycle"},
];
function AddFloatModal({onAdd,onClose,existing,loadMedia}){
  // Tab: 'text' or 'image'
  const [tab,setTab]=useState(existing?.floatType==="image"?"image":"text");
  // --- Text float state ---
  const [text,setText]=useState(existing?.text||"Hello! ✨");
  const [fontSize,setFontSize]=useState(existing?.fontSize||26);
  const [fontFamily,setFontFamily]=useState(existing?.fontFamily||FLOAT_FONTS[0]);
  const [bold,setBold]=useState(existing?.bold!==undefined?existing.bold:false);
  const [italic,setItalic]=useState(existing?.italic||false);
  const [color1,setColor1]=useState(existing?.color1||"#ff00ff");
  const [color2,setColor2]=useState(existing?.color2||"#00ffff");
  const [effect,setEffect]=useState(()=>{
    if(!existing)return"flash";
    if(existing.rainbow)return"rainbow";
    if(existing.flashOpacity===0||existing.flashOpacity<1)return"fade";
    if(existing.color2&&existing.flashSpeed>0)return"flash";
    return"none";
  });
  const [flashSpeed,setFlashSpeed]=useState(existing?.flashSpeed||400);
  const [glow,setGlow]=useState(existing?.glow||false);
  const [bg,setBg]=useState(existing?.bg||"");
  const [rotation,setRotation]=useState(existing?.rotation||0);
  const [shadow,setShadow]=useState(existing?.shadow!==undefined?existing.shadow:true);
  // --- Image float state ---
  const [imgSrc,setImgSrc]=useState(existing?.src||"");
  const [imgCaption,setImgCaption]=useState(existing?.caption||"");
  const [imgFit,setImgFit]=useState(existing?.fit||"cover");
  const [imgBorderRadius,setImgBorderRadius]=useState(existing?.borderRadius||0);
  const [imgBorder,setImgBorder]=useState(existing?.border||"none");
  const [imgUploading,setImgUploading]=useState(false);
  const imgFileRef=useRef();

  // Compute animation style for preview
  const previewId="prev"+Date.now();
  const hasAnim=effect!=="none";
  let animStyle={};
  let keyframeCss="";
  if(effect==="flash"){
    keyframeCss=`@keyframes pfsh{0%,100%{color:${color1};}50%{color:${color2};}}`;
    animStyle={animation:`pfsh ${flashSpeed}ms infinite`};
  } else if(effect==="fade"){
    keyframeCss=`@keyframes pfade{0%,100%{color:${color1};opacity:1;}50%{color:${color2};opacity:0;}}`;
    animStyle={animation:`pfade ${flashSpeed}ms infinite`};
  } else if(effect==="rainbow"){
    keyframeCss=`@keyframes pbow{0%{color:#ff0000;}14%{color:#ff8800;}28%{color:#ffff00;}42%{color:#00ff00;}57%{color:#0088ff;}71%{color:#8800ff;}85%{color:#ff00ff;}100%{color:#ff0000;}}`;
    animStyle={animation:`pbow ${flashSpeed*5}ms linear infinite`};
  }

  const spS={display:"block",fontSize,fontFamily,fontWeight:bold?"bold":"normal",fontStyle:italic?"italic":"normal",
    color:color1,textShadow:glow?`0 0 10px ${color1},0 0 22px ${color1}`:shadow?"1px 1px 3px rgba(0,0,0,.6)":"none",
    background:bg||"transparent",padding:bg?"4px 10px":"0",borderRadius:bg?"4px":"0",
    transform:`rotate(${rotation}deg)`,display:"inline-block",whiteSpace:"pre-wrap",...animStyle};

  const handleSave=()=>{
    if(tab==="image"){
      if(!imgSrc.trim())return alert("Enter an image URL or upload an image");
      onAdd({floatType:"image",src:imgSrc.trim(),caption:imgCaption,fit:imgFit,borderRadius:imgBorderRadius,border:imgBorder,width:200,height:150});
      return;
    }
    if(!text.trim())return alert("Enter some text");
    const isFlash=effect==="flash";const isFade=effect==="fade";const isRainbow=effect==="rainbow";
    onAdd({
      text:text.trim(),fontSize,fontFamily,bold,italic,color1,
      color2:hasAnim&&!isRainbow?color2:null,
      flashSpeed:hasAnim?flashSpeed:0,
      flashOpacity:isFade?0:1,
      rainbow:isRainbow,
      glow,bg:bg||null,rotation,shadow,
    });
  };
  const handleImgUpload=async(e)=>{
    const file=e.target.files?.[0];if(!file)return;
    setImgUploading(true);
    try{
      const path=`floats/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g,"_")}`;
      const url=await uploadMedia(await new Promise((res,rej)=>{const r=new FileReader();r.onload=ev=>res(ev.target.result);r.onerror=rej;r.readAsDataURL(file);}),path);
      if(url)setImgSrc(url);
    }catch(err){alert("Upload failed: "+err.message);}
    setImgUploading(false);
    if(imgFileRef.current)imgFileRef.current.value="";
  };

  const modalStyle={position:"fixed",inset:0,background:"rgba(0,0,0,.75)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"};
  const boxStyle={background:"#111122",border:"2px solid #6644aa",borderRadius:"6px",padding:"16px",width:"min(500px,96vw)",maxHeight:"90vh",overflowY:"auto",fontFamily:"Verdana,sans-serif",color:"#ccbbff"};
  const rowS={marginBottom:"8px"};const lblS={fontSize:"10px",color:"#aaa",marginBottom:"2px",display:"block"};
  const inpS={width:"100%",background:"#1a1a2e",border:"1px solid #554488",color:"#ddd",padding:"4px 6px",fontSize:"11px",borderRadius:"2px",boxSizing:"border-box"};
  const btnS={padding:"4px 14px",fontSize:"11px",cursor:"pointer",borderRadius:"3px",border:"none"};

  return(
    <div style={modalStyle} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={boxStyle}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"10px"}}>
          <span style={{fontWeight:"bold",fontSize:"13px"}}>✦ {existing?"Edit":"Add"} Overlay</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#aaa",cursor:"pointer",fontSize:"16px"}}>✕</button>
        </div>

        {/* Tab bar */}
        <div style={{display:"flex",gap:"6px",marginBottom:"12px"}}>
          {["text","image"].map(t=>(
            <button key={t} onClick={()=>setTab(t)} style={{flex:1,padding:"5px",fontSize:"11px",cursor:"pointer",borderRadius:"3px",
              background:tab===t?"#5533cc":"#1a1a2e",border:tab===t?"1px solid #8866ff":"1px solid #443366",
              color:tab===t?"#fff":"#aaa",fontWeight:tab===t?"bold":"normal"}}>
              {t==="text"?"💬 Text":"🖼 Image"}
            </button>
          ))}
        </div>

        {tab==="text"&&<>
        {/* Live preview */}
        <div style={{background:"#000018",border:"1px solid #443366",borderRadius:"4px",padding:"20px",minHeight:"60px",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:"12px",overflow:"hidden",position:"relative"}}>
          {keyframeCss&&<style>{keyframeCss}</style>}
          <span style={spS}>{text||"preview"}</span>
        </div>

        <div style={rowS}><label style={lblS}>Text</label>
          <textarea value={text} onChange={e=>setText(e.target.value)} rows={2} style={{...inpS,resize:"vertical"}} placeholder="Your text here..."/></div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"8px"}}>
          <div><label style={lblS}>Font</label>
            <select value={fontFamily} onChange={e=>setFontFamily(e.target.value)} style={inpS}>
              {FLOAT_FONTS.map(f=><option key={f} value={f} style={{fontFamily:f}}>{f.split(",")[0].replace(/['"]/g,"")}</option>)}
            </select></div>
          <div><label style={lblS}>Size: {fontSize}px</label>
            <input type="range" min={10} max={80} value={fontSize} onChange={e=>setFontSize(+e.target.value)} style={{width:"100%"}}/></div>
        </div>

        <div style={{display:"flex",gap:"12px",marginBottom:"8px",alignItems:"center"}}>
          <label style={{fontSize:"11px",cursor:"pointer",display:"flex",gap:"4px",alignItems:"center"}}><input type="checkbox" checked={bold} onChange={e=>setBold(e.target.checked)}/> Bold</label>
          <label style={{fontSize:"11px",cursor:"pointer",display:"flex",gap:"4px",alignItems:"center"}}><input type="checkbox" checked={italic} onChange={e=>setItalic(e.target.checked)}/> Italic</label>
          <label style={{fontSize:"11px",cursor:"pointer",display:"flex",gap:"4px",alignItems:"center"}}><input type="checkbox" checked={glow} onChange={e=>setGlow(e.target.checked)}/> Glow</label>
          <label style={{fontSize:"11px",cursor:"pointer",display:"flex",gap:"4px",alignItems:"center"}}><input type="checkbox" checked={shadow} onChange={e=>setShadow(e.target.checked)}/> Shadow</label>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"8px"}}>
          <div><label style={lblS}>Color 1 (base)</label>
            <div style={{display:"flex",gap:"4px"}}>
              <input type="color" value={color1} onChange={e=>setColor1(e.target.value)} style={{width:"32px",height:"26px",border:"1px solid #554",padding:0,cursor:"pointer"}}/>
              <input type="text" value={color1} onChange={e=>setColor1(e.target.value)} style={{...inpS,flex:1}}/>
            </div></div>
          <div><label style={lblS}>Color 2 (for flash/fade)</label>
            <div style={{display:"flex",gap:"4px"}}>
              <input type="color" value={color2} onChange={e=>setColor2(e.target.value)} style={{width:"32px",height:"26px",border:"1px solid #554",padding:0,cursor:"pointer"}}/>
              <input type="text" value={color2} onChange={e=>setColor2(e.target.value)} style={{...inpS,flex:1}}/>
            </div></div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"8px"}}>
          <div><label style={lblS}>Animation</label>
            <select value={effect} onChange={e=>setEffect(e.target.value)} style={inpS}>
              {FLOAT_EFFECTS.map(e=><option key={e.id} value={e.id}>{e.label}</option>)}
            </select></div>
          {effect!=="none"&&<div><label style={lblS}>Speed: {flashSpeed}ms</label>
            <input type="range" min={100} max={2000} step={50} value={flashSpeed} onChange={e=>setFlashSpeed(+e.target.value)} style={{width:"100%"}}/></div>}
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"12px"}}>
          <div><label style={lblS}>Background (optional)</label>
            <div style={{display:"flex",gap:"4px"}}>
              <input type="color" value={bg||"#000000"} onChange={e=>setBg(e.target.value)} style={{width:"32px",height:"26px",border:"1px solid #554",padding:0,cursor:"pointer"}}/>
              <input type="text" value={bg} onChange={e=>setBg(e.target.value)} style={{...inpS,flex:1}} placeholder="none"/>
            </div></div>
          <div><label style={lblS}>Rotation: {rotation}°</label>
            <input type="range" min={-45} max={45} value={rotation} onChange={e=>setRotation(+e.target.value)} style={{width:"100%"}}/></div>
        </div>
        </>}

        {tab==="image"&&<>
          {/* Image preview */}
          {imgSrc&&<div style={{marginBottom:"10px",textAlign:"center",border:"1px solid #443366",borderRadius:"4px",overflow:"hidden",maxHeight:"140px"}}>
            <img src={imgSrc} alt="preview" style={{maxWidth:"100%",maxHeight:"140px",objectFit:"contain",display:"block",margin:"0 auto"}}/>
          </div>}
          <div style={rowS}><label style={lblS}>Image URL</label>
            <input type="text" value={imgSrc} onChange={e=>setImgSrc(e.target.value)} style={inpS} placeholder="https://..."/></div>
          <div style={{marginBottom:"10px"}}>
            <label style={lblS}>Or upload from device</label>
            <input ref={imgFileRef} type="file" accept="image/*" onChange={handleImgUpload} style={{fontSize:"10px",color:"#ccc"}}/>
            {imgUploading&&<span style={{fontSize:"10px",color:"#88aaff",marginLeft:"6px"}}>Uploading…</span>}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"10px"}}>
            <div><label style={lblS}>Fit</label>
              <select value={imgFit} onChange={e=>setImgFit(e.target.value)} style={inpS}>
                <option value="cover">Cover (fill)</option>
                <option value="contain">Contain (letterbox)</option>
                <option value="fill">Stretch</option>
                <option value="none">None (natural size)</option>
              </select></div>
            <div><label style={lblS}>Corner radius: {imgBorderRadius}px</label>
              <input type="range" min={0} max={50} value={imgBorderRadius} onChange={e=>setImgBorderRadius(+e.target.value)} style={{width:"100%"}}/></div>
          </div>
          <div style={rowS}><label style={lblS}>Caption (alt text)</label>
            <input type="text" value={imgCaption} onChange={e=>setImgCaption(e.target.value)} style={inpS} placeholder="optional caption…"/></div>
          <div style={rowS}><label style={lblS}>Border (CSS, optional)</label>
            <input type="text" value={imgBorder==="none"?"":imgBorder} onChange={e=>setImgBorder(e.target.value||"none")} style={inpS} placeholder="e.g. 2px solid #ff00cc"/></div>
        </>}

        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end",marginTop:"8px"}}>
          <button onClick={onClose} style={{...btnS,background:"#333",color:"#ccc",border:"1px solid #555"}}>Cancel</button>
          <button onClick={handleSave} style={{...btnS,background:"#6633cc",color:"#fff",border:"1px solid #9966ff"}}>{existing?"Save Changes":"Add to Profile"}</button>
        </div>
      </div>
    </div>
  );
}

// ─── EDIT PROFILE ─────────────────────────────────────────────────────────────
const PROFILE_PRESETS=[
  {name:"Default",          bg:"#ffffff",hBg:"#336699",hTx:"#ffffff",tx:"#000000",link:"#0000cc",border:"#336699",bStyle:"solid",bWidth:"1px",tBg:"#f0f5ff",font:"Verdana, Arial, sans-serif"},
  {name:"Emo/Dark",         bg:"#000000",hBg:"#220022",hTx:"#ff00ff",tx:"#ff00ff",link:"#00ffff",border:"#9900cc",bStyle:"dashed",bWidth:"2px",tBg:"rgba(20,0,30,0.8)",font:"'Comic Sans MS', cursive"},
  {name:"Hacker",           bg:"#111111",hBg:"#001100",hTx:"#00ff00",tx:"#00ff00",link:"#00cc00",border:"#00aa00",bStyle:"solid",bWidth:"1px",tBg:"rgba(0,20,0,0.9)",font:"'Courier New', monospace"},
  {name:"Y2K Pink",         bg:"#ffccff",hBg:"#ff66cc",hTx:"#ffffff",tx:"#990066",link:"#cc0099",border:"#ff00cc",bStyle:"double",bWidth:"3px",tBg:"rgba(255,204,255,0.7)",font:"'Comic Sans MS', cursive"},
  {name:"Ocean Blue",       bg:"#003366",hBg:"#001133",hTx:"#aaddff",tx:"#cceeff",link:"#66ccff",border:"#0066cc",bStyle:"solid",bWidth:"1px",tBg:"rgba(0,30,60,0.8)",font:"Verdana, sans-serif"},
  {name:"Notebook",         bg:"#ffffee",hBg:"#cccc99",hTx:"#333300",tx:"#333333",link:"#0000cc",border:"#999966",bStyle:"solid",bWidth:"1px",tBg:"#fffff5",font:"'Courier New', monospace"},
  {name:"Blood Red",        bg:"#1a0000",hBg:"#440000",hTx:"#ff4444",tx:"#ffaaaa",link:"#ff6666",border:"#880000",bStyle:"solid",bWidth:"2px",tBg:"rgba(40,0,0,0.9)",font:"Verdana, sans-serif"},
  {name:"Glitter Princess", bg:"#220033",hBg:"#440066",hTx:"#ffffff",tx:"#ffaaff",link:"#ff55ff",border:"#ff00cc",bStyle:"double",bWidth:"3px",tBg:"rgba(40,0,60,0.85)",font:"'Georgia', serif"},
];
const FONT_OPTIONS=["Verdana, Arial, sans-serif","'Comic Sans MS', cursive","'Courier New', monospace","'Georgia', serif","'Times New Roman', serif","Arial, sans-serif","Tahoma, sans-serif","Impact, sans-serif"];

function EditProfileView({nav,me,onSave,loadMedia,saveMedia}){
  const [bio,setBio]=useState(me?.bio||"");const [mood,setMood]=useState(me?.mood||"");
  const [song,setSong]=useState(me?.song||"");const [ints,setInts]=useState(me?.interests||"");
  const [status,setStatus]=useState(me?.status||"online");const [headline,setHeadline]=useState(me?.headline||"");
  const [aboutTitle,setAboutTitle]=useState(me?.aboutTitle||"About Me");const [wiwm,setWiwm]=useState(me?.whoIWantToMeet||"");
  const [location,setLocation]=useState(me?.location||"");
  const [favMovies,setFavMovies]=useState(me?.favoriteMovies||"");
  const [favMusic,setFavMusic]=useState(me?.favoriteMusic||"");
  const [favTV,setFavTV]=useState(me?.favoriteTVShow||"");
  const [favQuote,setFavQuote]=useState(me?.favoriteQuote||"");
  const [audioTracks,setAudioTracks]=useState(me?.audioTracks||[]);
  const [audioTitle,setAudioTitle]=useState("");const [uploadingAudio,setUploadingAudio]=useState(false);
  const audioFileRef=useRef();
  const [bgMusicUrl,setBgMusicUrl]=useState(me?.bgMusicUrl||"");
  const [blinkies,setBlinkies]=useState(me?.blinkies||[]);const [newBlink,setNewBlink]=useState("");
  const [topFriends,setTopFriends]=useState((me?.topFriends||[]).join(","));
  const [pbg,setPbg]=useState(me?.profileBg||"#ffffff");const [phBg,setPhBg]=useState(me?.profileHeaderBg||"#336699");
  const [phTx,setPhTx]=useState(me?.profileHeaderText||"#ffffff");const [ptx,setPtx]=useState(me?.profileTextColor||"#000000");
  const [plnk,setPlnk]=useState(me?.profileLinkColor||"#0000cc");const [pbrd,setPbrd]=useState(me?.profileBorderColor||"#336699");
  const [pbrs,setPbrs]=useState(me?.profileBorderStyle||"solid");const [pbrw,setPbrw]=useState(me?.profileBorderWidth||"1px");
  const [ptbg,setPtbg]=useState(me?.profileTableBg||"#f0f5ff");const [pfont,setPfont]=useState(me?.profileFont||"Verdana, Arial, sans-serif");
  const [bgImageUrl,setBgImageUrl]=useState(me?.profileBgImage||"");
  const [bannerImageUrl,setBannerImageUrl]=useState(me?.profileBannerImage||"");
  const [uploadingBg,setUploadingBg]=useState(false);const [uploadingBanner,setUploadingBanner]=useState(false);
  const bgImgRef=useRef();const bannerImgRef=useRef();
  const [newPhoto,setNewPhoto]=useState(null);const [photoPreview,setPhotoPreview]=useState(null);const [saving,setSaving]=useState(false);
  const fileRef=useRef();

  useEffect(()=>{ if(me?.photoKey)loadMedia(me.photoKey).then(d=>d&&setPhotoPreview(d)); },[me?.photoKey]);
  if(!me)return<div className="content"><a onClick={()=>nav("login")}>Login</a> first.</div>;

  const handlePhotoFile=async(file)=>{ if(!file.type.startsWith("image/"))return; if(file.size>8*1024*1024)return alert("Max 8MB"); const c=await compressImage(file,400,.82); setNewPhoto(c); setPhotoPreview(c); };
  const applyPreset=(p)=>{setPbg(p.bg);setPhBg(p.hBg);setPhTx(p.hTx);setPtx(p.tx);setPlnk(p.link);setPbrd(p.border);setPbrs(p.bStyle);setPbrw(p.bWidth);setPtbg(p.tBg);setPfont(p.font);};
  const addBlink=()=>{if(blinkies.length<10&&newBlink.trim()){setBlinkies([...blinkies,newBlink.trim()]);setNewBlink("");}};

  const handleAudioUpload=async(file)=>{
    if(!file)return;
    const ext=file.name.split(".").pop().toLowerCase();
    if(!["mp3","ogg","wav","flac","m4a","aac","webm"].includes(ext))return alert("Supported formats: mp3, ogg, wav, flac, m4a, aac");
    if(file.size>20*1024*1024)return alert("Max 20MB per track");
    if(audioTracks.length>=10)return alert("Maximum 10 tracks");
    const title=audioTitle.trim()||file.name.replace(/\.[^.]+$/,"");
    setUploadingAudio(true);
    try{
      const path=`audio/${me.id}_${Date.now()}.${ext}`;
      const url=await uploadFile(file,path);
      setAudioTracks(prev=>[...prev,{id:String(Date.now()),title,url}]);
      setAudioTitle("");
    }catch(err){
      console.error("Audio upload error:",err);
      alert("Upload failed: "+(err.message||JSON.stringify(err)));
    }
    setUploadingAudio(false);
  };

  const handleBgImageUpload=async(file)=>{
    if(!file||!file.type.startsWith("image/"))return alert("Images only");
    if(file.size>8*1024*1024)return alert("Max 8MB");
    setUploadingBg(true);
    try{
      const ext=file.name.split('.').pop().toLowerCase();
      const path=`profile-bg/${me.id}_${Date.now()}.${ext}`;
      const url=await uploadFile(file,path);
      setBgImageUrl(url);
    }catch(err){alert("Upload failed: "+(err.message||String(err)));}
    setUploadingBg(false);
  };
  const handleBannerImageUpload=async(file)=>{
    if(!file||!file.type.startsWith("image/"))return alert("Images only");
    if(file.size>8*1024*1024)return alert("Max 8MB");
    setUploadingBanner(true);
    try{
      const ext=file.name.split('.').pop().toLowerCase();
      const path=`profile-banner/${me.id}_${Date.now()}.${ext}`;
      const url=await uploadFile(file,path);
      setBannerImageUrl(url);
    }catch(err){alert("Upload failed: "+(err.message||String(err)));}
    setUploadingBanner(false);
  };

  const handleSave=async()=>{
    setSaving(true);
    try{
      const tfArr=topFriends.split(",").map(x=>parseInt(x.trim())).filter(n=>!isNaN(n)&&n!==me.id);
      await onSave({bio,mood,song,interests:ints,status,headline,aboutTitle,whoIWantToMeet:wiwm,
        location,favoriteMovies:favMovies,favoriteMusic:favMusic,favoriteTVShow:favTV,favoriteQuote:favQuote,bgMusicUrl,
        blinkies,topFriends:tfArr,audioTracks,profileBg:pbg,profileHeaderBg:phBg,profileHeaderText:phTx,
        profileTextColor:ptx,profileLinkColor:plnk,profileBorderColor:pbrd,
        profileBorderStyle:pbrs,profileBorderWidth:pbrw,profileTableBg:ptbg,profileFont:pfont,
        profileBgImage:bgImageUrl||null,profileBannerImage:bannerImageUrl||null,
        removePhoto:!photoPreview&&!newPhoto&&!!me.photoKey},newPhoto);
    }catch(e){ console.error("handleSave error:",e); alert("Save error: "+e.message); }
    setSaving(false);
  };

  const previewH={background:phBg,color:phTx,padding:"8px 12px",border:`${pbrw} ${pbrs} ${pbrd}`,fontFamily:pfont,fontSize:"14px",fontWeight:"bold"};
  const previewB={background:ptbg,border:`${pbrw} ${pbrs} ${pbrd}`,borderTop:"none",padding:"8px",fontFamily:pfont,color:ptx,fontSize:"12px"};

  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; <a onClick={()=>nav("profile",{userId:me.id})}>My Profile</a> &raquo; Edit</div><br/>
      <div className="section-header">Edit Your Profile</div>
      <div style={{border:"1px solid #ccc",background:"#fafafa",padding:"12px"}}>
        {/* Preview */}
        <div style={{marginBottom:"12px"}}>
          <div style={{fontSize:"11px",color:"#666",fontWeight:"bold",marginBottom:"5px"}}>PREVIEW:</div>
          <div style={{background:pbg,padding:"10px",border:"1px solid #ccc"}}>
            <div style={previewH}>{me.username} — {headline||"your headline"}</div>
            <div style={previewB}><span>Sample text &nbsp;</span><a style={{color:plnk,fontFamily:pfont}}>sample link</a></div>
          </div>
        </div><hr/>

        {/* Quick themes */}
        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"5px"}}>Quick Themes:</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"4px"}}>{PROFILE_PRESETS.map(p=><button key={p.name} className="btn" style={{fontSize:"10px",background:p.bg,color:p.hTx,border:`1px solid ${p.border}`,padding:"2px 8px",fontFamily:p.font}} onClick={()=>applyPreset(p)}>{p.name}</button>)}</div>
        </div><hr/>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginBottom:"12px"}}>
          <div>
            {/* Photo */}
            <div className="form-row"><label className="form-label">Profile Photo:</label>
              <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
                <div style={{width:"60px",height:"60px",border:"1px solid #ccc",overflow:"hidden",flexShrink:0,background:"#eee",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"20px",color:"#999"}}>
                  {photoPreview?<img src={photoPreview} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:me.username[0].toUpperCase()}
                </div>
                <div><input ref={fileRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handlePhotoFile(e.target.files[0])}/>
                  <input type="submit" value="Upload" onClick={()=>fileRef.current?.click()} style={{display:"block",marginBottom:"3px"}}/>
                  {photoPreview&&<input type="submit" value="Remove" onClick={()=>{setNewPhoto(null);setPhotoPreview(null);}}/>}
                </div>
              </div>
            </div>
            <div className="form-row"><label className="form-label">Headline:</label><input type="text" value={headline} onChange={e=>setHeadline(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Mood:</label><input type="text" value={mood} onChange={e=>setMood(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Now Playing (text):</label><input type="text" value={song} onChange={e=>setSong(e.target.value)} style={{width:"100%"}} placeholder="Artist - Song"/></div>
            <div className="form-row"><label className="form-label">Background Music URL:</label><input type="text" value={bgMusicUrl} onChange={e=>setBgMusicUrl(e.target.value)} style={{width:"100%"}} placeholder="YouTube URL or direct .mp3 link"/><div style={{fontSize:"10px",color:"#999",marginTop:"2px"}}>YouTube or direct audio link (mp3/ogg/wav). Shows as player on your profile.</div></div>
            <div className="form-row"><label className="form-label">Status:</label><select value={status} onChange={e=>setStatus(e.target.value)}><option value="online">Online</option><option value="away">Away</option><option value="offline">Offline</option></select></div>
            <div className="form-row"><label className="form-label">Location:</label><input type="text" value={location} onChange={e=>setLocation(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Interests:</label><input type="text" value={ints} onChange={e=>setInts(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Favorite Movies:</label><input type="text" value={favMovies} onChange={e=>setFavMovies(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Favorite Music:</label><input type="text" value={favMusic} onChange={e=>setFavMusic(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Favorite TV Show:</label><input type="text" value={favTV} onChange={e=>setFavTV(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Favorite Quote:</label><input type="text" value={favQuote} onChange={e=>setFavQuote(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Who I want to meet:</label><input type="text" value={wiwm} onChange={e=>setWiwm(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">About Me box title:</label><input type="text" value={aboutTitle} onChange={e=>setAboutTitle(e.target.value)} style={{width:"100%"}}/></div>
            <div className="form-row"><label className="form-label">Top Friends (user IDs, comma separated):</label><input type="text" value={topFriends} onChange={e=>setTopFriends(e.target.value)} style={{width:"100%"}} placeholder="e.g. 2, 3"/></div>
          </div>
          <div><div className="form-row"><label className="form-label">About Me:</label><textarea value={bio} onChange={e=>setBio(e.target.value)} rows={12} style={{width:"100%"}} maxLength={800}/></div></div>
        </div><hr/>

        <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"8px"}}>PROFILE APPEARANCE:</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"8px",marginBottom:"10px"}}>
          {[["Page bg",pbg,setPbg],["Header bg",phBg,setPhBg],["Header text",phTx,setPhTx],["Body text",ptx,setPtx],["Links",plnk,setPlnk],["Border",pbrd,setPbrd]].map(([l,v,s])=>(
            <div key={l}><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>{l}</div>
              <div style={{display:"flex",gap:"4px",alignItems:"center"}}>
                <input type="color" value={v} onChange={e=>s(e.target.value)} style={{width:"28px",height:"22px",border:"1px solid #ccc",cursor:"pointer",padding:0}}/>
                <input type="text" value={v} onChange={e=>s(e.target.value)} style={{width:"70px",fontSize:"10px"}}/>
              </div>
            </div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"8px",marginBottom:"10px"}}>
          <div><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>Border style</div><select value={pbrs} onChange={e=>setPbrs(e.target.value)} style={{fontSize:"11px"}}>{["solid","dashed","dotted","double","groove","ridge","inset","outset"].map(s=><option key={s}>{s}</option>)}</select></div>
          <div><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>Border width</div><select value={pbrw} onChange={e=>setPbrw(e.target.value)} style={{fontSize:"11px"}}>{["1px","2px","3px","4px","5px"].map(s=><option key={s}>{s}</option>)}</select></div>
          <div><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>Table background</div><input type="text" value={ptbg} onChange={e=>setPtbg(e.target.value)} style={{width:"100%",fontSize:"11px"}} placeholder="#fff or rgba(...)"/></div>
        </div>
        <div style={{marginBottom:"10px"}}><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>Font</div>
          <select value={pfont} onChange={e=>setPfont(e.target.value)} style={{fontSize:"11px",width:"260px"}}>{FONT_OPTIONS.map(f=><option key={f} value={f} style={{fontFamily:f}}>{f.split(",")[0].replace(/['"]/g,"")}</option>)}</select>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginBottom:"10px"}}>
          {/* Background image */}
          <div>
            <div style={{fontSize:"10px",color:"#666",marginBottom:"4px",fontWeight:"bold"}}>🖼 Page Background Image</div>
            {bgImageUrl&&<div style={{marginBottom:"4px",position:"relative",display:"inline-block"}}>
              <img src={bgImageUrl} alt="bg preview" style={{width:"100%",maxWidth:"200px",height:"60px",objectFit:"cover",border:"1px solid #ccc",display:"block"}}/>
              <button onClick={()=>setBgImageUrl("")} style={{position:"absolute",top:"2px",right:"2px",background:"rgba(0,0,0,.6)",color:"#fff",border:"none",borderRadius:"2px",fontSize:"10px",cursor:"pointer",padding:"1px 5px"}}>✕</button>
            </div>}
            <div style={{display:"flex",gap:"6px",alignItems:"center",flexWrap:"wrap"}}>
              <input ref={bgImgRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleBgImageUpload(e.target.files[0])}/>
              <input type="submit" value={uploadingBg?"Uploading...":"Upload Image"} disabled={uploadingBg} onClick={()=>bgImgRef.current?.click()} style={{fontSize:"10px"}}/>
              <input type="text" value={bgImageUrl} onChange={e=>setBgImageUrl(e.target.value)} placeholder="…or paste image URL" style={{flex:1,fontSize:"10px",minWidth:"100px"}}/>
            </div>
            <div style={{fontSize:"9px",color:"#999",marginTop:"2px"}}>Covers the full profile background. Max 8MB.</div>
          </div>
          {/* Banner image */}
          <div>
            <div style={{fontSize:"10px",color:"#666",marginBottom:"4px",fontWeight:"bold"}}>🏞 Header Banner Image</div>
            {bannerImageUrl&&<div style={{marginBottom:"4px",position:"relative",display:"inline-block"}}>
              <img src={bannerImageUrl} alt="banner preview" style={{width:"100%",maxWidth:"200px",height:"60px",objectFit:"cover",objectPosition:"top",border:"1px solid #ccc",display:"block"}}/>
              <button onClick={()=>setBannerImageUrl("")} style={{position:"absolute",top:"2px",right:"2px",background:"rgba(0,0,0,.6)",color:"#fff",border:"none",borderRadius:"2px",fontSize:"10px",cursor:"pointer",padding:"1px 5px"}}>✕</button>
            </div>}
            <div style={{display:"flex",gap:"6px",alignItems:"center",flexWrap:"wrap"}}>
              <input ref={bannerImgRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleBannerImageUpload(e.target.files[0])}/>
              <input type="submit" value={uploadingBanner?"Uploading...":"Upload Image"} disabled={uploadingBanner} onClick={()=>bannerImgRef.current?.click()} style={{fontSize:"10px"}}/>
              <input type="text" value={bannerImageUrl} onChange={e=>setBannerImageUrl(e.target.value)} placeholder="…or paste image URL" style={{flex:1,fontSize:"10px",minWidth:"100px"}}/>
            </div>
            <div style={{fontSize:"9px",color:"#999",marginTop:"2px"}}>Replaces the header color bar. Username overlays at bottom. Max 8MB.</div>
          </div>
        </div><hr/>

        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"5px"}}>Blinkies ({blinkies.length}/10):</div>
          <div style={{marginBottom:"5px"}}>{blinkies.map((b,i)=><span key={i} className="blinkie" style={{cursor:"pointer"}} onClick={()=>setBlinkies(blinkies.filter((_,j)=>j!==i))} title="click to remove">{b} [x]</span>)}</div>
          <div style={{display:"flex",gap:"5px"}}><input type="text" value={newBlink} onChange={e=>setNewBlink(e.target.value)} placeholder="Add blinkie text..." style={{width:"200px"}} maxLength={30} onKeyDown={e=>e.key==="Enter"&&addBlink()}/><input type="submit" value="Add" onClick={addBlink}/></div>
        </div><hr/>

        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"5px"}}>🎵 My Music ({audioTracks.length}/10):</div>
          {audioTracks.length>0&&<div style={{marginBottom:"6px"}}>
            {audioTracks.map((t,i)=>(
              <div key={t.id} style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"3px",fontSize:"11px"}}>
                <span style={{flex:1}}>♪ {t.title}</span>
                <audio controls src={t.url} style={{height:"24px",width:"160px"}}/>
                <a style={{color:"#cc0000",cursor:"pointer",fontSize:"10px"}} onClick={()=>setAudioTracks(audioTracks.filter((_,j)=>j!==i))}>remove</a>
              </div>
            ))}
          </div>}
          {audioTracks.length<10&&<div style={{display:"flex",gap:"5px",alignItems:"center",flexWrap:"wrap"}}>
            <input type="text" value={audioTitle} onChange={e=>setAudioTitle(e.target.value)} placeholder="Track title (optional)" style={{width:"180px",fontSize:"11px"}}/>
            <input ref={audioFileRef} type="file" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleAudioUpload(e.target.files[0])}/>
            <input type="submit" value={uploadingAudio?"Uploading...":"+ Upload Track"} disabled={uploadingAudio} onClick={()=>audioFileRef.current?.click()} style={{fontSize:"11px"}}/>
            <span style={{fontSize:"10px",color:"#999"}}>mp3, ogg, wav — max 20MB</span>
          </div>}
        </div><hr/>

        <input type="submit" value={saving?"Saving...":"Save Profile"} disabled={saving} onClick={handleSave} style={{fontSize:"13px",padding:"4px 16px"}}/>
      </div>
    </div>
  );
}

// ─── ADMIN PANEL ─────────────────────────────────────────────────────────────
function AdminView({nav,boards,users,boardMods,getBoardModUsers,onAssignMod,onRemoveMod,isAdmin}){
  const [selected,setSelected]=useState({});
  if(!isAdmin)return<div className="content" style={{color:"#cc0000"}}>Access denied.</div>;
  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("home")}>Home</a> &raquo; Admin Panel</div><br/>
      <div className="section-header">★ Administrator Panel — Board Moderators</div>
      <div style={{border:"1px solid #ccc",padding:"8px",background:"#fafafa",marginBottom:"10px",fontSize:"11px",color:"#666"}}>
        Assign moderators to boards. Mods can customize their board's look, set rules and announcements, lock threads, and delete posts.
      </div>
      <table className="board-table"><thead><tr><th>Board</th><th>Current Moderators</th><th style={{width:"240px"}}>Add Moderator</th></tr></thead>
      <tbody>{boards.map(b=>{
        const mods=getBoardModUsers(b.id);
        const modIds=new Set((boardMods[b.id]||[]));
        const eligible=users.filter(u=>!modIds.has(u.id)).sort((a,c)=>a.username.localeCompare(c.username));
        const sel=selected[b.id]||"";
        return(<tr key={b.id}>
          <td><strong>{b.name}</strong><br/><span className="board-desc">{b.desc}</span></td>
          <td>
            {mods.length===0&&<span style={{color:"#bbb",fontSize:"11px"}}>None</span>}
            {mods.map(m=><div key={m.id} style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"3px"}}>
              <a onClick={()=>nav("profile",{userId:m.id})} style={{fontSize:"12px"}}>{m.username}</a>
              <input type="submit" value="✕ Remove" style={{fontSize:"9px",padding:"1px 5px",background:"#ffeeee",color:"#cc0000",border:"1px solid #ffcccc"}} onClick={()=>onRemoveMod(b.id,m.id)}/>
            </div>)}
          </td>
          <td>
            <div style={{display:"flex",gap:"4px",alignItems:"center"}}>
              <select value={sel} onChange={e=>{const v=e.target.value;setSelected(prev=>({...prev,[b.id]:v}));}} style={{flex:1,fontSize:"11px"}}>
                <option value="">— pick a user —</option>
                {eligible.map(u=><option key={u.id} value={u.username}>{u.username}</option>)}
              </select>
              <input type="submit" value="Assign" disabled={!sel} style={{fontSize:"10px"}}
                onClick={()=>{ if(sel){ onAssignMod(b.id,sel); setSelected(prev=>({...prev,[b.id]:""})); }}}/>
            </div>
          </td>
        </tr>);
      })}</tbody></table>
    </div>
  );
}

// ─── MOD PANEL ────────────────────────────────────────────────────────────────
const MOD_PRESETS=[
  {name:"Default",       bg:"#ffffff",hBg:"#336699",hTx:"#ffffff",tx:"#000000",link:"#0000cc",border:"#cccccc",row:"#f9f9f9",alt:"#eef2f7",font:"Verdana, Arial, sans-serif"},
  {name:"Dark / Emo",    bg:"#111111",hBg:"#330033",hTx:"#ff00ff",tx:"#ddaadd",link:"#cc00cc",border:"#660066",row:"#1a001a",alt:"#220022",font:"'Courier New', monospace"},
  {name:"Hacker",        bg:"#0a0a0a",hBg:"#001a00",hTx:"#00ff00",tx:"#00cc00",link:"#00ff66",border:"#005500",row:"#050f05",alt:"#0a150a",font:"'Courier New', monospace"},
  {name:"Y2K Pink",      bg:"#ffe6ff",hBg:"#ff66cc",hTx:"#ffffff",tx:"#660044",link:"#cc0088",border:"#ff99cc",row:"#fff0ff",alt:"#ffe0ff",font:"'Comic Sans MS', cursive"},
  {name:"Deep Ocean",    bg:"#001122",hBg:"#003366",hTx:"#aaddff",tx:"#88ccee",link:"#66aaff",border:"#004477",row:"#001833",alt:"#002244",font:"Verdana, sans-serif"},
  {name:"Old Parchment", bg:"#f5f0e0",hBg:"#8b7355",hTx:"#ffffff",tx:"#3b2a1a",link:"#663300",border:"#c8b89a",row:"#f0ead8",alt:"#e8e0cc",font:"'Times New Roman', serif"},
  {name:"Blood Red",     bg:"#1a0000",hBg:"#550000",hTx:"#ffaaaa",tx:"#ffcccc",link:"#ff6666",border:"#880000",row:"#220000",alt:"#2a0000",font:"Verdana, sans-serif"},
  {name:"Vaporwave",     bg:"#1a0033",hBg:"#6600cc",hTx:"#ffffff",tx:"#ff99ff",link:"#ff00ff",border:"#aa00ff",row:"#220044",alt:"#2a0055",font:"'Courier New', monospace"},
];

function ModPanelView({nav,boards,boardId,me,getBoardStyle,isMod,isAdmin,onSaveStyle}){
  const b=boards.find(x=>x.id===boardId);
  const cur=getBoardStyle(boardId);
  const [bg,setBg]=useState(cur.bg);const [hBg,setHBg]=useState(cur.headerBg);const [hTx,setHTx]=useState(cur.headerText);
  const [tx,setTx]=useState(cur.textColor);const [link,setLink]=useState(cur.linkColor);const [brd,setBrd]=useState(cur.borderColor);
  const [row,setRow]=useState(cur.tableRowBg);const [alt,setAlt]=useState(cur.tableRowAlt);
  const [font,setFont]=useState(cur.font);const [banner,setBanner]=useState(cur.banner||"");const [rules,setRules]=useState(cur.rules||"");
  const [saving,setSaving]=useState(false);
  if(!me||(!isMod(boardId,me.id)&&!isAdmin))return<div className="content" style={{color:"#cc0000"}}>Access denied.</div>;
  const apply=(p)=>{setBg(p.bg);setHBg(p.hBg);setHTx(p.hTx);setTx(p.tx);setLink(p.link);setBrd(p.border);setRow(p.row);setAlt(p.alt);setFont(p.font);};
  const save=async()=>{setSaving(true);try{await onSaveStyle(boardId,{bg,headerBg:hBg,headerText:hTx,textColor:tx,linkColor:link,borderColor:brd,tableRowBg:row,tableRowAlt:alt,font,banner,rules});nav("board",{boardId});}catch(e){/* error shown via msg() */}finally{setSaving(false);};};
  return(
    <div className="content">
      <div className="breadcrumb"><a onClick={()=>nav("board",{boardId})}>{b?.name}</a> &raquo; Mod Panel</div><br/>
      <div className="section-header">Mod Panel — {b?.name}</div>
      <div style={{border:"1px solid #ccc",padding:"10px",background:"#fafafa",marginBottom:"10px"}}>
        {/* Preview */}
        <div style={{marginBottom:"12px"}}>
          <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"5px"}}>LIVE PREVIEW:</div>
          <div style={{border:"1px solid #ccc"}}>
            <div style={{background:hBg,color:hTx,padding:"6px 10px",fontFamily:font,fontSize:"12px",fontWeight:"bold"}}>{b?.name} — preview</div>
            {banner&&<div style={{background:hBg,color:hTx,padding:"4px 10px",fontFamily:font,fontSize:"11px",borderTop:`1px solid ${brd}`}}>{banner}</div>}
            <div style={{background:bg,padding:"6px",fontFamily:font}}>
              <div style={{background:row,border:`1px solid ${brd}`,padding:"4px 8px",marginBottom:"2px",fontSize:"11px",color:tx}}>Sample thread — <a style={{color:link}}>click here</a></div>
              <div style={{background:alt,border:`1px solid ${brd}`,padding:"4px 8px",fontSize:"11px",color:tx}}>Another thread — <span style={{opacity:.6,fontSize:"10px"}}>2h ago</span></div>
            </div>
          </div>
        </div><hr/>
        <div style={{marginBottom:"10px"}}>
          <div style={{fontSize:"11px",fontWeight:"bold",color:"#666",marginBottom:"5px"}}>Quick Themes:</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"4px"}}>{MOD_PRESETS.map(p=><button key={p.name} className="btn" style={{fontSize:"10px",background:p.bg,color:p.hTx,border:`1px solid ${p.border}`,padding:"2px 8px",fontFamily:p.font}} onClick={()=>apply(p)}>{p.name}</button>)}</div>
        </div><hr/>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"8px",marginBottom:"10px"}}>
          {[["Page bg",bg,setBg],["Header bg",hBg,setHBg],["Header text",hTx,setHTx],["Body text",tx,setTx],["Links",link,setLink],["Border",brd,setBrd],["Row 1",row,setRow],["Row 2",alt,setAlt]].map(([l,v,s])=>(
            <div key={l}><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>{l}</div>
              <div style={{display:"flex",gap:"3px",alignItems:"center"}}>
                <input type="color" value={v} onChange={e=>s(e.target.value)} style={{width:"26px",height:"20px",border:"1px solid #ccc",cursor:"pointer",padding:0}}/>
                <input type="text" value={v} onChange={e=>s(e.target.value)} style={{width:"62px",fontSize:"10px"}}/>
              </div>
            </div>
          ))}
        </div>
        <div style={{marginBottom:"10px"}}><div style={{fontSize:"10px",color:"#666",marginBottom:"2px"}}>Font</div>
          <select value={font} onChange={e=>setFont(e.target.value)} style={{fontSize:"11px",width:"240px"}}>{FONT_OPTIONS.map(f=><option key={f} value={f} style={{fontFamily:f}}>{f.split(",")[0].replace(/['"]/g,"")}</option>)}</select>
        </div><hr/>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px",marginBottom:"10px"}}>
          <div><label className="form-label">Banner / Announcement:</label><textarea value={banner} onChange={e=>setBanner(e.target.value)} rows={3} style={{width:"100%",fontSize:"11px"}} placeholder="Shows at top of board. Leave blank for none."/></div>
          <div><label className="form-label">Board Rules:</label><textarea value={rules} onChange={e=>setRules(e.target.value)} rows={3} style={{width:"100%",fontSize:"11px"}} placeholder="1. No spam&#10;2. Stay on topic"/></div>
        </div><hr/>
        <input type="submit" value={saving?"Saving...":"Save Board Style"} disabled={saving} onClick={save} style={{fontSize:"12px",padding:"3px 14px"}}/>
        &nbsp;&nbsp;<a onClick={()=>nav("board",{boardId})}>Cancel</a>
      </div>
    </div>
  );
}

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────
function AvatarBox({user,name,loadMedia,size=60,onClick,clickable}){
  const [photo,setPhoto]=useState(null);
  useEffect(()=>{ if(user?.photoKey){ if(user.photoKey.startsWith("http")) setPhoto(user.photoKey); else loadMedia(user.photoKey).then(d=>d&&setPhoto(d)); } },[user?.photoKey]);
  return(
    <div className="avatar-box" style={{width:size,height:size,cursor:clickable?"pointer":"default"}} onClick={onClick}>
      {photo?<img src={photo} alt={name}/>:(name||"?")[0].toUpperCase()}
    </div>
  );
}

function MediaDisplay({media,loadMedia}){
  const [src,setSrc]=useState(null);
  useEffect(()=>{ if(media?.key){ if(media.key.startsWith("http")) setSrc(media.key); else loadMedia(media.key).then(d=>d&&setSrc(d)); } },[media?.key]);
  if(!media||!src)return null;
  if(media.type==="image")return<div style={{marginTop:"8px"}}><img src={src} alt="attachment" style={{maxWidth:"100%",maxHeight:"400px",border:"1px solid #ccc",display:"block"}}/></div>;
  return<div style={{marginTop:"8px",border:"1px solid #ccc",padding:"6px",background:"#f9f9f9"}}><div style={{fontSize:"10px",color:"#666",marginBottom:"3px"}}>{media.type==="voice"?"Voice memo:":"Audio:"}</div><audio controls src={src}/></div>;
}

function MediaComposer({onMedia}){
  const [tab,setTab]=useState("file");const [has,setHas]=useState(false);
  const h=(m)=>{setHas(!!m);onMedia(m);};
  return(
    <div style={{border:"1px solid #ccc",padding:"6px",background:"#f0f0f0",fontSize:"11px"}}>
      <span style={{color:"#666"}}>Attach: </span>
      <button className="btn" style={{fontSize:"10px",background:tab==="file"?"#c0d8f0":"",marginRight:"3px"}} onClick={()=>setTab("file")}>File / Image</button>
      <button className="btn" style={{fontSize:"10px",background:tab==="voice"?"#c0d8f0":""}} onClick={()=>setTab("voice")}>Voice Memo</button>
      {has&&<span style={{color:"#006600",marginLeft:"8px"}}>✓ attached</span>}
      <div style={{marginTop:"6px"}}>
        {tab==="file"&&<FileUploader onMedia={h} onClear={()=>h(null)}/>}
        {tab==="voice"&&<VoiceRecorder onRecording={m=>h(m||null)}/>}
      </div>
    </div>
  );
}

function FileUploader({onMedia,onClear}){
  const [preview,setPreview]=useState(null);const [type,setType]=useState(null);
  const [fname,setFname]=useState(null);const [busy,setBusy]=useState(false);const [err,setErr]=useState(null);
  const ref=useRef();
  const handle=async(file)=>{
    setErr(null);setBusy(true);
    try{
      const isImg=file.type.startsWith("image/"),isAud=file.type.startsWith("audio/");
      if(!isImg&&!isAud){setErr("Images and audio only.");setBusy(false);return;}
      if(file.size>8*1024*1024){setErr("Max 8MB.");setBusy(false);return;}
      if(isImg){const data=await compressImage(file,700,.8);setType("image");setPreview(data);onMedia({type:"image",data});}
      else{const data=await readAsDataURL(file);setType("audio");setFname(file.name);onMedia({type:"audio",data});}
    }catch(e){setErr("Failed.");}
    setBusy(false);
  };
  const clear=()=>{setPreview(null);setType(null);setFname(null);setErr(null);onClear();};
  return(
    <div>
      {!type&&<div className="media-drop" onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();const f=e.dataTransfer.files[0];if(f)handle(f);}} onClick={()=>ref.current?.click()}>
        <input ref={ref} type="file" accept="image/*,audio/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handle(e.target.files[0])}/>
        {busy?"Processing...":"Click or drag a file here (images or audio, max 8MB)"}
      </div>}
      {err&&<div style={{color:"#cc0000",fontSize:"11px",marginTop:"3px"}}>{err}</div>}
      {type==="image"&&preview&&<div style={{marginTop:"4px",position:"relative",display:"inline-block"}}><img src={preview} alt="preview" style={{maxWidth:"200px",maxHeight:"150px",border:"1px solid #ccc",display:"block"}}/><button className="btn" style={{fontSize:"9px",position:"absolute",top:"2px",right:"2px"}} onClick={clear}>[remove]</button></div>}
      {type==="audio"&&<div style={{display:"flex",alignItems:"center",gap:"6px",marginTop:"4px",fontSize:"11px"}}><span>🎵 {fname}</span><button className="btn" style={{fontSize:"9px"}} onClick={clear}>[remove]</button></div>}
    </div>
  );
}

function VoiceRecorder({onRecording}){
  const [state,setState]=useState("idle");const [dur,setDur]=useState(0);
  const [url,setUrl]=useState(null);const [err,setErr]=useState(null);
  const rec=useRef(null);const chunks=useRef([]);const timer=useRef(null);
  const start=async()=>{
    setErr(null);
    try{
      const stream=await navigator.mediaDevices.getUserMedia({audio:true});
      const mime=MediaRecorder.isTypeSupported("audio/webm")?"audio/webm":"audio/ogg";
      const r=new MediaRecorder(stream,{mimeType:mime});
      rec.current=r;chunks.current=[];
      r.ondataavailable=e=>chunks.current.push(e.data);
      r.onstop=async()=>{
        const blob=new Blob(chunks.current,{type:mime});
        setUrl(URL.createObjectURL(blob));setState("done");
        const data=await readAsDataURL(blob);onRecording({type:"voice",data});
        stream.getTracks().forEach(t=>t.stop());
      };
      r.start(200);setState("recording");setDur(0);
      timer.current=setInterval(()=>setDur(d=>d+1),1000);
    }catch(e){setErr("Microphone access denied.");}
  };
  const stop=()=>{rec.current?.stop();clearInterval(timer.current);};
  const clear=()=>{setState("idle");setUrl(null);setDur(0);onRecording(null);};
  return(
    <div style={{display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap",fontSize:"11px"}}>
      {state==="idle"&&<><button className="rec-btn" onClick={start}>●</button><span style={{color:"#666"}}>Click to record a voice memo</span></>}
      {state==="recording"&&<><button className="rec-btn on" onClick={stop}>■</button><span style={{color:"#cc0000",animation:"recblink 1s infinite"}}>● {fmtDur(dur)}</span></>}
      {state==="done"&&url&&<><audio controls src={url} style={{height:"28px",flex:1,minWidth:"140px"}}/><button className="btn" style={{fontSize:"10px"}} onClick={clear}>[redo]</button></>}
      {err&&<span style={{color:"#cc0000"}}>{err}</span>}
    </div>
  );
}
